/* ============================================================
   FATHERS DAY QUIZ  -  FramedFantasy Father's Day 2026
   Quiz engine for sections/fathers-day-quiz.liquid.

   Built per FramedFantasy_FathersDay_Quiz_Spec_v4.md (Set 2,
   Fantasy World Broad), extended to five questions with a
   morphing question image.

   Flow. Intro, five questions, then one continuous ending screen.
   Each answer she picks sets the hero image shown on the next
   question's page. The ending screen carries the eight archetype
   personality reveal, the proof gallery, and the SMS opt in form.
   On a successful submit the form area swaps in place to the
   confirmation and the shareable card. Plain JavaScript.

   Q1 hobby and Q2 character knowledge inform Jan's first text.
   Q3 is the timing question. Q4 vibe and Q5 personality score
   the eight archetypes.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('ffg-root');
  if (!root) return;

  /* ---------- Gift link card-view mode ----------
     The same #ffg-root host serves two pages. The builder (gift-quiz.liquid) carries
     data-gift-quiz and runs the quiz. The card page (gift-card-view.liquid) carries
     data-card-view and renders a SAVED card from the Worker, with no quiz. IS_CARD_VIEW
     is the single switch. On the builder it is false, so nothing below changes the
     existing buyer flow. CARD_BASE is the gift-cards Worker origin. */
  var IS_CARD_VIEW = !!(root.getAttribute && root.getAttribute('data-card-view') !== null);
  /* The gift-cards Worker origin and the card-open page path. Single constants so a
     host or handle change is one edit. The card page passes its own base via
     data-card-base; the builder uses GIFT_WORKER. CARD_PAGE_PATH is /pages/your-gift. */
  var GIFT_WORKER = 'https://gift-cards.fondlyframed.workers.dev';
  var CARD_PAGE_PATH = '/pages/your-gift';
  var CARD_BASE = (root.getAttribute && root.getAttribute('data-card-base')) || GIFT_WORKER;
  /* The reveal overlay is shared. 'preview' is the buyer previewing their own card
     (the existing behavior, links to /gift). 'recipient' is the paid link, where the
     claim panel reveals the real code. Default keeps the buyer behavior untouched. */
  var PRESENT_MODE = 'preview';

  /* ---------- Config ---------- */
  var CONFIG = { images: {}, questionImages: {}, introThumbs: [], trust: {}, galleryUrls: '', klaviyo: {} };
  var CONFIG_OK = false;
  try {
    var cfgEl = document.getElementById('ffg-config');
    if (cfgEl) { CONFIG = JSON.parse(cfgEl.textContent); CONFIG_OK = true; }
  } catch (e) { /* keep defaults, CONFIG_OK stays false */ }
  var IMG = CONFIG.images || {};
  var Q_IMAGES = CONFIG.questionImages || {};
  var Q_VIDEOS = CONFIG.questionVideos || {};
  var TRUST = CONFIG.trust || {};
  var PRODUCT_URL = CONFIG.productUrl || '/products/fathers-day-portrait-from-photo';
  var INTRO_PROOF = CONFIG.introProof || 'I am Jan. My team and I have painted over 1,000 of these by hand since 2022. More than 500 five star reviews.';
  var FD_CUTOFF = CONFIG.fathersDayCutoff || '2026-06-07';

  /* The proof gallery photos. These 15 are the built in safety net.
     The merchant's own photo list from the theme editor wins whenever
     they have one. Keeping a hardcoded default means the band never
     goes empty even if the config fails to load. */
  var GALLERY_DEFAULT = [
    'https://framedfantasy.com/cdn/shop/files/482512971_2017248132085394_2108276693120287940_n_1.jpg?v=1763790701&width=600',
    'https://framedfantasy.com/cdn/shop/files/ff_sample_2.png?v=1764921019&width=600',
    'https://framedfantasy.com/cdn/shop/files/processed-D1CE8CDD-77FD-457D-9DE9-6D5F757F1D00.jpg?v=1763790384&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7880789626_n2v32vv3.jpg?v=1775463989&width=600',
    'https://framedfantasy.com/cdn/shop/files/ff_sample_3_fb789b48-6b11-4b51-b29d-6fb1ff4603e5.png?v=1764921004&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7815610927_9eailaeq_43488e9b-e739-48a1-b4b5-17fd75a5c8c4.webp?v=1772598257&width=600',
    'https://framedfantasy.com/cdn/shop/files/ig_38136768-75e6-474e-a6fb-ac4f880c06f1.png?v=1763980842&width=600',
    'https://framedfantasy.com/cdn/shop/files/processed-5EFE38F2-53F5-4088-8EFC-1DA596ADCE5F.jpg?v=1763790358&width=600',
    'https://framedfantasy.com/cdn/shop/files/image0.jpg?v=1763789346&width=600',
    'https://framedfantasy.com/cdn/shop/files/GwdD7jy5P_mid_8e8b005c-587c-4fce-9d1a-9133e99f8d2e.jpg?v=1772598254&width=600',
    'https://framedfantasy.com/cdn/shop/files/IMG_4824.jpg?v=1763790297&width=600',
    'https://framedfantasy.com/cdn/shop/files/3image0_1.jpg?v=1763790310&width=600',
    'https://framedfantasy.com/cdn/shop/files/iap_640x640.7395387079_ftfz826a_upscayl_2x_upscayl-standard-4x.png?v=1763790397&width=600',
    'https://framedfantasy.com/cdn/shop/files/FondlyFramed_Review_Image_2.png?v=1763790327&width=600',
    'https://framedfantasy.com/cdn/shop/files/20251030_101824_1.jpg?v=1763790504&width=600'
  ];
  /* Split the merchant's gallery URL list, one URL per line, into a
     clean array. Blank lines, stray whitespace, and any line that is
     not a URL are dropped. */
  function parseGalleryUrls(str) {
    var out = [];
    if (!str || typeof str.split !== 'function') return out;
    var lines = str.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var u = lines[i].replace(/^\s+|\s+$/g, '');
      if (u && /^(https?:)?\/\//.test(u)) out.push(u);
    }
    return out;
  }
  /* The live gallery. The merchant's photo list from the theme editor
     when they have one, the built in default otherwise. Recomputed on
     every editor reload so edits to the list update the band live. */
  function computeGallery() {
    var list = parseGalleryUrls(CONFIG.galleryUrls);
    return list.length ? list : GALLERY_DEFAULT;
  }
  var GALLERY = computeGallery();
  var KL = CONFIG.klaviyo || {};
  var KL_COMPANY = KL.companyId || 'UeMxA4';
  var KL_LIST = KL.listId || 'W8Unvq';
  var KL_REVISION = KL.revision || '2025-10-15';

  /* v36 portrait sizes shown on the reveal as a product-style picker. The
     section settings fill these in (label, descriptor, price, and the
     Shopify variant id Jan pastes). Built-in defaults mirror the D&D
     portrait sizes so the picker works before anything is configured; a
     size with no variantId falls back to the gift product at checkout. */
  /* v38.9 the defaults carry the REAL FramedFantasy gift card variant ids (verified
     live: $99=51803991146813, $139=51803991179581, $199=51803991212349, all in stock).
     So the buy checks out the correct gift card variant even if the section config
     fails to parse (e.g. a Liquid error in another setting) and SIZES falls back here.
     The section settings still override these when the config loads. */
  var DEFAULT_SIZES = [
    { key: 'half',  name: 'Half body', desc: 'face and upper body',    price: '$99',  variantId: '51803991146813', image: '', qty: 22, popular: false },
    { key: 'thigh', name: 'Thigh up',  desc: 'full outfit and stance', price: '$139', variantId: '51803991179581', image: '', qty: 14, popular: true },
    { key: 'full',  name: 'Full body', desc: 'the whole character',    price: '$199', variantId: '51803991212349', image: '', qty: 7,  popular: false }
  ];
  var SIZES = (CONFIG.sizes && CONFIG.sizes.length) ? CONFIG.sizes : DEFAULT_SIZES;
  /* v36.8 the review carousel. A scrolling loop of customer review photos, each
     linking to its Loox review. Editor: review{1..15}_img + _link, plus a
     fallback link. Until Jan adds her own, these placeholders (real customer
     photos) loop, all pointing at the fallback review link she gave. */
  var REVIEW_FALLBACK_LINK = 'https://framedfantasy.com/pages/fathers-day-quiz#qvMP5deEXUB-H';
  var REVIEW_PLACEHOLDERS = [
    'https://framedfantasy.com/cdn/shop/files/20251030_101824_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/3image0_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/482512971_2017248132085394_2108276693120287940_n_1.jpg',
    'https://framedfantasy.com/cdn/shop/files/IMG_4824.jpg',
    'https://framedfantasy.com/cdn/shop/files/processed-5EFE38F2-53F5-4088-8EFC-1DA596ADCE5F.jpg',
    'https://framedfantasy.com/cdn/shop/files/processed-D1CE8CDD-77FD-457D-9DE9-6D5F757F1D00.jpg',
    'https://framedfantasy.com/cdn/shop/files/image0.jpg',
    'https://framedfantasy.com/cdn/shop/files/ig_38136768-75e6-474e-a6fb-ac4f880c06f1.png'
  ];
  /* The review list shown in the carousel. Reads the editor (CONFIG.reviews:
     [{img, link}]), drops slots with no image, and falls back to each review's
     own link, then the editor fallback link, then the built-in one. With nothing
     set it returns the placeholder photos (all using the fallback link). */
  function reviewsList() {
    var cfg = (CONFIG && CONFIG.reviews) || [];
    var fallback = (CONFIG && CONFIG.reviewsLinkFallback) || REVIEW_FALLBACK_LINK;
    var out = [];
    for (var i = 0; i < cfg.length; i++) {
      if (cfg[i] && cfg[i].img) out.push({ img: cfg[i].img, link: cfg[i].link || fallback });
    }
    if (out.length) return out;
    return REVIEW_PLACEHOLDERS.map(function (src) { return { img: src, link: fallback }; });
  }

  var TEST_NAME = 'jangela';
  /* v10 bump: v7 cut character_knowledge entirely and moved timing
     from Q10 to Q3. state.answers shrank from 10 to 9. Old v9 saves
     are silently discarded on next load. */
  var STORE_KEY = 'ffg_progress_v1';
  var AUDIO_MUTE_KEY = 'ffg_audio_muted_v1';

  /* ---------- Background music ----------
     One looping track (Quiet Alehouse Loop). Browsers block autoplay
     until the page has had a user gesture, so the first intro CTA tap
     is what unlocks it. The unlock pattern (create Audio muted, fire
     a no-op play, then unmute) mirrors the character quest engine, and
     it is what lets the subsequent playBGM call actually produce
     sound on iOS Safari and modern Chrome. A small mute toggle lives
     in the top bar; the choice is persisted to localStorage so the
     visitor's preference survives a refresh. */
  var BGM_URL = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Quiet_Alehouse_Loop.mp3?v=1775559877';
  var audioMgr = {
    audio: null,
    unlocked: false,
    /* Once we've ever started the BGM in this page session it must
       NEVER be started again — retake, second CTA click, page mid-
       session navigation. Two latches catch this:
         1. started — flips to true on the first successful play() and
            never resets, so playBGM is permanently no-op after that.
         2. !audio.paused — even if started somehow lied, the live
            audio state is the second line of defense.
       The user reported hearing two desynced loops after Retake; this
       structure makes that impossible. */
    started: false,
    muted: false,
    vol: 0.4,
    isMuted: function () {
      try { return localStorage.getItem(AUDIO_MUTE_KEY) === '1'; }
      catch (e) { return false; }
    },
    setMuted: function (m) {
      this.muted = !!m;
      try { localStorage.setItem(AUDIO_MUTE_KEY, m ? '1' : '0'); } catch (e) {}
      if (this.audio) {
        try { this.audio.muted = !!m; } catch (e) {}
      }
    },
    unlock: function () {
      if (this.unlocked) return;
      this.unlocked = true;
      try {
        var a = new Audio(BGM_URL);
        a.preload = 'auto';
        a.loop = true;
        a.muted = true;
        var p = a.play();
        if (p && p.catch) p.catch(function () {});
        a.pause();
        try { a.currentTime = 0; } catch (e) {}
        a.muted = false;
        this.audio = a;
      } catch (e) { /* swallow, silent quiz is still a working quiz */ }
    },
    playBGM: function () {
      /* Hard guard 1: ever-started latch. */
      if (this.started) return;
      /* Hard guard 2: live audio state. If somehow the latch was reset
         but the audio is already running, bail before play()ing again. */
      if (this.audio && !this.audio.paused) { this.started = true; return; }
      var self = this;
      this.muted = this.isMuted();
      if (!this.audio) {
        try {
          this.audio = new Audio(BGM_URL);
          this.audio.preload = 'auto';
          this.audio.loop = true;
        } catch (e) { return; }
      }
      /* Flip the latch BEFORE play() so any synchronous re-entry from
         a duplicate click or hot path lands in the guard above. */
      this.started = true;
      try {
        this.audio.loop = true;
        this.audio.muted = this.muted;
        this.audio.volume = 0;
        var pp = this.audio.play();
        if (pp && pp.catch) pp.catch(function () {});
        /* Soft fade in so the track does not slam in. */
        var v = 0;
        var iv = setInterval(function () {
          v += 0.04;
          if (v >= self.vol) {
            try { self.audio.volume = self.vol; } catch (e) {}
            clearInterval(iv);
          } else {
            try { self.audio.volume = v; } catch (e) {}
          }
        }, 60);
      } catch (e) {}
    }
  };

  /* Timing constants. Named so the jsdom harness can speed them up. */
  var T_FADE = 190;     /* screen transition */
  var T_CONFIRM = 250;  /* answer confirm beat before advancing */
  var T_BEAT = 1900;    /* reveal reading beat */
  var T_BREATH = 5000;  /* breath screen auto advance, additive on top of T_FADE */

  /* Breath screens. Two transitional content moments between questions.
     Reframe sits between Q2 and Q3. Heirloom sits between Q4 and Q5.
     Each is shown at most once per session, and back navigation from
     the next question skips them. Everything below is overridable from
     the theme editor via the breath block in the Liquid config. */
  /* v24: one pause now, the hinge. It fires between his_character (Q2)
     and the_notice (Q3) and does the heavy lifting of the whole funnel.
     It installs three beliefs at once without naming any of them: that
     this is easy, that it is barely any work, and that it is for his
     own character. The earlier intro / reframe / heirloom pauses were
     removed with the question restructure. */
  var BREATH_DEFAULTS = {
    hinge: {
      label: 'THE EASY PART',
      headline: 'You do not have to know their character.',
      subline: 'They bring it to life themselves.',
      prompt: 'continue',
      image: { full: '' },
      video: { src: '', sources: [] }
    }
  };
  var BREATH = mergeBreathConfig(CONFIG.breath);
  function mergeBreathConfig(src) {
    src = src || {};
    var out = {};
    var keys = ['hinge'];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var d = BREATH_DEFAULTS[k];
      var s = src[k] || {};
      out[k] = {
        label: s.label || d.label,
        headline: s.headline || d.headline,
        subline: s.subline || d.subline,
        prompt: s.prompt || d.prompt,
        image: s.image || d.image,
        video: s.video || d.video
      };
    }
    return out;
  }

  /* ---------- Static copy ---------- */
  var TCPA_TEXT = 'By saving your spot you agree to receive text messages from Jan at FramedFantasy at the number provided, including messages sent by autodialer. Consent is not a condition of any purchase. Message and data rates may apply. Message frequency varies. Reply STOP to opt out or HELP for help.';
  var CHECK_SVG = '<svg viewBox="0 0 20 20" fill="none"><path d="M4 10.5l4 4 8-9" stroke="#241b06" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- Headlines, A/B ----------
     Variant A carries an italic gold accent word (modeled on the
     character quest hookEm treatment). The shape is { lead, em, tail }
     so the renderer can wrap the accent in a span. Variant B stays as
     a plain string fallback. headlineHTML below handles either form. */
  /* v22 headline. The quiz is now a gift finder, not a personality
     test. The gold accent lands on the opening word "Finally" so the
     promise (a gift that finally lands) reads from the first glance. The
     em can sit at the head of the line, so the render helper omits the
     lead and the space before a tail that starts with punctuation. */
  var HEADLINES = {
    A: { lead: '', em: 'Finally', tail: ', a gift that proves you get them.' }
  };
  /* Variant B previously held an alternate copy for an A/B test. The
     test was retired in favor of variant A; B now aliases A so any
     visitor whose localStorage saved 'B' still renders the new copy
     instead of falling back to a stale string. */
  HEADLINES.B = HEADLINES.A;
  function headlineHTML(h) {
    if (typeof h === 'string') return esc(h);
    var lead = h.lead ? esc(h.lead) + ' ' : '';
    var em = '<span class="ffg-em">' + esc(h.em) + '</span>';
    /* No space between the gold word and a tail that opens with
       punctuation, so "Finally" + ", a gift…" reads as one clean line. */
    var gap = /^[\s,.;:!?]/.test(h.tail || '') ? '' : ' ';
    var tail = h.tail ? gap + esc(h.tail) : '';
    return lead + em + tail;
  }
  /* HTML (rendered without esc, trusted constant) so "personalized" can be bold. */
  var SUBHEAD = 'Answer a few questions about them, and watch a <strong>personalized</strong> gift come together in two minutes.';
  /* Eyebrow label above the headline. Editor-overridable via config. */
  var EYEBROW_LABEL = (CONFIG.eyebrowLabel || 'A GIFT THEY WILL NEVER FORGET');
  /* Small note under the primary CTA. */
  var CTA_NOTE = 'Takes two minutes.';
  /* Final proof line below the photo strip. */
  /* HTML (rendered without esc): "Yours is next." gets a subtle gold highlight. */
  var FINAL_PROOF = 'Over 1,000 already gave the gift they never forgot. <span class="ffg-intro__proof-hl">Yours is next.</span>';
  /* Small prelude above the bottom CTA. */
  var BOTTOM_CTA_PRELUDE = 'Let\'s make their gift.';

  /* ---------- Archetypes ---------- */
  /* Final tiebreak priority order. This is the LAST fallback after
     moral_signature → personality → hobby_vibe all also tie. Sorted
     so the archetypes with the FEWEST total points available across
     the quiz come first, which means ties resolve in favor of the
     under-represented archetype rather than the over-represented one.
     After the v11 rebalance: rogue/bard/barbarian all sit at ~8 total
     points available, ranger/knight at ~9, arcane/DM at ~10, cleric
     at ~12. Cleric sits last because it's the natural "obvious good
     guy" winner and shouldn't also collect free tiebreaks. */
  var ARCH_ORDER = ['sneaky_rogue', 'mighty_barbarian', 'charismatic_bard', 'wild_ranger', 'noble_knight', 'dungeon_master', 'arcane_spellcaster', 'devoted_cleric'];

  /* The bridge line is a universal transition between the heading-
     tagline pair and the three paragraph read. All eight archetypes
     share the same bridge; Family uses a slightly shorter variant. */
  var ARCH_BRIDGE = 'Here\'s what that means about him.';
  /* v5 reveal rewrites. Each read applies the four-part framework:
     P1 hedged opener, P2 specific behavior + universal + Q4 trait
     reference + strange concrete detail + bi-directional pair,
     P3 one rainbow ruse line + one honest unfavorable note + an
     explicit contradiction line, P4 painting placed in a specific
     location triggering a specific behavior in him. Target ~285
     words. Third person throughout. */
  var ARCH = {
    noble_knight: {
      name: 'Noble Knight',
      heading: 'He is the Noble Knight.',
      tagline: 'The one who stands in front of the people he loves.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'ll do the right thing even when no one will know he did. Especially then.',
      read: [
        'You already knew. Years of watching him get quiet when something needs handling, pick up the phone at midnight without complaining. You just didn\'t have a name for it. Now you do.',
        'The Noble Knight is the man who shows up. He\'s the one who does the right thing when no one\'s watching, and you stopped counting how often years ago. He stands quietly between you and whatever\'s coming, before he even thinks about it. He\'ll answer the phone at midnight and not say much, just drive. He remembers the year your grandmother died. He keeps the spare key on a hook by the door because somebody might need it.',
        'The Knight carries a lot. He\'s the one people lean on, because he lets them. That\'s the gift and that\'s the cost. He doesn\'t always know how to put it down. He\'ll carry hard news for a day before he tells you, working out how to say it so it lands the right way. He\'s somebody who needs to be the steady one, and somebody who needs to be allowed not to be. That contradiction is most of him. He apologizes when he\'s wrong, which most people only claim to do.'
      ]
    },
    sneaky_rogue: {
      name: 'Sneaky Rogue',
      heading: 'He is the Sneaky Rogue.',
      tagline: 'He already found the exit and the better way in.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s patient in a way that looks like distraction. He\'ll let you think you\'re winning.',
      read: [
        'You already knew. The smirk before the line lands. The way he clocks a room before he sits down. You\'ve been watching this version of him the whole time. It just didn\'t have a name.',
        'The Sneaky Rogue is the man who notices everything before anyone notices him. He\'s the one who already knows where the back exit is. He clocked the room before he sat down, and you\'ve watched him do it a hundred times. There\'s a smirk he does right before he says something that lands, and you\'ve learned to watch for it. He\'s the one who orders for the table and gets every order right. He\'s the one who picks up the check before you see him.',
        'The Rogue keeps a little of himself back. There\'s a door in him that even you only get through some of the time, and you stopped taking it personally years ago because he lets you in further than he lets anyone. He\'s somebody who lives a step ahead of the room and somebody who\'s quietly counting on you to slow him down. That contradiction runs underneath everything. There\'s a menace to him, and there\'s also more care with the people he picks than anyone gives him credit for.'
      ]
    },
    arcane_spellcaster: {
      name: 'Arcane Spellcaster',
      heading: 'He is the Arcane Spellcaster.',
      tagline: 'He read the manual nobody else bothered to open.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s the one with the question nobody else thought to ask.',
      read: [
        'You already knew. The pause before he answers, the way he remembers small things about people. You\'ve been living with this version of him for years. It just didn\'t have a name.',
        'The Arcane Spellcaster is the man with the question nobody else thought to ask. He\'s the one who read the manual before the box was open, and he\'ll happily explain why the manual is also slightly wrong. He thinks for a living. He pauses before he answers, because he\'s actually thinking, and the room learns to wait for it. He notices when something\'s off in the room before anyone else has named it. He\'ll remember the brand of car your dad drove.',
        'The Spellcaster lives one step ahead of the conversation. It can read as distance. It isn\'t distance. His attention is a real resource and he spends it carefully, and on the days he spends it on you, you can feel the difference. He\'d rather understand a thing than win the argument about it. He\'s also wrong sometimes and takes a beat too long to admit it. That contradiction is most of him. The patience and the pride.'
      ]
    },
    charismatic_bard: {
      name: 'Charismatic Bard',
      heading: 'He is the Charismatic Bard.',
      tagline: 'The party face who is secretly running the table.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s loud at the table and quiet in the car on the way home.',
      read: [
        'You already knew. The way the room shifts when he walks in. The quieter version that surfaces in the kitchen at the end of the night. Both versions are him. You\'ve seen both.',
        'The Charismatic Bard is the man other people end up telling stories about. He\'s the one who comes home with a friend he met at a gas station, and you stopped noticing how often he does it. He laughs at his own jokes a beat before anyone else does. That beat is him deciding the joke is funny, and the rest of the room follows. He remembers names. He remembers the dog\'s name. He\'ll talk to a stranger at the next pump the way he talks to his oldest friend.',
        'The Bard runs on people. The warmth he gives off is real, and it costs him something. He\'s the hardest one to actually reach when he\'s worn out. He\'s somebody who needs the room and somebody who needs the door to close. That contradiction is most of him. The people who think they know him have only met one half. You\'ve met both, and you\'ve seen the quieter face surface in the kitchen at the end of the night.'
      ]
    },
    mighty_barbarian: {
      name: 'Mighty Barbarian',
      heading: 'He is the Mighty Barbarian.',
      tagline: 'The loudest person you love, and the warmest.',
      bridge: ARCH_BRIDGE,
      pull: 'He\'s softer than he looks. He\'d be embarrassed if you said it out loud.',
      read: [
        'You already knew. The hugs that crush, the food made for a crowd of twenty when there\'s eight people coming. You\'ve been watching the big version and the quiet one underneath for years.',
        'The Mighty Barbarian is the loudest person you love. He\'s the one who walks into a room and changes the temperature. He laughs a beat before anyone else gets the joke. The kids hear the door and come running before they\'ve even seen him. He hugs too hard. He grills too much food. He says the thing the table was thinking and somehow it lands instead of stinging. He shows up early and stays late, and that\'s most of what he means by love.',
        'The size of him is mostly heart. He runs hot. He\'ll tell you he\'s fine in a voice that\'s plainly not, and twenty minutes later he\'ll tell you the real thing. He\'s louder when he\'s hurting than when he\'s happy, and you learned to watch for that years ago. He\'s somebody who needs to be the biggest person in the room and somebody who tears up at songs from his childhood. That contradiction is most of him. The quiet half is the one you live with. Most people only ever meet the first half.'
      ]
    },
    devoted_cleric: {
      name: 'Devoted Cleric',
      heading: 'He is the Devoted Cleric.',
      tagline: 'Softer than he looks, steadier than he says.',
      bridge: ARCH_BRIDGE,
      pull: 'He notices what people need before they ask. He doesn\'t need anyone to notice.',
      read: [
        'You already knew. The text the day after the hard thing. The chair moved so it\'s easier for someone to sit. You\'ve been watching him take care of people quietly for years.',
        'The Devoted Cleric is the man people call when something has gone wrong. He\'s the one who shows up with food after the funeral. He texts the day after the hard thing to ask how you are really doing. He has done it for years and never made a thing of it. He\'ll refill your glass before you notice it\'s empty. He\'ll move a chair so it\'s easier for someone to sit down. He notices when someone has gone quiet at a table of ten and asks them a small question that lets them back in.',
        'The Cleric gives more than he asks for. When you try to give it back he gets a little awkward, as if care is only supposed to move in one direction. It isn\'t. He\'s somebody who carries the weight for the people he loves and somebody who rarely puts it down where anyone can see. That contradiction is the whole shape of him. He doesn\'t need anyone to notice. You wish, sometimes, that he would let himself be noticed anyway.'
      ]
    },
    wild_ranger: {
      name: 'Wild Ranger',
      heading: 'He is the Wild Ranger.',
      tagline: 'Happiest where the map runs out.',
      bridge: ARCH_BRIDGE,
      pull: 'He keeps his attention small. He tries to know one thing well.',
      read: [
        'You already knew. The way he reads the weather before the radio does. The short list of people he lets all the way in. You\'ve been on that list a long time.',
        'The Wild Ranger is the man who\'s most himself when he\'s a little outside. He\'s the one who reads the manual nobody else opens, then closes it and goes out to look at the thing himself. You\'ve watched him do it for years. He keeps his attention small. One project. One stretch of trees he\'s been walking for years. One short list of people he\'s let all the way in. He\'ll notice the weather changing before the radio does.',
        'The Ranger is a slow open. He warms up the way a fire does. He\'s a bit awkward at first, and then he\'s the one who walks you all the way back to the car. He doesn\'t try to know everything. He tries to know one thing well. He\'s somebody who needs the door open and somebody who locks every door behind him at night. That contradiction is most of him. The people on his short list don\'t always know how rare it is to be on it.'
      ]
    },
    dungeon_master: {
      name: 'Dungeon Master',
      heading: 'He is the Dungeon Master.',
      tagline: 'He built the whole world so you would have somewhere to play.',
      bridge: ARCH_BRIDGE,
      pull: 'He runs the room without anyone realizing he\'s running it.',
      read: [
        'You already knew. The six hours of prep so Friday night feels effortless. The dog\'s name remembered at someone else\'s house. You\'ve been watching him build things for other people for years.',
        'The Dungeon Master is the man who builds things so other people can have somewhere to be. He\'s the one who runs the whole thing without anyone realizing he\'s running it. He prepped for six hours so Friday night would feel effortless. He remembers the dog\'s name at someone else\'s house. He remembers what everyone ordered last time. He asks one good question and pulls the answer back out six months later, exactly when someone needs to be reminded he was actually listening.',
        'The DM doesn\'t need to be the hero. He\'d rather watch the people he loves get the good moments, and set up a few more of those moments than anyone realizes. He\'s quiet in the room he\'s running. He\'s the one moving the table itself, while everyone has fun on top of it. He\'s somebody who loves making things for other people and somebody who forgets he\'s allowed to be made things for. That contradiction is most of him.'
      ]
    }
  };

  var FAMILY = {
    heading: 'Your family is an adventuring party.',
    tagline: 'The shape of you is the shape of a group that decided to stay in this together.',
    bridge: 'Here\'s what that means.',
    pull: 'Some families are built. Yours has been built deliberately, by people who pay attention.',
    read: [
      'You already saw it. The way you operate as a group. The way you cover for each other without anyone asking. You\'ve been the heart of this for years.',
      'Your family is an adventuring party. The shape of you is the shape of a group that decided to stay in this together. Some families happen. Yours has been chosen, year after year.',
      'You see who he becomes when the kids are at the table. You see the small ways he protects them. You see the bits of himself he passes on without making a thing of it. Some families are built. Yours has been built deliberately, by people who pay attention. He\'s a big part of that and he probably doesn\'t say so out loud.'
    ]
  };

  /* ---------- The seven questions ----------
     v3 order:
       Q1 recipient (segmentation, was on homepage)
       Q2 hobby (segmentation)
       Q3 hobby_vibe (SCORED, moved up from Q4 to land the engagement
                      hook earlier)
       [Reframe breath]
       Q4 character_knowledge (segmentation)
       Q5 personality (SCORED)
       [Heirloom breath]
       Q6 moral_signature (SCORED, most differentiating)
       Q7 timing (segmentation, moved to end)
     Tiebreakers run by semantic key (moral_signature first, then
     personality, then hobby_vibe), so this order can move without
     breaking scoring. Each option image (in the config) sets the
     hero on the next page. */
  /* v24 question set. The quiz is no longer a personality test that
     scores an archetype. It is a short belief ladder dressed as warm
     questions about him. Four screens only: recipient, his world, his
     character, the thing only she notices. No score is computed. The
     route (his character vs portrait from photo) and the card content
     are derived from these answers in computeRoute and seedCardFrom-
     Answers. The single hinge pause fires between his_character and
     the_notice. Insider warmth, never explain what D&D is, and every
     question offers a range from "knows it cold" to "knows the shape
     of it" so no answer makes her feel dumb. */
  /* v33 seven steps. Q1 splits her stance (insider vs outsider) and sets
     the voice of the breath and the read. Then recipient, name, world,
     character, the breath, the notice (the emotional peak), and finally
     where to send his card (the email capture). Every answer becomes a
     piece of the card or the read. The breath fires after his_character,
     right before the_notice. */
  var QUESTIONS = [
    /* v-evergreen Q1 occasion. The frame for everything after. Stored value is
       the occasion KEY, read directly by occasionKey(). It re-themes the card
       datestamp, greeting, the reveal headline, and the buyer "give it on X"
       step through the occasion helpers. Kept first so every later screen and
       the card read as the right occasion from the start. */
    {
      key: 'occasion',
      type: 'occasion',
      stem: 'What are you celebrating?',
      micro: 'Type it, or tap one. This sets the tone of the whole card.',
      placeholder: 'Type the occasion, e.g. his 40th birthday',
      /* v-evergreen2 the four fixed-date holidays carry a `holiday` key and only
         show inside their lead window (see occasionOptions + HOLIDAY_LEAD). The
         dateless reasons below, including the D&D milestones, always show. Order
         here is the display order for the dateless reasons; a visible holiday is
         pulled to the front by occasionOptions so the nearest one leads. */
      options: [
        { label: 'Valentine\'s Day', store: 'valentines', holiday: 'valentines' },
        { label: 'Mother\'s Day', store: 'mothers_day', holiday: 'mothers_day' },
        { label: 'Father\'s Day', store: 'fathers_day', holiday: 'fathers_day' },
        { label: 'Christmas', store: 'christmas', holiday: 'christmas' },
        { label: 'Birthday', store: 'birthday' },
        { label: 'Anniversary', store: 'anniversary' },
        { label: 'Defeated the BBEG', store: 'defeated_bbeg' },
        { label: 'Campaign finale', store: 'campaign_finale' },
        { label: 'A fallen hero', store: 'fallen_hero' },
        { label: 'New campaign', store: 'new_campaign' },
        { label: 'Graduation', store: 'graduation' },
        { label: 'Wedding', store: 'wedding' },
        { label: 'Just because', store: 'just_because' }
      ]
    },
    /* Q2 stance. The opener after occasion. Branches the pause voice. */
    {
      key: 'stance',
      stem: 'Are you part of their world too, or is it more their thing?',
      micro: '',
      options: [
        { label: 'I am right there in it with them', store: 'insider' },
        { label: 'I am around it, I know their world', store: 'semi' },
        { label: 'It is their thing, I just love them', store: 'outsider' }
      ]
    },
    /* Q2 recipient. Drives the sign-off and the route. */
    {
      key: 'recipient',
      type: 'recipient',
      stem: 'Who is it for?',
      micro: 'Type it, or tap one. This sets who the card speaks to.',
      placeholder: 'Type who it is for, e.g. my girlfriend, my brother',
      options: [
        { label: 'My partner', store: 'partner' },
        { label: 'My husband', store: 'husband' },
        { label: 'My wife', store: 'wife' },
        { label: 'My boyfriend', store: 'boyfriend' },
        { label: 'My girlfriend', store: 'girlfriend' },
        { label: 'My dad', store: 'dad' },
        { label: 'My mom', store: 'mom' },
        { label: 'My son', store: 'son' },
        { label: 'My daughter', store: 'daughter' },
        { label: 'A friend', store: 'friend' },
        { label: 'My whole family', store: 'whole_family' },
        { label: 'My D&D group', store: 'players' }
      ]
    },
    /* Q3 his_name. Two text fields now: his name for the greeting on the
       front of the card, and her name for the sign-off at the bottom. Both
       optional, each with a graceful fallback, so neither blocks. */
    {
      key: 'his_name',
      type: 'names',
      stem: 'What do you call them, and who is it from?',
      micro: 'Their name goes on the front. Yours signs the bottom.',
      placeholder: 'Goes on the front',
      fromPlaceholder: 'Signs the bottom'
    },
    /* Q4 his_world. Picks the card scene and leans the route. */
    {
      key: 'his_world',
      stem: 'What world do they disappear into?',
      micro: '',
      options: [
        { label: 'A table with their crew and a pile of dice', store: 'DnD' },
        { label: 'A game they disappear into for hours', store: 'VideoGame' },
        { label: 'The books and worlds they keep in their head', store: 'Reading' },
        { label: 'Honestly, a bit of everything', store: 'Mix' }
      ]
    },
    /* Q5 his_character. Locks the route, feeds the read. */
    {
      key: 'his_character',
      stem: 'Do they have a character they keep coming back to?',
      micro: '',
      options: [
        { label: 'Yeah, the same one for years', store: 'same' },
        { label: 'They are always rolling up new ones', store: 'several' },
        { label: 'They talk about someone, but I do not know the details', store: 'someone' },
        { label: 'Not sure, but they are always in that world', store: 'unsure' }
      ]
    },
    /* Q6 the_notice. The emotional peak. Becomes the message on the card
       and the heart of the read. The breath fires just before it. */
    {
      key: 'the_notice',
      layout: 'cards',
      stem: 'Who are they, underneath it all?',
      micro: 'Pick the one that lands the hardest. This becomes the heart of the message.',
      options: [
        { emoji: '💛', label: 'Looks out for everyone', sub: 'Always checking in', store: 'caretaker', trait: 'the one who looks out for everyone, the first to notice when someone needs help and the first to show up' },
        { emoji: '⚓', label: 'Calm in any storm', sub: 'Everyone leans on them', store: 'steady', trait: 'the calm, steady one who keeps everyone grounded, the person people lean on when things fall apart' },
        { emoji: '✨', label: 'Lights up the room', sub: 'Makes it more fun', store: 'funny', trait: 'the bright, funny one who lights up the room and makes everything more fun just by being there' },
        { emoji: '🛡️', label: 'Ride or die', sub: 'Always in your corner', store: 'protector', trait: 'the ride or die one who always has your back and stays in your corner no matter what' },
        { emoji: '🌙', label: 'Quiet but deep', sub: 'Says what matters', store: 'quiet', trait: 'the quiet, thoughtful one who does not say much but always says the thing that matters most' },
        { emoji: '🔥', label: 'All in, always', sub: 'Never half measures', store: 'allin', trait: 'the all in one who throws their whole heart into everything they care about and never does anything halfway' },
        { emoji: '🧠', label: 'Has all the answers', sub: 'Three steps ahead', store: 'clever', trait: 'the sharp, clever one who always has the answer and is usually three steps ahead of everyone else' },
        { emoji: '🌊', label: 'Soft under the armor', sub: 'Bigger heart than they show', store: 'softer', trait: 'tougher on the outside than the inside, a real softie under the armor once you get past the surface' }
      ]
    },
    /* v-evergreen Q8 the_detail. The single biggest lever on the AI message:
       her own words about the person, in a free textarea with live guidance
       that nudges toward a richer answer. Optional, so it never blocks; the
       guidance only pulls for more. Last question before the card builds, so
       the effort lands straight in a visibly better result. */
    {
      key: 'the_detail',
      type: 'longtext',
      stem: 'In your own words, what is one thing you love about them?',
      micro: 'A sentence or two. The more you say, the better the card.',
      placeholder: 'For example, how they show up, something only you notice, a moment you keep coming back to.'
    }
  ];
  /* v-evergreen the recipient is the master routing answer. One pick encodes
     the recipient pronouns, the emotional register the AI writes in, the card
     sign-off, the greeting vocative, and whether the recipient is a group.
     pron() resolves the current set; every surface that used to hardcode "he"
     reads from here. Unknown or unset recipients fall back to neutral they. */
  var RECIPIENT_MAP = {
    partner:     { label:'My partner',     map:'Partner',      subj:'they', obj:'them', pos:'their', refl:'themself',   register:'romantic',    signoff:'your partner', vocative:'',        group:false },
    husband:     { label:'My husband',     map:'Husband',      subj:'he',   obj:'him',  pos:'his',   refl:'himself',    register:'romantic',    signoff:'your wife',    vocative:'',        group:false },
    wife:        { label:'My wife',        map:'Wife',         subj:'she',  obj:'her',  pos:'her',   refl:'herself',    register:'romantic',    signoff:'your husband', vocative:'',        group:false },
    boyfriend:   { label:'My boyfriend',   map:'Boyfriend',    subj:'he',   obj:'him',  pos:'his',   refl:'himself',    register:'romantic',    signoff:'your partner', vocative:'',        group:false },
    girlfriend:  { label:'My girlfriend',  map:'Girlfriend',   subj:'she',  obj:'her',  pos:'her',   refl:'herself',    register:'romantic',    signoff:'your partner', vocative:'',        group:false },
    dad:         { label:'My dad',         map:'Dad',          subj:'he',   obj:'him',  pos:'his',   refl:'himself',    register:'familial',    signoff:'your family',  vocative:'Dad',     group:false },
    mom:         { label:'My mom',         map:'Mom',          subj:'she',  obj:'her',  pos:'her',   refl:'herself',    register:'familial',    signoff:'your family',  vocative:'Mom',     group:false },
    son:         { label:'My son',         map:'Son',          subj:'he',   obj:'him',  pos:'his',   refl:'himself',    register:'familial',    signoff:'Mom and Dad',  vocative:'',        group:false },
    daughter:    { label:'My daughter',    map:'Daughter',     subj:'she',  obj:'her',  pos:'her',   refl:'herself',    register:'familial',    signoff:'Mom and Dad',  vocative:'',        group:false },
    brother:     { label:'My brother',     map:'Brother',      subj:'he',   obj:'him',  pos:'his',   refl:'himself',    register:'familial',    signoff:'your family',  vocative:'',        group:false },
    sister:      { label:'My sister',      map:'Sister',       subj:'she',  obj:'her',  pos:'her',   refl:'herself',    register:'familial',    signoff:'your family',  vocative:'',        group:false },
    friend:      { label:'A friend',       map:'Friend',       subj:'they', obj:'them', pos:'their', refl:'themself',   register:'friendly',    signoff:'your friend',  vocative:'',        group:false },
    whole_family:{ label:'My whole family',map:'Whole family', subj:'they', obj:'them', pos:'their', refl:'themselves', register:'familial',    signoff:'your family',  vocative:'everyone',group:true  },
    players:     { label:'My D&D group',   map:'Players',      subj:'they', obj:'them', pos:'their', refl:'themselves', register:'celebratory', signoff:'your DM',      vocative:'team',   group:true  },
    other:       { label:'Someone else',   map:'Other',        subj:'they', obj:'them', pos:'their', refl:'themself',   register:'warm',        signoff:'',             vocative:'',        group:false }
  };
  /* The resolved pronoun + voice set for the current recipient. */
  function pron() { return RECIPIENT_MAP[state.recipient] || RECIPIENT_MAP.other; }
  /* Capitalize the first letter (for sentence-start pronouns). */
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  /* Independent possessive (his / hers / theirs) for "and ___ to keep". */
  function posInd(p) { return p === 'their' ? 'theirs' : (p === 'her' ? 'hers' : p); }

  /* ---------- State ---------- */
  var state = {
    view: 'intro',
    step: 0,
    /* v-evergreen the occasion she is celebrating (Q1). Stored as the occasion
       KEY (fathers_day, birthday, ...) and read by occasionKey(). occasionDetail
       is her optional one-line note about it, passed to the AI message. */
    occasion: '',
    occasionDetail: '',
    /* v-evergreen the raw text in the occasion type-or-pick box (either a chip
       label or her own words like "his 40th"). state.occasion is the derived
       key; occasionText is what shows in the input and seeds occasionDetail. */
    occasionText: '',
    /* v-evergreen her free-text answer to "one thing you love about them" (Q8).
       The highest-signal input to the AI message. */
    theDetail: '',
    /* v-evergreen Q8 rotating-prompt index (which angle is shown) and the angle
       handed to the AI for the typed answer. */
    detailIdx: 0,
    detailAngle: '',
    /* v-evergreen the AI-generated card message, cached so the builder and the
       canvas export use identical text and a reload does not regenerate.
       aiStatus is '', 'loading', 'done', 'failed', 'timeout', or 'unsupported'. */
    aiMessage: '',
    aiStatus: '',
    /* v-evergreen true once the card has been built (the builder reached). Locks
       the funnel forward so the quiz cannot be re-run, which caps the AI cost. */
    cardBuilt: false,
    /* v-evergreen true once the visitor has acknowledged the fast-track gate
       (the gift-only waitlist-skip warning). Persisted so they see it once. */
    gateAck: false,
    recipient: '',
    /* v-evergreen the raw text in the recipient type-or-pick box. state.recipient
       is the derived relationship key that drives pronouns, voice, and sign-off. */
    recipientText: '',
    branch: 'Standard',
    answers: [null, null, null, null, null, null, null, null],
    /* v33 her stance from Q1: insider, semi, or outsider. Branches the
       breath voice and the reveal read. */
    stance: '',
    archetype: '',
    scores: {},
    headlineVariant: '',
    firstName: '',
    email: '',
    phone: '',
    country: 'US',
    hisName: '',
    /* v29 her name for the sign-off, optional. Blank falls back to the
       relationship sign-off from question one. */
    fromName: '',
    cardAspect: '4x5',
    /* v23 invitation builder state. cardMessage is the line she picks
       or writes for the invitation. cardMsgPreset tracks which preset
       chip is active (for the selected highlight) or 'custom' when she
       has typed her own. cardTheme defaults from her hobby answer (his
       world) but she can change it in the builder. */
    cardMessage: '',
    cardMsgPreset: '',
    cardTheme: '',
    /* v34.1 in-place edits of the card text. Each holds her override of the
       computed line. Empty means use the value built from her answers. */
    cardGreeting: '',
    /* v-evergreen editable top label (defaults to the occasion stamp). */
    cardStamp: '',
    cardSummons: '',
    /* v-evergreen which summons line is shown (the card refresh icon cycles them). */
    summonsIdx: 0,
    cardSignoff: '',
    /* v37.6 (Change 5) his character's name, captured on Q6 only when she
       says he keeps coming back to the same one. Optional. Prefills the
       editable "your character" words on the card (Change 4). */
    characterName: '',
    /* v37.6 (Change 4) her in-place edit of the "your character" words on the
       card. Empty means use the captured quiz name, or the default. */
    cardCharacter: '',
    /* v36 the portrait size she picked on the reveal. Blank resolves to the
       most popular size. Drives the card size line and the checkout variant. */
    sizeKey: '',
    /* v34.1 set once she has seen the how-the-code-works lightbox, so it
       auto-opens only the first time she touches the code area. */
    stepsSeen: false,
    /* v39 (Rebuild 4) true once the post-confirm reveal prompt has shown or
       she has opened the reveal herself, so it only ever leads her in once.
       Persisted. */
    presentPromptSeen: false,
    /* Her optional written line about him (legacy capture field, retained
       for saved-state compatibility). Unused by the live flow. */
    notesText: '',
    /* v24 gift route, set by computeRoute from her answers. 'character'
       (default, the higher want) or 'portrait' (the photo fallback). */
    giftRoute: '',
    /* v27 paste-to-unlock. After she buys the gift, she pastes the code
       Shopify gave her here. The invitation then renders with his code
       on it and that finished version becomes the download. Persisted so
       a reload after purchase keeps the finished card. Empty before
       purchase, where the card shows the locked, empty panel. */
    unlockCode: '',
    /* Per-session flags so each breath screen fires at most once and
       back-navigation from the next question skips it cleanly. Not
       persisted: a fresh page load gives the breath a chance again. */
    breathShown: { hinge: false },
    /* v17: timing moved out of the quiz body and into the SMS opt-in
       form. Stored as its own state field instead of an answers[]
       index because the form drives it, not the question engine. */
    timing: ''
  };
  var tracked = {};
  /* Module-scoped handle for the active breath auto-advance timer so
     navigation away from a breath screen (back button, retake, refresh)
     never leaves an orphaned timeout running. */
  var breathTimer = null;
  function clearBreathTimer() {
    if (breathTimer) { clearTimeout(breathTimer); breathTimer = null; }
  }
  /* v28.1 guard so the collapsed message picker's document-level
     outside-click and Escape handlers are attached only once, never
     restacked across builder re-renders. */
  var msgpickDocBound = false;
  /* v34.1 guard so the lightbox Escape-to-close handler is attached once. */
  var stepsDocBound = false;
  /* v-evergreen one-shot flag: when true, the next card render reveals the
     message word by word (set by applyAICard and the AI fallback). */
  var pendingReveal = false;

  /* ---------- Small helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) { try { return crypto.randomUUID(); } catch (e) {} }
    return 'ffg-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function h(html) {
    var t = document.createElement('template');
    t.innerHTML = String(html).trim();
    return t.content.firstChild;
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function recipientObj() {
    var m = RECIPIENT_MAP[state.recipient] || RECIPIENT_MAP.other;
    return { value: state.recipient || 'other', map: m.map, label: m.label };
  }


  /* ---------- Storage ---------- */
  function save() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({
        view: state.view, step: state.step, recipient: state.recipient,
        branch: state.branch, answers: state.answers,
        timing: state.timing,
        /* v23 invitation builder fields. v24 adds giftRoute. */
        stance: state.stance, email: state.email, phone: state.phone,
        hisName: state.hisName, fromName: state.fromName, cardMessage: state.cardMessage,
        cardStamp: state.cardStamp, cardGreeting: state.cardGreeting, cardSummons: state.cardSummons, summonsIdx: state.summonsIdx,
        cardSignoff: state.cardSignoff, stepsSeen: state.stepsSeen,
        presentPromptSeen: state.presentPromptSeen,
        characterName: state.characterName, cardCharacter: state.cardCharacter,
        sizeKey: state.sizeKey,
        notesText: state.notesText,
        cardMsgPreset: state.cardMsgPreset, cardTheme: state.cardTheme,
        giftRoute: state.giftRoute, unlockCode: state.unlockCode,
        occasion: state.occasion, occasionDetail: state.occasionDetail,
        occasionText: state.occasionText, recipientText: state.recipientText,
        theDetail: state.theDetail, detailIdx: state.detailIdx, detailAngle: state.detailAngle, aiMessage: state.aiMessage, cardBuilt: state.cardBuilt,
        gateAck: state.gateAck,
        headlineVariant: state.headlineVariant, ts: Date.now()
      }));
    } catch (e) {}
  }
  function loadSaved() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      /* v34 keep her card for 60 days, not 24 hours, so she can buy, get a
         code, come back days later, and her finished card and answers are
         still here to paste into without retaking the quiz. */
      if (!d || !d.ts || Date.now() - d.ts > 60 * 24 * 3600 * 1000) return null;
      return d;
    } catch (e) { return null; }
  }
  function clearSaved() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }

  /* ---------- Scoring ---------- */
  function answersComplete() {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (state.answers[i] == null) return false;
    }
    return true;
  }
  function answerStore(idx) {
    var ai = state.answers[idx];
    if (ai == null) return '';
    var q = QUESTIONS[idx];
    if (!q || !q.options) return '';
    /* Multi-select questions store an array of selected indices, not
       a single index. For these, return the joined store values.
       answerMulti() returns the array form for callers that need it. */
    if (q.type === 'multi') {
      if (!Array.isArray(ai)) return '';
      var parts = [];
      for (var m = 0; m < ai.length; m++) {
        var o = q.options[ai[m]];
        if (o && o.store) parts.push(o.store);
      }
      return parts.join(', ');
    }
    var opt = q.options[ai];
    return opt ? opt.store : '';
  }
  /* v37.6 (Change 5) index of the option carrying a given store value on a
     question, or -1. Lets the his_character handler find the "same one for
     years" option by meaning instead of a hardcoded position. */
  function storeIndex(q, store) {
    if (!q || !q.options) return -1;
    for (var i = 0; i < q.options.length; i++) {
      if (q.options[i] && q.options[i].store === store) return i;
    }
    return -1;
  }
  /* Multi-select sibling of answerStore. Returns the array of
     selected store strings (or empty array if not yet picked). Used
     by buildProperties to JSON-stringify trait_curation. */
  function answerMulti(key) {
    var i = indexByKey(key);
    if (i < 0) return [];
    var ai = state.answers[i];
    if (!Array.isArray(ai)) return [];
    var q = QUESTIONS[i];
    if (!q || !q.options) return [];
    var out = [];
    for (var m = 0; m < ai.length; m++) {
      var o = q.options[ai[m]];
      if (o && o.store) out.push(o.store);
    }
    return out;
  }
  /* ---------- Semantic lookups ----------
     v3 refactor. Anywhere we used to reference a question by its
     position in the array (e.g. "the question at index 4 is the
     scored personality one") now goes through these helpers. Lets us
     reorder QUESTIONS without breaking scoring, image lookup, breath
     insertion, or Klaviyo property writes. */
  function indexByKey(key) {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (QUESTIONS[i].key === key) return i;
    }
    return -1;
  }
  function answerByKey(key) {
    var i = indexByKey(key);
    return i >= 0 ? answerStore(i) : '';
  }
  /* Map a semantic question key to the legacy editor image slot. The
     Liquid theme settings (q1_image, q2_image, etc.) were authored
     before the v3 reorder; rather than renaming all the editor
     settings (which would orphan Jan's existing uploads) we map by
     intent here. New questions get new slots. */
  var IMG_SLOT = {
    /* v-evergreen one editor image slot per question, in quiz order. The existing
       slot ids (occasion/stance/recipient/q3/q1/q4/q6) are kept so prior uploads
       still show; the_detail gets its own new 'detail' slot. */
    occasion: 'occasion',        /* Q1  What are you celebrating         -> q_occasion_image */
    stance: 'stance',            /* Q2  Part of their world              -> q_stance_image */
    recipient: 'recipient',      /* Q3  Who is it for                    -> recipient_picker_image */
    his_name: 'q3',              /* Q4  Their name + yours               -> q3_image */
    his_world: 'q1',             /* Q5  The world they disappear into    -> q1_image */
    his_character: 'q4',         /* Q6  A character they come back to     -> q4_image */
    the_notice: 'q6',            /* Q7  Who they are underneath           -> q6_image */
    the_detail: 'detail'         /* Q8  One thing you love about them     -> q_detail_image */
  };
  /* v33 a visible placeholder for any screen that has no uploaded image,
     so the image area is always present and obvious to fill. */
  function heroPlaceholderHTML() {
    return '<div class="ffg-qhero ffg-qhero--ph" aria-hidden="true"></div>';
  }
  /* v37.2 Jan wants a real placeholder image on every question + pause screen
     (not just an empty frame) so the funnel never looks unfinished, even before
     he uploads the exact image for each one. We deal them from the portfolio
     pool by index so each screen gets a stable, different portrait. Falls back
     to the empty frame only if the pool is somehow empty. */
  function placeholderFromGallery(n) {
    var pool = GALLERY_DEFAULT;
    if (!pool.length) return '';
    return pool[((n % pool.length) + pool.length) % pool.length];
  }
  function questionPlaceholderImgHTML(idx) {
    var src = placeholderFromGallery(idx);
    if (!src) return heroPlaceholderHTML();
    return '<div class="ffg-qhero ffg-qhero--phimg">' +
      '<img src="' + esc(src) + '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  function breathPlaceholderImgHTML() {
    /* offset 7 so the pause portrait differs from the early-question ones */
    var src = placeholderFromGallery(7);
    if (!src) return '<div class="ffg-breath__media ffg-breath__media--ph" aria-hidden="true"></div>';
    return '<div class="ffg-breath__media ffg-breath__media--phimg">' +
      '<img src="' + esc(src) + '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  /* v24: archetype scoring removed. The quiz computes a gift ROUTE,
     not an archetype. Two routes: 'character' (the higher want, the
     thing a cheap tool cannot fake, the default) and 'portrait' (turn
     him into the hero from a photo she already has). Lean hard toward
     character. Fall back to portrait only when there is clearly no
     character to bring to life: the whole-family recipient, or a pure
     video-game fan who has not made a character. The hinge pause means
     she never has to describe a character she only half knows, so the
     character route is safe even when she picked "I do not know the
     details" or "I am not sure." */
  function computeRoute() {
    if (state.recipient === 'whole_family') { state.giftRoute = 'portrait'; return; }
    var world = answerByKey('his_world');
    var character = answerByKey('his_character');
    /* The only non-family fallback: a video-game world with no
       character he has made. Everyone else gets the character route. */
    if (world === 'VideoGame' && character === 'unsure') { state.giftRoute = 'portrait'; return; }
    state.giftRoute = 'character';
  }
  /* Seed the invitation card from her answers so a finished, beautiful
     card is waiting with nothing to build. She can still change the
     message, but she should not have to. World sets the scene theme,
     the_notice sets which care line surfaces as the message. */
  var NOTICE_TO_PRESET = {
    protector: 4,
    caretaker: 1,
    softer: 0,
    quiet: 3,
    funny: 5,
    clever: 6,
    allin: 5,
    steady: 4
  };
  function seedCardFromAnswers() {
    if (!state.cardTheme) state.cardTheme = defaultThemeForHobby();
    /* Only seed the message if she has not already written or picked
       one (so re-entering the builder does not overwrite her edit). */
    if (!state.cardMessage) {
      var notice = answerByKey('the_notice');
      var idx = NOTICE_TO_PRESET[notice];
      if (idx == null) idx = 0;
      state.cardMessage = INVITE_PRESETS[idx] || INVITE_PRESETS[0];
      state.cardMsgPreset = String(idx);
    }
  }

  /* ---------- AI card message (reuses the dormant quest-ai Worker) ----------
     v-evergreen the personal message is generated by the same Cloudflare Worker
     the Character Quest uses (POST {prompt} -> {text}, model + token server-side,
     stateless, so this never touches the Quest's data). The greeting/occasion
     line stays deterministic (occasionGreet + name), which already produces the
     intended wording; the AI focuses on the message, where it adds real value.
     The preset from seedCardFromAnswers is the instant fallback, so the card is
     never blank and the buy never waits on the network. The result is cached in
     state so re-entering the builder does not regenerate and the canvas export
     uses the exact same text as the preview. */
  var AI_WORKER_URL = 'https://quest-ai.fondlyframed.workers.dev';
  /* The full label of the picked the_notice option (richer than the store code). */
  function noticeLabelText() {
    var i = indexByKey('the_notice');
    if (i < 0) return '';
    var ai = state.answers[i];
    var q = QUESTIONS[i];
    if (q && q.options && ai != null && q.options[ai]) return q.options[ai].trait || q.options[ai].label || '';
    return '';
  }
  /* A natural-language phrase for the world they love, for the prompt. */
  function worldPhrase() {
    return ({
      DnD: 'tabletop role-playing with their crew',
      VideoGame: 'the games they lose hours in',
      Reading: 'the fantasy worlds they read and keep in their head',
      Mix: 'a whole mix of fantasy and gaming worlds'
    })[answerByKey('his_world')] || 'the worlds they love';
  }
  /* v-evergreen2 Q8 rotating prompts, tuned to the recipient and the occasion.
     Each prompt is tagged:
       recipients  who it fits. 'any' works for everyone. Other tags are partner,
                   parent, child, sibling, friend, group, family.
       registers   the voice it fits (romantic, familial, friendly, celebratory, warm).
       occasions   if set, the prompt ONLY shows for those occasions (occasion locked).
                   if empty, it is a general prompt that shows for any occasion.
       group       'only' shows for group recipients only, 'no' hides for groups.
     detailPromptOrder() filters out the wrong-fit prompts (a friend never sees a
     romantic prompt, a solo gift never sees a group prompt, a memorial only shows
     gentle prompts) and orders the rest, most relevant first. Each carries an
     `angle` handed to the AI so it knows what the typed words are answering. */
  var ALL_REGISTERS = ['romantic', 'familial', 'friendly', 'celebratory', 'warm'];
  var DETAIL_PROMPTS = [
    /* Universal. Always eligible, the floor under every combo. */
    { stem: 'What is one thing they always do that is just so them?', angle: 'a signature habit or quirk that is unmistakably them', registers: ALL_REGISTERS, recipients: ['any'] },
    { stem: 'What is a moment with them you keep coming back to?', angle: 'a specific moment with them the giver keeps coming back to', registers: ALL_REGISTERS, recipients: ['any'] },
    { stem: 'What is something only the people close to them get to see?', angle: 'a side of them only the people closest to them see', registers: ALL_REGISTERS, recipients: ['any'] },
    { stem: 'If you had to hype them up in one line, what would you say?', angle: 'how the giver would hype this person up in one line', registers: ALL_REGISTERS, recipients: ['any'] },
    { stem: 'What is something they would never say about themselves?', angle: 'something true about them they are too modest to say', registers: ALL_REGISTERS, recipients: ['any'] },
    /* Partner. */
    { stem: 'What is a small thing they do that you would miss most?', angle: 'a small everyday thing about them the giver would miss most', registers: ['romantic'], recipients: ['partner'], group: 'no' },
    { stem: 'When did you know they were one of the good ones?', angle: 'the moment the giver knew this person was one of the good ones', registers: ['romantic'], recipients: ['partner'], group: 'no' },
    { stem: 'What do you see in them that they miss in themselves?', angle: 'something good the giver sees in them that they miss in themselves', registers: ['romantic'], recipients: ['partner'], group: 'no' },
    /* Parent, the giver is the kid looking up. */
    { stem: 'What is something they taught you that stuck?', angle: 'a lesson this parent taught the giver that stuck', registers: ['familial'], recipients: ['parent'], group: 'no' },
    { stem: 'What did they always say or do when you were growing up?', angle: 'a signature saying or habit of this parent from when the giver was growing up', registers: ['familial'], recipients: ['parent'], group: 'no' },
    { stem: 'What do you get about them now that you did not back then?', angle: 'something about this parent the giver understands now that they did not as a kid', registers: ['familial'], recipients: ['parent'], group: 'no' },
    /* Child, the giver is the parent looking on with pride. */
    { stem: 'What is something about them that makes you proud?', angle: 'what makes the giver proud of their kid', registers: ['familial'], recipients: ['child'], group: 'no' },
    { stem: 'What were they like as a little kid, in one moment?', angle: 'a small moment that captures who their child has always been', registers: ['familial'], recipients: ['child'], group: 'no' },
    { stem: 'What do you see coming for them that they cannot yet?', angle: 'the potential the giver sees in their child that the child cannot see yet', registers: ['familial'], recipients: ['child'], group: 'no' },
    /* Sibling. */
    { stem: 'What is the thing only the two of you would get?', angle: 'an inside thing only these siblings share', registers: ['familial'], recipients: ['sibling'], group: 'no' },
    { stem: 'What is a story from growing up you still bring up?', angle: 'a shared growing up story the giver still brings up', registers: ['familial'], recipients: ['sibling'], group: 'no' },
    /* Friend. */
    { stem: 'What is the thing everyone counts on them for?', angle: 'what the friend group always counts on this person for', registers: ['friendly'], recipients: ['friend'], group: 'no' },
    { stem: 'What is a story about them you always end up telling?', angle: 'the story the giver always ends up telling about this friend', registers: ['friendly'], recipients: ['friend'], group: 'no' },
    { stem: 'When did they show up for you without being asked?', angle: 'a time this friend showed up for the giver without being asked', registers: ['friendly'], recipients: ['friend'], group: 'no' },
    /* Group or whole family. Plural by design. */
    { stem: 'What is a moment with this crew nobody lets the others forget?', angle: 'a shared moment this whole group will never let each other forget', registers: ['celebratory', 'familial'], recipients: ['group', 'family'], group: 'only' },
    { stem: 'What is the thing that makes this crew, this crew?', angle: 'what makes this particular group what it is', registers: ['celebratory', 'familial'], recipients: ['group', 'family'], group: 'only' },
    /* Occasion locked. These only show for their occasion and lead when it is set. */
    { stem: 'What did it take for them to get here?', angle: 'what this person pushed through to reach this milestone', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['graduation'] },
    { stem: 'What do you see when you look at the two of them?', angle: 'what the giver sees when they look at this couple', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['wedding'] },
    { stem: 'What about them has not changed in all this time?', angle: 'something constant about them across all the years', registers: ['romantic'], recipients: ['any'], occasions: ['anniversary'] },
    { stem: 'What is the thing about them you fell for?', angle: 'the thing about them the giver first fell for', registers: ['romantic'], recipients: ['any'], occasions: ['valentines'] },
    { stem: 'What about them are you most grateful for this year?', angle: 'something about them the giver is most grateful for this year', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['christmas'] },
    { stem: 'What is the world better at because they are in it?', angle: 'what is better in the world because this person is in it', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['birthday'] },
    { stem: 'What was the moment you knew you had them?', angle: 'the turning point in the fight when the party knew they had won', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['defeated_bbeg'] },
    { stem: 'What is the moment from this whole campaign you will never forget?', angle: 'the one moment from the whole campaign the giver will never forget', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['campaign_finale'] },
    { stem: 'Who is this new character, and what are you hoping for them?', angle: 'who this brand new character is and what the giver is hoping for them', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['new_campaign'] },
    /* A fallen hero. Gentle, about the character. Only these show for that occasion. */
    { stem: 'What made this character impossible to forget?', angle: 'what made this fallen character impossible to forget at the table', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['fallen_hero'] },
    { stem: 'What is the moment with them the table still talks about?', angle: 'the moment with this character the table still talks about', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['fallen_hero'] },
    { stem: 'Who were they at their best?', angle: 'who this character was at their very best', registers: ALL_REGISTERS, recipients: ['any'], occasions: ['fallen_hero'] }
  ];
  /* Occasions that ARE the reason for the gift. When one of these is set, its
     occasion-locked prompt leads. The rest are timing, so the relationship leads. */
  var MILESTONE_OCC = { graduation: 1, wedding: 1, retirement: 1, defeated_bbeg: 1, campaign_finale: 1, new_campaign: 1 };
  /* Occasions that need a gentle hand. Only their own prompts show, nothing upbeat. */
  var SOMBER_OCC = { fallen_hero: 1 };
  /* Collapse the specific recipient into the tag the prompt pool uses. */
  function recipientTag() {
    return ({
      partner: 'partner', husband: 'partner', wife: 'partner', boyfriend: 'partner', girlfriend: 'partner',
      dad: 'parent', mom: 'parent', son: 'child', daughter: 'child',
      brother: 'sibling', sister: 'sibling', friend: 'friend',
      whole_family: 'family', players: 'group'
    })[state.recipient] || 'any';
  }
  /* Filter the prompt pool to what fits this recipient and occasion, then order it
     most relevant first. Filtering (not just ranking) is what keeps a friend from
     ever seeing a romantic prompt and a memorial from ever seeing an upbeat one. */
  function detailPromptOrder() {
    var reg = pron().register, occ = occasionKey(), tag = recipientTag(), grp = !!pron().group, somber = !!SOMBER_OCC[occ];
    var scored = [];
    for (var i = 0; i < DETAIL_PROMPTS.length; i++) {
      var p = DETAIL_PROMPTS[i];
      var recips = p.recipients || ['any'];
      var occs = p.occasions || [];
      /* Somber occasions: only the prompts locked to that occasion. */
      if (somber) { if (occs.indexOf(occ) === -1) continue; }
      /* Other occasion-locked prompts only show for their occasion. */
      else if (occs.length && occs.indexOf(occ) === -1) continue;
      /* Recipient fit. */
      if (recips.indexOf('any') === -1 && recips.indexOf(tag) === -1) continue;
      /* Group phrasing fit. */
      if (grp && p.group === 'no') continue;
      if (!grp && p.group === 'only') continue;
      var s = 0;
      if (recips.indexOf(tag) !== -1) s += 3;
      if (occs.indexOf(occ) !== -1) s += MILESTONE_OCC[occ] ? 4 : 2;
      if (p.registers && p.registers.indexOf(reg) !== -1) s += 1;
      scored.push({ p: p, i: i, s: s });
    }
    scored.sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
    var out = [];
    for (var k = 0; k < scored.length; k++) out.push(scored[k].p);
    if (!out.length) out.push(DETAIL_PROMPTS[0]);
    return out;
  }
  function activeDetailPrompt() {
    var order = detailPromptOrder();
    return order[(state.detailIdx || 0) % order.length] || order[0];
  }
  function buildCardPrompt() {
    var p = pron();
    var rel = ((RECIPIENT_MAP[state.recipient] || RECIPIENT_MAP.other).label || 'someone I love').replace(/^(My |A )/, '');
    var name = (state.hisName || '').trim();
    var giver = (state.fromName || '').trim();
    var detail = (state.theDetail || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    var occDetail = (state.occasionDetail || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
    var occ = occasionLabel() || 'a special occasion';
    var charName = (state.characterName || '').trim();
    var registerHint = ({
      romantic: 'romantic and intimate, the way a partner writes to the one they love',
      familial: 'warm and affectionate, the way close family writes',
      friendly: 'warm, easy and genuine, the way close friends talk, never romantic',
      celebratory: 'celebratory and shared, written to a group who went on an adventure together',
      warm: 'warm and sincere'
    })[p.register] || 'warm and sincere';
    var L = [];
    L.push('Write a short, heartfelt gift-card message FROM the giver TO the recipient.');
    L.push('Return ONLY the message text, with no preamble, no quotation marks, and no label.');
    L.push('');
    L.push('Occasion: ' + occ + (occDetail ? ' (' + occDetail + ')' : '') + '.');
    if (occasionKey() === 'fallen_hero') L.push('This is a tribute to a character who has died. Keep it warm and a little wistful, never grim. Write about who the character was, not about the loss.');
    L.push('Recipient: ' + rel + (name ? (', named ' + name) : '') + '. Address them only as "you".');
    L.push('What they love: ' + worldPhrase() + (charName ? (', especially a character named ' + charName) : '') + '.');
    if (noticeLabelText()) L.push('What the giver most notices about them: ' + noticeLabelText() + '.');
    if (detail) L.push('In the giver\'s OWN words, about ' + (state.detailAngle || 'what they love about them') + ', use this as the heart of the message: "' + detail + '"');
    L.push('');
    L.push('Rules:');
    L.push('- Keep it SHORT. One or two short sentences, 30 words maximum. Tight beats long, never pad it.');
    L.push('- First person, addressed to "you".');
    L.push('- Tone: ' + registerHint + '.');
    L.push('- Specific and sincere, built on the giver\'s own words. Plain language a real person would actually say.');
    L.push('- Sound like a human who knows them, never like a greeting card or AI. No cliches.');
    L.push('- Banned phrases: "in ways I never knew", "words cannot express", "forever grateful", "light up my world", "more than words", "every fiber", "thankful beyond".');
    L.push('- Do NOT mention painting, portraits, gift cards, codes, or how the gift works.');
    L.push('- Do NOT include any names, not the recipient\'s and not the giver\'s. Do NOT sign it, and do NOT end it with a name. A greeting and a signature are added separately, so the message body must contain no names and no sign-off.');
    L.push('- No dashes of any kind. No em dashes, no en dashes, no hyphens used as pauses, no semicolons, no emojis, no hashtags. Use only commas and periods.');
    return L.join('\n');
  }
  /* Reject empty, markdown-ish, or over-long output (mirrors the Quest's callAI). */
  function aiValid(s, maxLen) {
    if (!s) return false;
    var t = String(s).replace(/^\s+|\s+$/g, '');
    if (!t) return false;
    if (t.charAt(0) === '#') return false;
    if (t.length > (maxLen || 600)) return false;
    return true;
  }
  /* Strip any wrapping quotes or a stray leading label the model may add. */
  function aiClean(s) {
    var t = String(s || '').replace(/^\s+|\s+$/g, '');
    t = t.replace(/^MESSAGE:\s*/i, '');
    t = t.replace(/^["'“‘]+/, '').replace(/["'”’]+$/, '');
    /* v-evergreen never let a dash reach the card. Em dash, en dash, and a
       hyphen used as a pause all become a comma. Then tidy doubled commas and
       runs of whitespace so the sentence still reads clean. */
    t = t.replace(/\s*[—–]\s*/g, ', ');
    t = t.replace(/\s+-\s+/g, ', ');
    t = t.replace(/\s*,(\s*,)+\s*/g, ', ').replace(/\s{2,}/g, ' ');
    return t.replace(/^\s+|\s+$/g, '');
  }
  /* Cap the message to about two short sentences / 34 words on a sentence
     boundary, so a long generation still reads as a tight card. No regex
     lookbehind (older Safari does not support it). */
  function aiTrim(text) {
    var parts = String(text).match(/[^.!?]+[.!?]+|\S[^.!?]*$/g) || [String(text)];
    var out = '', words = 0;
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i].replace(/^\s+|\s+$/g, '');
      if (!seg) continue;
      var w = seg.split(/\s+/).length;
      if (out && (words + w) > 34) break;
      out += (out ? ' ' : '') + seg;
      words += w;
    }
    return out || String(text).replace(/^\s+|\s+$/g, '');
  }
  /* Wrap each word in a span with a staggered fade-in delay, so the message
     reveals as if it is being written. Total stagger is capped so it never
     drags. Used once per generation (gated by pendingReveal). */
  function revealWordsHTML(text) {
    var words = String(text).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '').split(' ');
    var out = '';
    for (var i = 0; i < words.length; i++) {
      var d = Math.min(i * 45, 1800);
      out += '<span class="ffg-w" style="animation-delay:' + d + 'ms">' + esc(words[i]) + '</span>';
      if (i < words.length - 1) out += ' ';
    }
    return out;
  }
  /* Backstop: only neutralize gendered pronouns when the recipient is neutral
     "they", to catch the model slipping into he/she. He/she recipients are
     trusted (the prompt named the pronouns). The message addresses the recipient
     as "you", so this rarely fires. */
  function aiPronounSafe(text) {
    if (pron().subj !== 'they') return text;
    return String(text)
      .replace(/\bhe\b/g, 'they').replace(/\bHe\b/g, 'They')
      .replace(/\bshe\b/g, 'they').replace(/\bShe\b/g, 'They')
      .replace(/\bhim\b/g, 'them').replace(/\bHim\b/g, 'Them')
      .replace(/\bhis\b/g, 'their').replace(/\bHis\b/g, 'Their')
      .replace(/\bhimself\b/g, 'themself').replace(/\bherself\b/g, 'themself');
  }
  /* Apply a cached AI message to the card, unless she has written her own. */
  function applyAICard() {
    if (!state.aiMessage) return;
    if (state.cardMsgPreset === 'custom') return;   /* her own edit always wins */
    state.cardMessage = state.aiMessage;
    state.cardMsgPreset = 'ai';
    save();
    pendingReveal = true;
    if (state.view === 'builder') { try { updateInvitePreview(); } catch (e) {} }
  }
  /* When the AI cannot produce a message (slow, down, or bad output), reveal the
     seeded preset with the same word-by-word animation, so the writing state
     never hangs and she still gets a complete, warm card. */
  function revealFallback() {
    if (!state.cardMessage) seedCardFromAnswers();
    pendingReveal = true;
    if (state.view === 'builder') { try { updateInvitePreview(); } catch (e) {} }
  }
  /* Generate the message on the Worker. Non-blocking, cached, with a timeout.
     The seeded preset stays in place until (and unless) this succeeds, so the
     card is always complete and the buy never waits on it. */
  function aiGenerateCard() {
    if (state.aiMessage) { applyAICard(); return; }       /* cached from a prior run */
    if (state.aiStatus === 'loading') return;
    if (typeof fetch !== 'function') { state.aiStatus = 'unsupported'; return; }
    state.aiStatus = 'loading';
    var settled = false;
    var to = setTimeout(function () { if (!settled) { settled = true; state.aiStatus = 'timeout'; revealFallback(); } }, 9000);
    try {
      fetch(AI_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: buildCardPrompt() })
      })
        .then(function (r) { return (r && r.ok) ? r.json() : Promise.reject(new Error('bad status')); })
        .then(function (d) {
          if (settled) return;
          settled = true; clearTimeout(to);
          var raw = (d && typeof d.text === 'string') ? d.text : '';
          if (!aiValid(raw, 1200)) { state.aiStatus = 'failed'; revealFallback(); return; }
          var msg = aiPronounSafe(aiTrim(aiClean(raw)));
          if (!aiValid(msg, 600)) { state.aiStatus = 'failed'; revealFallback(); return; }
          state.aiMessage = msg;
          state.aiStatus = 'done';
          save();
          applyAICard();
        })
        .catch(function () { if (!settled) { settled = true; clearTimeout(to); state.aiStatus = 'failed'; revealFallback(); } });
    } catch (e) { settled = true; clearTimeout(to); state.aiStatus = 'failed'; revealFallback(); }
  }
  function firstTextTemplate() {
    /* v7: character_knowledge cut, so Template 1 now triggers on
       hobby = DnD alone (no character-knowledge dependency). */
    if (state.branch === 'Family') return 'Template 5';
    /* v17: timing reads from state.timing (form data) instead of
       the answers[] array since it's no longer a quiz question. */
    if (state.timing === 'ASAP') return 'Template 4';
    if (answerByKey('his_world') === 'DnD') return 'Template 1';
    return 'Template 2';
  }

  /* ---------- Reveal data ---------- */
  /* Returns the cleaned full label of the picked trait_curation
     option: leading emoji stripped, first letter lowercased so it
     reads naturally inside "You said it's [...]", trailing period
     removed (the sentence adds its own). Empty string if no pick. */
  function pickedTraitLabel() {
    var idx = indexByKey('trait_curation');
    if (idx < 0) return '';
    var ai = state.answers[idx];
    if (ai == null) return '';
    var q = QUESTIONS[idx];
    if (!q || !q.options || !q.options[ai]) return '';
    var label = q.options[ai].label || '';
    /* Skip leading non-letter characters (emoji + variation
       selectors + whitespace) by finding the first ASCII letter. */
    var m = label.match(/[A-Za-z]/);
    if (m) label = label.slice(m.index);
    if (label.length) label = label.charAt(0).toLowerCase() + label.slice(1);
    label = label.replace(/\.\s*$/, '');
    return label;
  }
  /* Builds the reveal-screen sentence above the archetype heading.
     Standard: "You said it's [trait]. Here's the rest of him."
     Family:   "You said it's [trait]. That's the shape of this family."
     Returns empty string if she somehow didn't pick a trait. */
  /* "Save your [relationship]'s archetype" label for the reveal-page
     card download button. Keyed off state.recipient (set by the Q1
     pick). Falls back to a generic label when recipient is missing
     or unrecognized, so the button never shows broken copy. */
  function cardButtonLabel() {
    var rel = ({
      husband:      'HUSBAND',
      boyfriend:    'PARTNER',
      dad:          'DAD',
      whole_family: 'FAMILY'
    })[state.recipient];
    if (!rel) return 'SAVE YOUR ARCHETYPE CARD';
    return 'SAVE YOUR ' + rel + '\'S ARCHETYPE CARD';
  }
  function traitPicksSentence() {
    var trait = pickedTraitLabel();
    if (!trait) return '';
    if (state.branch === 'Family') {
      return 'You said it\'s ' + trait + '. That\'s the shape of this family.';
    }
    return 'You said it\'s ' + trait + '. Here\'s the rest of him.';
  }
  function revealData() {
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    if (state.branch === 'Family') {
      /* v5: Family reveal opens with the trait-picks sentence (was
         the dynamic "He is the [archetype name] at the center of it"
         prepend in v3). The three Family paragraphs that follow are
         unchanged. If she somehow reached Family without picking 3
         traits, fall back to the v3 archetype prepend so the read is
         never broken. */
      var fOpen = traitPicksSentence();
      if (!fOpen) fOpen = 'He is the ' + a.name + ' at the center of it.';
      return {
        heading: FAMILY.heading,
        tagline: FAMILY.tagline,
        imageKey: 'family',
        read: [fOpen].concat(FAMILY.read),
        bridge: FAMILY.bridge,
        pull: FAMILY.pull,
        cardLabel: 'YOUR FAMILY IS',
        cardName: 'AN ADVENTURING PARTY',
        cardTagline: FAMILY.tagline
      };
    }
    return {
      heading: a.heading,
      tagline: a.tagline,
      imageKey: state.archetype,
      read: a.read,
      bridge: a.bridge,
      pull: a.pull,
      cardLabel: 'HE IS THE',
      cardName: a.name.toUpperCase(),
      cardTagline: a.tagline
    };
  }

  /* ---------- Tracking ---------- */
  function fbTrack(name, custom) {
    if (typeof window.fbq !== 'function') return;
    try {
      var params = { eventID: uuid() };
      if (name === 'Lead') window.fbq('track', 'Lead', custom || {}, params);
      else window.fbq('trackCustom', name, custom || {}, params);
    } catch (e) {}
  }
  function gaTrack(name, params) {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, params || {}); } catch (e) {}
  }
  function trackOnce(key, fn) { if (tracked[key]) return; tracked[key] = true; fn(); }

  /* ---------- Meta CompleteRegistration (browser pixel + Conversions API) ----------
     Mirrors the Fantasy Portrait from Photo product page. Fires a
     CompleteRegistration event when someone finishes the quiz and submits
     their name and number, so a Meta custom conversion can optimize ad
     delivery toward quiz finishers who leave a contact.

     Browser fbq and the server-side Conversions API POST share one
     event_id, so Meta dedupes them into a single conversion. The CAPI
     half is what guarantees the event lands even when the browser pixel
     is blocked. user_data is SHA-256 hashed (phone, first name) per
     Meta's requirement. event_source_url is the live quiz page path with
     query params stripped, so a URL-rule custom conversion never breaks
     on ?utm or ?fbclid. The dataset id and access token were removed from
     this evergreen clone, so the inline CAPI call is disabled by default. */
  function capiCompleteRegistration(e164, first) {
    /* v-evergreen: Meta Conversions API is DISABLED in the evergreen clone.
       The hardcoded dataset id and long-lived access token were removed from
       this public asset (they must never ship in client JS). If server-side
       CAPI is ever wanted on this funnel, route it through the Worker, which
       holds the token as an environment variable. This function is a no-op. */
    return;
    var eventId = 'FDQSubmit_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    var eventTime = Math.floor(Date.now() / 1000);
    var sourceUrl;
    try { sourceUrl = window.location.origin + window.location.pathname; }
    catch (e) { sourceUrl = 'https://framedfantasy.com/pages/fathers-day-quiz'; }
    var customData = {
      content_name: 'Gift Quiz Evergreen Signup',
      content_category: 'Gift Quiz Evergreen'
    };

    /* Browser-pixel half of the dedupe pair. */
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', 'CompleteRegistration', customData, { eventID: eventId }); } catch (e) {}
    }

    /* Server (Conversions API) half. */
    try {
      if (!window.crypto || !window.crypto.subtle || typeof window.TextEncoder === 'undefined') return;
      function sha256(str) {
        var buf = new window.TextEncoder().encode(String(str));
        return window.crypto.subtle.digest('SHA-256', buf).then(function (hash) {
          var bytes = new Uint8Array(hash);
          var out = '';
          for (var i = 0; i < bytes.length; i++) {
            out += bytes[i].toString(16).padStart(2, '0');
          }
          return out;
        });
      }
      var cleanPhone = String(e164 || '').replace('+', '').toLowerCase();
      var cleanName = String(first || '').toLowerCase().trim();
      Promise.all([sha256(cleanPhone), sha256(cleanName)]).then(function (hashes) {
        var payload = {
          data: [{
            event_name: 'CompleteRegistration',
            event_time: eventTime,
            event_id: eventId,
            event_source_url: sourceUrl,
            action_source: 'website',
            user_data: { ph: [hashes[0]], fn: [hashes[1]] },
            custom_data: customData
          }]
        };
        fetch('about:blank' /* v-evergreen: Meta CAPI endpoint, dataset id, and access token removed from this public asset */, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Proof gallery ---------- */
  function galleryRow() {
    var row = '';
    for (var i = 0; i < GALLERY.length; i++) {
      row += '<img class="ffg-gallery__img" src="' + esc(GALLERY[i]) +
        '" alt="A FramedFantasy portrait, sent in by a customer" loading="lazy" decoding="async" draggable="false">';
    }
    /* Three copies (not two) so the drag wrap stays seamless in BOTH
       directions: while the auto-drift only moves forward, a user can
       fling backward via drag/momentum and I need the row to the left
       of the centered set as well. The mountMarquee runtime computes
       singleSetWidth = scrollWidth / 3 and wraps in [0, 2W]. */
    return '<div class="ffg-gallery__viewport"><div class="ffg-gallery__track" data-ffg-marquee>' + row + row + row + '</div></div>';
  }
  function statsHTML() {
    return '<div class="ffg-gallery__stats">' +
      '<span>' + esc(TRUST.reviews || '500 plus') + ' five star reviews</span>' +
      '<span>' + esc(TRUST.commissions || '1000 plus') + ' commissions since ' + esc(TRUST.year || '2012') + '</span>' +
      '<span>Two weeks to a first painting</span>' +
      '</div>';
  }
  function galleryHTML() {
    /* The old numeric trust stats row was removed in this pass. The
       photos themselves carry the proof now, and Loox reviews mount
       further down the page for the hard social-proof layer. */
    if (!GALLERY.length) return '';
    return '<div class="ffg-gallery">' +
      /* The mobile-only <br> forces a line break between "Real portraits,"
         and "real homes" so the headline reads as two centered phrases
         on phones. Desktop keeps it on one line via the CSS rule that
         hides .ffg-br-mobile at the desktop breakpoint. */
      '<p class="ffg-gallery__head">Real portraits,<br class="ffg-br-mobile"> real players</p>' +
      '<p class="ffg-gallery__sub">Sent in by the people I painted them for</p>' +
      galleryRow() + '</div>';
  }
  /* A heading free scrolling band of the same proof photos, used on the
     intro screen. Uses the fixed CDN urls, so it always shows. */
  function galleryBand() {
    if (!GALLERY.length) return '';
    return '<div class="ffg-gallery ffg-gallery--band">' + galleryRow() + '</div>';
  }

  /* ---------- Sample archetype deck (working carousel) ----------
     Same model as the character quest "What other players got"
     carousel: each card's transform is computed from its offset to
     the centered index, side cards are clickable to recenter, arrow
     buttons step prev/next, and horizontal touch swipes paginate.
     The order is fixed so that noble_knight sits at index 2, which
     is the initial center. The flanking spread balances the fan
     visually (gold bard + spellcaster nearest, barbarian + ranger
     outer). Mount happens via mountDecks() after every paint. */
  function deckHTML() {
    /* v26: the deck no longer shows the eight named archetypes (a
       result the quiz no longer gives). It is now a carousel of real
       customer portraits, framed as the kind of painting he ends up
       with. Proof, not a dead feature. Cards are image-only and pull
       from the same GALLERY photo list as the proof strip. If there
       are no photos, the deck is skipped entirely. */
    var pics = (GALLERY && GALLERY.length) ? GALLERY.slice(0, 8) : [];
    if (pics.length < 3) return '';
    var initialIdx = Math.floor(pics.length / 2);
    var cards = '';
    for (var i = 0; i < pics.length; i++) {
      cards += '<div class="ffg-deck__card ffg-deck__card--photo" data-ffg-deck-card="' + i + '">' +
        '<div class="ffg-deck__card-img"><img src="' + esc(pics[i]) + '" alt="A FramedFantasy portrait in a customer home" decoding="async" loading="lazy" draggable="false"></div>' +
        '<p class="ffg-deck__card-foot">FRAMEDFANTASY</p>' +
      '</div>';
    }
    return '<div class="ffg-deck ffg-deck--proof">' +
      '<p class="ffg-deck__head">The portrait they keep</p>' +
      '<p class="ffg-deck__sub">Real portraits I painted, every one of them theirs to keep.</p>' +
      '<div class="ffg-deck__area" data-ffg-deck data-ffg-deck-init="' + initialIdx + '">' +
        '<button type="button" class="ffg-deck__arrow ffg-deck__arrow--prev" data-ffg-deck-arrow="prev" aria-label="Previous portrait">&lsaquo;</button>' +
        '<div class="ffg-deck__fan">' + cards + '</div>' +
        '<button type="button" class="ffg-deck__arrow ffg-deck__arrow--next" data-ffg-deck-arrow="next" aria-label="Next portrait">&rsaquo;</button>' +
      '</div>' +
    '</div>';
  }

  /* ---------- Deck carousel runtime ----------
     Ported from character-quest.js, translated to vanilla. For each
     card we compute raw = i - idx, wrap raw to [-n/2, n/2], then
     branch on absOff: 0 center, 1 flanking, 2 outer, >2 hidden. The
     transforms are written inline so the same elements re-flow into
     their new slots when idx changes, the CSS transition handles the
     slide. Mount is idempotent via data-ffg-deck-ready. */
  /* ---------- Loox reviews teleport ----------
     Locates the Loox section anywhere on the page (regardless of how
     Shopify named the wrapper, which can vary between direct JSON
     edits and theme editor additions) and moves it into the result
     screen mount. The selector ladder tries, in order:
       1. The exact id we expect from JSON edits (#shopify-section-loox_reviews)
       2. Any shopify-section whose id contains "loox"
       3. Any shopify-section that contains a Loox widget descendant
     Loox populates widgets on page load, so by the time the result
     screen paints we're just relocating an already rendered node.
     Retry once after 400 ms in case Loox injected late. */
  /* Hunts the Loox section in the DOM. When the merchant adds the
     Loox block via the Shopify theme editor, Shopify assigns the
     wrapper a random hash id like shopify-section-1779383151f64ec88e
     so we cannot rely on the literal name. We try the most specific
     selectors first, then fall back to "any shopify-section that is
     not the FFQ main section and is not theme chrome." Every
     candidate must pass an ancestor check via Node.contains: if the
     candidate already contains the mount point, appending it into
     the mount would create a DOM cycle and throw
     HierarchyRequestError. That happens for shopify-section-main
     (the FFQ's own wrapper) and for any section-group wrapper that
     wraps main. We just skip those silently and keep looking. */
  function findLooxSection(mount) {
    /* Helper: a candidate is safe to move into the mount only when
       it is not the mount itself AND it does not contain the mount. */
    function safe(node) {
      if (!node) return false;
      if (node === mount) return false;
      if (node.contains && node.contains(mount)) return false;
      return true;
    }
    var literal = document.getElementById('shopify-section-loox_reviews');
    if (safe(literal)) return literal;
    var byId = document.querySelector('[id^="shopify-section-"][id*="loox" i]');
    if (safe(byId)) return byId;
    var sects = document.querySelectorAll('[id^="shopify-section-"]');
    var EXCLUDE = {
      'shopify-section-main': 1,
      'shopify-section-header': 1,
      'shopify-section-footer': 1,
      'shopify-section-announcement-bar': 1
    };
    /* Pass A: any safe section containing a Loox descendant. */
    for (var i = 0; i < sects.length; i++) {
      var a = sects[i];
      if (EXCLUDE[a.id] || !safe(a)) continue;
      if (a.querySelector('[id*="loox" i], [class*="loox" i], [data-loox]')) return a;
    }
    /* Pass B: any safe non-chrome shopify-section that isn't the
       FFQ section. Catches the case where Loox's JS hasn't yet
       injected its markup but the Shopify-rendered apps section
       wrapper exists. */
    for (var j = 0; j < sects.length; j++) {
      var b = sects[j];
      if (EXCLUDE[b.id] || !safe(b)) continue;
      if (/announcement|hoh-announcement/i.test(b.id || '')) continue;
      return b;
    }
    return null;
  }
  function revealLooxSection(section) {
    /* Force the moved section visible regardless of any inline or
       computed styles that may have hidden it in its previous spot
       (e.g. our older :has based CSS, or Shopify chrome rules). */
    section.style.display = 'block';
    section.style.visibility = 'visible';
    section.style.height = 'auto';
    section.style.overflow = 'visible';
    section.style.pointerEvents = 'auto';
    section.style.opacity = '1';
    section.removeAttribute('aria-hidden');
  }
  function mountLoox() {
    var mount = document.getElementById('ffg-loox-mount');
    if (!mount || mount.dataset.ffgLooxMounted === '1') return;
    var section = findLooxSection(mount);
    if (section) {
      mount.appendChild(section);
      revealLooxSection(section);
      mount.dataset.ffgLooxMounted = '1';
      return;
    }
    /* Retry once for slow Loox injection. */
    setTimeout(function () {
      var m2 = document.getElementById('ffg-loox-mount');
      if (!m2 || m2.dataset.ffgLooxMounted === '1') return;
      var s2 = findLooxSection(m2);
      if (s2) {
        m2.appendChild(s2);
        revealLooxSection(s2);
        m2.dataset.ffgLooxMounted = '1';
      }
    }, 600);
  }
  function mountDecks(scope) {
    var decks = (scope || document).querySelectorAll('[data-ffg-deck]');
    for (var i = 0; i < decks.length; i++) {
      var d = decks[i];
      if (d.dataset.ffgDeckReady === '1') continue;
      d.dataset.ffgDeckReady = '1';
      initDeck(d);
    }
  }
  function initDeck(area) {
    var cards = area.querySelectorAll('[data-ffg-deck-card]');
    var n = cards.length;
    if (!n) return;
    var idx = parseInt(area.getAttribute('data-ffg-deck-init'), 10);
    if (isNaN(idx) || idx < 0 || idx >= n) idx = Math.floor(n / 2);
    var touchStartX = 0, touchEndX = 0;
    /* Per-breakpoint translate distances. Match the CSS card width so
       the flanking and outer cards sit just past the edge of center.
       v3.6: cards grew wider (152/168/196 from 130/144/174) when the
       painting image and pull quote were added, so the distances grew
       proportionally to keep the fan visually balanced. */
    function dist() {
      var w = window.innerWidth || 360;
      if (w >= 750) return { inner: 134, outer: 235 };
      if (w >= 420) return { inner: 112, outer: 196 };
      return { inner: 86, outer: 146 };
    }
    function apply() {
      var d = dist();
      for (var i = 0; i < n; i++) {
        var card = cards[i];
        var raw = i - idx;
        var off = raw;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        var absOff = Math.abs(off);
        if (absOff > 2) {
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
          card.style.transform = 'translate(-50%, -50%) scale(0.4)';
          card.style.zIndex = '0';
          continue;
        }
        var x, scale, rot, z, op, clickable;
        if (absOff === 0) {
          x = 0; scale = 1; rot = 0; z = 10; op = 1; clickable = false;
        } else if (absOff === 1) {
          x = off > 0 ? d.inner : -d.inner;
          scale = 0.72; rot = off > 0 ? 8 : -8; z = 8; op = 0.85; clickable = true;
        } else {
          x = off > 0 ? d.outer : -d.outer;
          scale = 0.52; rot = off > 0 ? 16 : -16; z = 6; op = 0.55; clickable = true;
        }
        card.style.transform = 'translate(-50%, -50%) translateX(' + x + 'px) scale(' + scale + ') rotate(' + rot + 'deg)';
        card.style.zIndex = String(z);
        card.style.opacity = String(op);
        card.style.pointerEvents = clickable ? 'auto' : 'none';
        card.style.cursor = clickable ? 'pointer' : 'default';
      }
    }
    function setIdx(t) { if (t < 0 || t >= n || t === idx) return; idx = t; apply(); }
    function next() { idx = (idx + 1) % n; apply(); }
    function prev() { idx = (idx - 1 + n) % n; apply(); }
    /* Click on a side card brings it to center. */
    for (var ci = 0; ci < n; ci++) {
      (function (target) {
        cards[target].addEventListener('click', function () { setIdx(target); });
      })(ci);
    }
    var prevBtn = area.querySelector('[data-ffg-deck-arrow="prev"]');
    var nextBtn = area.querySelector('[data-ffg-deck-arrow="next"]');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });
    /* Touch swipe, same 40 px threshold as the quest. */
    area.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) {
        touchStartX = e.touches[0].clientX;
        touchEndX = e.touches[0].clientX;
      }
    }, { passive: true });
    area.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) touchEndX = e.touches[0].clientX;
    }, { passive: true });
    area.addEventListener('touchend', function () {
      var dx = touchEndX - touchStartX;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
      touchStartX = 0; touchEndX = 0;
    }, { passive: true });
    /* Recompute distances on resize so the spread tracks the breakpoint. */
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(apply, 120);
    }, { passive: true });
    apply();
  }

  /* ---------- Marquee runtime (auto drift + drag + momentum) ----------
     Same model as the homepage ss-scrolling-images section: a transform
     based marquee with three rows, an auto leftward drift, mouse drag on
     desktop and touch swipe on mobile, and exponential momentum decay on
     release. I intentionally do not import from the homepage section,
     this is a self contained copy so the quiz can evolve independently
     and there is no risk of touching the homepage at all. Each viewport
     is mounted at most once via a dataset flag, and the RAF loop self
     terminates when the track is removed from the DOM. */
  function mountMarquees(scope) {
    var tracks = (scope || document).querySelectorAll('[data-ffg-marquee]');
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (track.dataset.ffgMarqueeReady === '1') continue;
      track.dataset.ffgMarqueeReady = '1';
      initMarquee(track);
    }
  }
  function initMarquee(track) {
    var state = {
      position: 0,
      velocity: 0,
      singleSetWidth: 0,
      autoSpeed: 40,                  /* px/sec, matches homepage default */
      isDragging: false,
      dragMoved: false,
      startPointerX: 0,
      startPosition: 0,
      lastPointerX: 0,
      lastPointerTime: 0,
      activePointer: null,
      touchStartY: 0,
      touchHorizontal: false,
      isVisible: true,
      lastFrame: 0
    };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.autoSpeed = 0;
    }
    function measure() {
      var w = track.scrollWidth;
      if (w > 0) state.singleSetWidth = w / 3;
    }
    function applyTransform() {
      track.style.transform = 'translate3d(' + (-state.position).toFixed(2) + 'px, 0, 0)';
    }
    function ready() {
      measure();
      /* Start at the middle copy so dragging backward has runway. */
      state.position = state.singleSetWidth;
      applyTransform();
      bind();
      loop();
    }
    function dragStart(clientX, pointerId) {
      state.isDragging = true;
      state.dragMoved = false;
      state.velocity = 0;
      state.startPointerX = clientX;
      state.startPosition = state.position;
      state.lastPointerX = clientX;
      state.lastPointerTime = performance.now();
      state.activePointer = pointerId;
      if (pointerId != null && track.setPointerCapture) {
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
    }
    function dragUpdate(clientX) {
      if (!state.isDragging) return;
      var dx = clientX - state.startPointerX;
      if (!state.dragMoved && Math.abs(dx) >= 5) {
        state.dragMoved = true;
        track.classList.add('is-dragging');
      }
      if (!state.dragMoved) return;
      state.position = state.startPosition - dx;
      applyTransform();
      var now = performance.now();
      var dt = now - state.lastPointerTime;
      if (dt > 0) state.velocity = -((clientX - state.lastPointerX) / dt) * 1000;
      state.lastPointerX = clientX;
      state.lastPointerTime = now;
    }
    function dragEnd() {
      if (!state.isDragging) return;
      state.isDragging = false;
      track.classList.remove('is-dragging');
      if (state.activePointer != null && track.releasePointerCapture) {
        try { track.releasePointerCapture(state.activePointer); } catch (_) {}
      }
      state.activePointer = null;
    }
    function bind() {
      /* Desktop pointer (mouse only). Touch and pen go through the touch
         listeners below so I can do the vertical scroll heuristic. */
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          if (e.button !== 0) return;
          dragStart(e.clientX, e.pointerId);
        });
        track.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          dragUpdate(e.clientX);
        });
        var endPtr = function (e) {
          if (e.pointerType === 'touch' || e.pointerType === 'pen') return;
          dragEnd();
        };
        track.addEventListener('pointerup', endPtr);
        track.addEventListener('pointercancel', endPtr);
      }
      /* Touch: stay passive and let the page scroll vertically until I
         confirm horizontal intent. Once horizontal wins, drag takes
         over, but I never call preventDefault so the page never
         scroll jacks. */
      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        state.touchStartY = t.clientY;
        state.touchHorizontal = false;
        dragStart(t.clientX, null);
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (!state.isDragging) return;
        var t = e.touches[0];
        if (!state.touchHorizontal) {
          var dxAbs = Math.abs(t.clientX - state.startPointerX);
          var dyAbs = Math.abs(t.clientY - state.touchStartY);
          if (dxAbs < 8 && dyAbs < 8) return;
          if (dyAbs > dxAbs) {
            state.isDragging = false;
            state.dragMoved = false;
            track.classList.remove('is-dragging');
            return;
          }
          state.touchHorizontal = true;
        }
        dragUpdate(t.clientX);
      }, { passive: true });
      var touchEnd = function () { if (state.isDragging) dragEnd(); };
      track.addEventListener('touchend', touchEnd, { passive: true });
      track.addEventListener('touchcancel', touchEnd, { passive: true });
      /* Eat the post drag click so a fling does not also open an image. */
      track.addEventListener('click', function (e) {
        if (state.dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          state.dragMoved = false;
        }
      }, true);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          state.isVisible = entries[0].isIntersecting;
        }, { threshold: 0, rootMargin: '200px' });
        io.observe(track);
      }
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var oldW = state.singleSetWidth;
          measure();
          if (oldW > 0 && state.singleSetWidth > 0) {
            state.position = (state.position / oldW) * state.singleSetWidth;
          }
        }, 200);
      }, { passive: true });
    }
    function loop() {
      state.lastFrame = performance.now();
      function tick(now) {
        /* If the screen got repainted, the track is gone from the DOM
           and innerHTML cleared my listeners. Stop the loop so I do
           not leak RAFs across navigations. */
        if (!track.isConnected) return;
        var dt = (now - state.lastFrame) / 1000;
        state.lastFrame = now;
        if (dt > 0.1) dt = 0.016;
        if (state.isVisible && !state.isDragging) {
          /* If the track was measured while hidden (e.g. the two-phase reveal mounts
             the reviews carousel inside a display:none column), singleSetWidth is 0
             and the wrap below never runs, so it would scroll off into a black gap.
             Re-measure once it has width and snap to the middle copy before moving. */
          if (state.singleSetWidth <= 0) {
            measure();
            if (state.singleSetWidth > 0) { state.position = state.singleSetWidth; }
          }
          if (state.singleSetWidth <= 0) { requestAnimationFrame(tick); return; }
          state.position += state.autoSpeed * dt;
          if (Math.abs(state.velocity) > 1) {
            state.position += state.velocity * dt;
            state.velocity *= Math.pow(0.94, dt * 60);
          } else {
            state.velocity = 0;
          }
          if (state.singleSetWidth > 0) {
            while (state.position > 2 * state.singleSetWidth) {
              state.position -= state.singleSetWidth;
              state.startPosition -= state.singleSetWidth;
            }
            while (state.position < 0) {
              state.position += state.singleSetWidth;
              state.startPosition += state.singleSetWidth;
            }
          }
          applyTransform();
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    /* Wait for images to load so scrollWidth is accurate. If document
       is already complete I still wait a microtask to let layout flush. */
    if (document.readyState === 'complete') {
      setTimeout(ready, 0);
    } else {
      window.addEventListener('load', ready, { once: true });
    }
  }

  /* ============================================================
     APP SHELL
     ============================================================ */
  function buildShell() {
    root.innerHTML = '';
    var app = h(
      '<div class="ffg-app">' +
        '<div class="ffg-topbar">' +
          '<div class="ffg-progress" id="ffg-progress" aria-hidden="true"></div>' +
          '<button type="button" class="ffg-mute" id="ffg-mute" aria-label="Toggle music" aria-pressed="false">' +
            '<svg class="ffg-mute__on" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8a5 5 0 010 8M18.5 5.5a8 8 0 010 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>' +
            '<svg class="ffg-mute__off" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8l6 8M22 8l-6 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ffg-stage"><div class="ffg-screen" id="ffg-screen"></div></div>' +
      '</div>'
    );
    root.appendChild(app);
    bindMuteToggle();
  }
  function bindMuteToggle() {
    var btn = document.getElementById('ffg-mute');
    if (!btn) return;
    function reflect() {
      var m = audioMgr.muted;
      btn.classList.toggle('is-muted', m);
      btn.setAttribute('aria-pressed', m ? 'true' : 'false');
      btn.setAttribute('aria-label', m ? 'Unmute music' : 'Mute music');
    }
    audioMgr.muted = audioMgr.isMuted();
    reflect();
    btn.addEventListener('click', function () {
      audioMgr.setMuted(!audioMgr.muted);
      reflect();
    });
  }
  function renderProgress() {
    var p = document.getElementById('ffg-progress');
    if (!p) return;
    if (state.view === 'quiz') {
      p.textContent = 'Question ' + (state.step + 1) + ' of ' + QUESTIONS.length;
    } else {
      /* Breath, intro, beat, and result all read as no progress label. */
      p.textContent = '';
    }
  }
  function screenEl() { return document.getElementById('ffg-screen'); }

  function paint(html, instant, afterBuild) {
    var screen = screenEl();
    function build() {
      screen.innerHTML = html;
      delete screen.dataset.locked;
      renderProgress();
      try { window.scrollTo(0, 0); } catch (e) {}
      try { if (root) root.scrollTop = 0; } catch (e) {}
      void screen.offsetWidth;
      screen.classList.remove('is-hidden');
      /* Activate any gallery marquees that the new HTML just inserted.
         Self-skips tracks already mounted on a prior paint. */
      mountMarquees(screen);
      /* Same idempotent mount for the archetype deck carousel. */
      mountDecks(screen);
      if (afterBuild) afterBuild();
    }
    if (instant) { build(); return; }
    screen.classList.add('is-hidden');
    setTimeout(build, T_FADE);
  }

  /* ============================================================
     INTRO SCREEN
     ============================================================ */
  /* v3 landing: matches the Character Quest landing format.
     Hero image at top → eyebrow label → headline → subhead → primary
     CTA → CTA note → "What do I get?" expander → deck carousel →
     deck hint → photo strip → final proof → bottom CTA → bullets.
     No recipient picker here. The recipient picker is now Q1 inside
     the quiz flow. */
  function introHeroImageHTML() {
    var url = (CONFIG && CONFIG.introHero) || '';
    if (!url) return '';
    return '<div class="ffg-intro__hero"><img src="' + esc(url) +
      '" alt="" aria-hidden="true" decoding="async" loading="eager"></div>';
  }
  function ctaButtonHTML(id, label, variant) {
    /* variant: 'primary' (default) = full gold gradient with shimmer
       and pulse animation. 'quiet' = same gold body, no shimmer span,
       no pulse animation — used for the secondary CTA below the
       photo strip so it does not visually compete with the primary
       above the fold. */
    var quiet = variant === 'quiet';
    var cls = 'ffg-continue ffg-continue--hero' + (quiet ? ' ffg-continue--hero-quiet' : '');
    return '<button type="button" class="' + cls + '" id="' + esc(id) + '">' +
      (quiet ? '' : '<span class="ffg-continue__shimmer" aria-hidden="true"></span>') +
      '<span class="ffg-continue__label">' + esc(label) + ' <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
    '</button>';
  }
  function introHTML() {
    return '<div class="ffg-intro">' +
      introHeroImageHTML() +
      '<p class="ffg-intro__eyebrow">' + esc(EYEBROW_LABEL) + '</p>' +
      '<h1 class="ffg-intro__headline">' + headlineHTML(HEADLINES[state.headlineVariant] || HEADLINES.A) + '</h1>' +
      '<p class="ffg-intro__sub">' + SUBHEAD + '</p>' +
      '<p class="ffg-intro__sub">It is not a card they read and set aside. They open it, and their character starts to come to life.</p>' +
      /* Photo strip — sliding band of customer portraits. Sits right
         under the subhead so the social proof lands before the CTA
         instead of buried at the bottom of the page. */
      galleryBand() +
      ctaButtonHTML('ffg-intro-cta', 'Make their card', 'primary') +
      '<p class="ffg-intro__ctanote">' + esc(CTA_NOTE) + '</p>' +
      /* Deck carousel ("one of these eight is him"). */
      deckHTML() +
      '<p class="ffg-intro__deckhint">Swipe or use arrows to browse</p>' +
      '<p class="ffg-intro__finalproof">' + FINAL_PROOF + '</p>' +
      ctaButtonHTML('ffg-intro-cta2', 'Make their card', 'quiet') +
      '<p class="ffg-intro__bullets">Their character, captured in a portrait they keep forever.</p>' +
      '</div>';
  }
  function bindIntro() {
    var screen = screenEl();
    var ctaA = screen.querySelector('#ffg-intro-cta');
    var ctaB = screen.querySelector('#ffg-intro-cta2');

    /* Single shared start handler. Either CTA invokes it. There is no
       recipient pre-pick here in v3 — Q1 inside the quiz captures
       recipient. */
    function startQuiz() {
      if (screen.dataset.locked) return;
      screen.dataset.locked = '1';
      state.view = 'quiz';
      state.step = 0;
      save();
      preloadQuestionImages();
      /* First confirmed user interaction. Unlock and start BGM so the
         browser autoplay policy lets the audio actually play. */
      audioMgr.unlock();
      audioMgr.playBGM();
      /* v3: QuizStarted fires on homepage CTA click, BEFORE any
         answer. recipient field is empty at this point — Q1 will
         populate it next. */
      trackOnce('started', function () {
        fbTrack('QuizStarted', { content_name: 'Gift Quiz Evergreen', headline_variant: state.headlineVariant });
        gaTrack('quiz_start', { headline_variant: state.headlineVariant });
      });
      paintQuestion();
    }
    /* v-evergreen the fast-track gate. A first-time visitor sees the gift-only
       warning rise up and must acknowledge it before the quiz opens. Once
       acknowledged (persisted), the CTA starts the quiz straight away. */
    function maybeStart() {
      if (state.gateAck) { startQuiz(); return; }
      showGiftGate(startQuiz);
    }
    if (ctaA) ctaA.addEventListener('click', maybeStart);
    if (ctaB) ctaB.addEventListener('click', maybeStart);
  }
  /* v-evergreen the honest fast-track gate. The card jumps the public waitlist,
     so before the quiz opens we set the expectation once: this is for genuine
     gifts. It fades and rises over a dim backdrop and the visitor must
     acknowledge to begin. Built on #ffg-root (no transform there) so the fixed
     overlay centres on the real viewport, the same pattern as the reveal. */
  function buildGiftGate() {
    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="ffg-gate" id="ffg-gate" role="dialog" aria-modal="true" aria-labelledby="ffg-gate-title">' +
        '<div class="ffg-gate__backdrop" id="ffg-gate-backdrop"></div>' +
        '<div class="ffg-gate__card" role="document" tabindex="-1">' +
          '<span class="ffg-gate__crest" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M12 3 4 6v5c0 4.5 3.2 7.9 8 9 4.8-1.1 8-4.5 8-9V6l-8-3Z"/><path d="M9.3 12l1.9 1.9 3.5-3.7"/>' +
            '</svg>' +
          '</span>' +
          '<h2 class="ffg-gate__title" id="ffg-gate-title">One thing before you start</h2>' +
          '<p class="ffg-gate__body">This gift skips the waitlist. The recipient goes straight to the front while everyone else waits.</p>' +
          '<p class="ffg-gate__body">I hold these front spots for gifts and the occasions that should not wait. If you are here for someone you love, you are in the right place.</p>' +
          '<p class="ffg-gate__pledge">Some moments are worth jumping the line for.</p>' +
          '<div class="ffg-gate__actions">' +
            '<button type="button" class="ffg-gate__ok" id="ffg-gate-ok">This is a gift, let’s start</button>' +
            '<a class="ffg-gate__cancel" id="ffg-gate-cancel" href="https://framedfantasy.com/products/fantasy-character-commission">Buying for yourself? Join the waitlist</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    return wrap.firstChild;
  }
  function showGiftGate(onAccept) {
    var root = document.getElementById('ffg-root') || screenEl();
    if (!root || document.getElementById('ffg-gate')) return;
    /* the intro screen blurs while the gate is up. Never blur the element we
       mount into, or the gate would blur itself. */
    var blurTarget = document.getElementById('ffg-screen');
    if (blurTarget === root) blurTarget = null;
    var node = buildGiftGate();
    root.appendChild(node);
    var card = node.querySelector('.ffg-gate__card');
    var okBtn = node.querySelector('#ffg-gate-ok');
    var noBtn = node.querySelector('#ffg-gate-cancel');
    var backdrop = node.querySelector('#ffg-gate-backdrop');
    var done = false;
    function close(accepted) {
      if (done) return; done = true;
      if (blurTarget) blurTarget.classList.remove('ffg-bg-blur');
      node.classList.remove('is-in');
      node.classList.add('is-out');
      var finish = function () {
        if (node.parentNode) node.parentNode.removeChild(node);
        if (accepted && typeof onAccept === 'function') onAccept();
      };
      if (reducedMotion()) finish(); else setTimeout(finish, 240);
    }
    if (okBtn) okBtn.addEventListener('click', function () { state.gateAck = true; save(); close(true); });
    /* the secondary action is a real link to the public waitlist, so it just
       navigates. The backdrop and Esc still dismiss back to the intro. */
    if (backdrop) backdrop.addEventListener('click', function () { close(false); });
    node.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(false); return; }
      if (e.key === 'Tab') {
        var f = [okBtn, noBtn].filter(Boolean);
        if (!f.length) return;
        e.preventDefault();
        var idx = f.indexOf(document.activeElement);
        var next = e.shiftKey ? (idx <= 0 ? f.length - 1 : idx - 1) : (idx >= f.length - 1 ? 0 : idx + 1);
        try { f[next].focus(); } catch (er) {}
      }
    });
    /* rise + fade in on the next frame so the transition actually runs, and blur
       the intro behind it at the same time */
    if (reducedMotion()) { node.classList.add('is-in'); if (blurTarget) blurTarget.classList.add('ffg-bg-blur'); }
    else { requestAnimationFrame(function () { requestAnimationFrame(function () { node.classList.add('is-in'); if (blurTarget) blurTarget.classList.add('ffg-bg-blur'); }); }); }
    try { (okBtn || card).focus(); } catch (e) {}
  }
  function goToIntro(instant) {
    if (state.cardBuilt) { renderBuilder(); return; }
    state.view = 'intro';
    save();
    paint(introHTML(), !!instant, bindIntro);
  }

  /* ============================================================
     QUESTION SCREENS
     ============================================================ */
  /* The hero image at the top of a question comes only from the theme editor.
     Lookup is by question.key (not position) so reordering QUESTIONS never
     swaps images, and every question maps to its own slot through IMG_SLOT. */
  function questionHeroURL(idx) {
    var q = QUESTIONS[idx];
    if (!q) return '';
    var slot = IMG_SLOT[q.key];
    return (slot && Q_IMAGES[slot]) || '';
  }
  /* The matching video sources [{url, type}, ...] for the question's slot, or an
     empty array if none is set. A set video replaces the image, and the image
     becomes its poster. */
  function questionHeroVideoSources(idx) {
    var q = QUESTIONS[idx];
    if (!q) return [];
    var slot = IMG_SLOT[q.key];
    return (slot && Q_VIDEOS[slot]) || [];
  }
  function inEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }
  /* Editor only. When a question has no image set, show a note in the
     Shopify theme editor naming the slot to fill, plus a one line
     status of the config the quiz actually received. Customers never
     see this, it is gated on Shopify designMode. */
  function editorHeroNote(idx) {
    var q = QUESTIONS[idx];
    var keyToLabel = {
      occasion: 'Q1 image, what are you celebrating',
      stance: 'Q2 image, part of their world',
      recipient: 'Q3 image, who is it for',
      his_name: 'Q4 image, their name and yours',
      his_world: 'Q5 image, the world they disappear into',
      his_character: 'Q6 image, a character they come back to',
      the_notice: 'Q7 image, who they are underneath',
      the_detail: 'Q8 image, one thing you love about them'
    };
    var label = (q && keyToLabel[q.key]) || 'Question image';
    var qi = CONFIG.questionImages || {};
    var diag = 'config ' + (CONFIG_OK ? 'loaded' : 'FAILED TO PARSE') +
      '   occasion ' + (qi.occasion ? 'set' : 'empty') +
      '   stance ' + (qi.stance ? 'set' : 'empty') +
      '   recipient ' + (qi.recipient ? 'set' : 'empty') +
      '   q3 ' + (qi.q3 ? 'set' : 'empty') +
      '   q1 ' + (qi.q1 ? 'set' : 'empty') +
      '   q4 ' + (qi.q4 ? 'set' : 'empty') +
      '   q6 ' + (qi.q6 ? 'set' : 'empty') +
      '   detail ' + (qi.detail ? 'set' : 'empty');
    var box = 'border:1px dashed rgba(201,168,76,.55);border-radius:12px;padding:20px 18px;text-align:center;';
    return '<div class="ffg-qhero" style="' + box + '">' +
      '<div style="font-family:Cinzel,serif;color:#c9a84c;font-size:15px;letter-spacing:.04em;">' +
        esc(label) + '</div>' +
      '<div style="color:#9a93a6;font-size:13px;margin-top:6px;">' +
        'Set this image in the theme editor under Question images. Only the editor shows this note.</div>' +
      '<div style="color:#6f6a7d;font-size:11px;margin-top:10px;font-family:monospace;">' +
        esc(diag) + '</div>' +
    '</div>';
  }
  function questionHTML(idx) {
    var q = QUESTIONS[idx];
    var html = '<button type="button" class="ffg-back" id="ffg-back">' +
      '<span class="ffg-back__arrow">&larr;</span> Back</button>';
    var hero = questionHeroURL(idx);
    var vidSources = questionHeroVideoSources(idx);
    if (vidSources.length) {
      /* Video wins. autoplay + muted + playsinline is the only combo
         that actually auto-starts on iOS and modern Chrome. preload
         "auto" is fine because I steer merchants to sub 2 MB clips, so
         the file lands quickly and starts on its own once metadata is
         ready. The image, if also set, becomes the poster so the still
         shows instantly during the first buffer fill. Multiple sources
         are emitted in order so the browser picks the first it can
         play. */
      html += '<div class="ffg-qhero">';
      html += '<video class="ffg-qhero__video" autoplay muted loop playsinline preload="auto" disableremoteplayback';
      if (hero) html += ' poster="' + esc(hero) + '"';
      html += '>';
      for (var vi = 0; vi < vidSources.length; vi++) {
        var s = vidSources[vi];
        if (s && s.url) {
          html += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      html += '</video></div>';
    } else if (hero) {
      html += '<div class="ffg-qhero"><img src="' + esc(hero) + '" alt="" aria-hidden="true" decoding="async"></div>';
    } else if (inEditor()) {
      html += editorHeroNote(idx);
    } else {
      /* v37.2 every question shows a real image. With no uploaded image we drop
         in a portfolio placeholder (Jan asked for placeholder images even if not
         the exact one for that question) so the slot is never an empty frame. */
      html += questionPlaceholderImgHTML(idx);
    }
    /* v-evergreen the_detail shows a rotating prompt (the refresh icon changes
       it) and its guidance line lives above the textarea, so the static micro is
       suppressed here for that question. The stem gets an id so the refresh can
       swap it in place without repainting the screen. */
    var headStem = q.stem, headMicro = q.micro;
    if (q.key === 'the_detail') { headStem = activeDetailPrompt().stem; headMicro = ''; }
    /* v-evergreen2 the personality question asks about one person. For a group
       recipient (a whole family or a D&D party) it reads better as a question about
       the crew, so swap the title. The cards still work as group vibes. */
    if (q.key === 'the_notice' && pron().group) { headStem = 'What is this crew like together?'; }
    html += '<h1 class="ffg-question" id="ffg-qstem">' + esc(headStem) + '</h1>';
    if (headMicro) html += '<p class="ffg-micro">' + esc(headMicro) + '</p>';

    /* v34 names branch (his_name). Two fields, his and hers, so she sees
       she is filling in both names for a card from her to him. Both go onto
       the card and both are optional, so Continue is always enabled. */
    /* v-evergreen occasion branch. A type-or-pick control modeled on the
       Character Quest race/class step: one text input plus a wrapped grid of
       quick-pick chips. Tapping a chip fills the input and sets the occasion;
       typing her own words (e.g. "his 40th") both derives the occasion key and
       becomes the detail the AI message uses. Continue commits. Keeps the
       screen short instead of a long stack of full-width rows. */
    if (q.type === 'occasion') {
      var occChipsHTML = '';
      var occOpts = occasionOptions();
      for (var oc = 0; oc < occOpts.length; oc++) {
        var oopt = occOpts[oc];
        var oon = state.occasion === oopt.store ? ' is-on' : '';
        occChipsHTML += '<button type="button" class="ffg-chip' + oon + '" data-occ="' + esc(oopt.store) + '" data-occ-label="' + esc(oopt.label) + '">' + esc(oopt.label) + '</button>';
      }
      html += '<div class="ffg-occ">' +
        '<input class="ffg-input ffg-occ__input" id="ffg-occ-input" type="text" autocomplete="off" maxlength="60" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.occasionText || '') + '">' +
        '<div class="ffg-chips" id="ffg-occ-chips">' + occChipsHTML + '</div>' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-textq-continue">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v-evergreen recipient branch. Same type-or-pick control as occasion. The
       chips cover the common relationships; typing maps her words to a known
       relationship key (so "my girlfriend" or "my brother" resolve to the right
       pronouns and voice). Keeps the screen short. */
    if (q.type === 'recipient') {
      var rcChipsHTML = '';
      for (var rci = 0; rci < q.options.length; rci++) {
        var rcopt = q.options[rci];
        var rcon = state.recipient === rcopt.store ? ' is-on' : '';
        rcChipsHTML += '<button type="button" class="ffg-chip' + rcon + '" data-recip="' + esc(rcopt.store) + '" data-recip-label="' + esc(rcopt.label) + '">' + esc(rcopt.label) + '</button>';
      }
      html += '<div class="ffg-occ">' +
        '<input class="ffg-input ffg-occ__input" id="ffg-recip-input" type="text" autocomplete="off" maxlength="40" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.recipientText || '') + '">' +
        '<div class="ffg-chips" id="ffg-recip-chips">' + rcChipsHTML + '</div>' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-textq-continue">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    if (q.type === 'names') {
      html += '<div class="ffg-textq ffg-textq--names">' +
        '<div class="ffg-field">' +
          '<label class="ffg-field__label" for="ffg-textq-his">Their name</label>' +
          '<input class="ffg-input ffg-textq__input" id="ffg-textq-his" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.hisName || '') + '">' +
        '</div>' +
        '<div class="ffg-field">' +
          '<label class="ffg-field__label" for="ffg-textq-from">Your name</label>' +
          '<input class="ffg-input ffg-textq__input" id="ffg-textq-from" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.fromPlaceholder || 'Your name') + '" value="' + esc(state.fromName || '') + '">' +
        '</div>' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-textq-continue">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v31 text branch (his_name). A single text field plus a Continue
       button, since typing does not auto-advance. The value goes onto the
       card and is optional, so Continue is always enabled. */
    if (q.type === 'text') {
      html += '<div class="ffg-textq">' +
        '<input class="ffg-input ffg-textq__input" id="ffg-textq" type="text" maxlength="24" autocomplete="off" placeholder="' + esc(q.placeholder || '') + '" value="' + esc(state.hisName || '') + '">' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-textq-continue">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v-evergreen longtext branch (the_detail). A textarea with a live
       guidance line that reacts to word count, plus Continue. Optional, so
       Continue is always enabled; the guidance only nudges for a richer
       answer that the AI message then uses. */
    if (q.type === 'longtext') {
      html += '<button type="button" class="ffg-refresh" id="ffg-longq-refresh" aria-label="Try a different question" title="Try a different question">' + refreshGlyph() + '</button>';
      html += '<div class="ffg-textq ffg-textq--long">' +
        '<p class="ffg-longq__hint" id="ffg-longq-hint" aria-live="polite"></p>' +
        '<textarea class="ffg-input ffg-textq__area" id="ffg-longq" rows="5" maxlength="600" autocomplete="off" placeholder="' + esc(q.placeholder || '') + '">' + esc(state.theDetail || '') + '</textarea>' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-textq-continue">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v33 capture branch (send_to). Email required, phone optional, then a
       button that subscribes her and goes to the reveal. */
    if (q.type === 'capture') {
      html += '<div class="ffg-capture">' +
        '<div class="ffg-field">' +
          '<input class="ffg-input ffg-capture__email" id="ffg-capture-email" type="email" autocomplete="email" inputmode="email" placeholder="Your email" value="' + esc(state.email || '') + '">' +
          '<p class="ffg-capture__err" id="ffg-capture-err" hidden></p>' +
        '</div>' +
        '<div class="ffg-field">' +
          '<input class="ffg-input ffg-capture__phone" id="ffg-capture-phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="Your phone, if you want a text too" value="' + esc(state.phone || '') + '">' +
        '</div>' +
      '</div>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-capture-go">' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">Show me the card <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* Multi-select branch (v5 trait_curation). Renders the same option
       button grid as single-select, but:
       - Tracks an array of selected indices in state.answers[idx]
       - Up to q.maxPicks (3) options can be active at once
       - A counter pill shows current/max picks
       - A Continue button enables ONLY when exactly maxPicks are
         selected (per brief "no more, no less"). The brief reorder
         placed the Reframe breath right after this question, so
         advance() does the breath dispatch on Continue. */
    if (q.type === 'multi') {
      var max = q.maxPicks || 3;
      var sel = Array.isArray(state.answers[idx]) ? state.answers[idx] : [];
      html += '<div class="ffg-options ffg-options--multi">';
      for (var mi = 0; mi < q.options.length; mi++) {
        var mon = sel.indexOf(mi) !== -1;
        html += '<button type="button" class="ffg-option ffg-option--multi' + (mon ? ' is-chosen' : '') +
          '" data-mopt="' + mi + '" aria-pressed="' + (mon ? 'true' : 'false') + '">' +
          '<span class="ffg-option__check" aria-hidden="true"></span>' +
          '<span class="ffg-option__text">' + esc(q.options[mi].label) + '</span></button>';
      }
      html += '</div>';
      html += '<p class="ffg-multi__counter" id="ffg-multi-counter" aria-live="polite">' +
        esc(sel.length) + ' of ' + esc(max) + ' picked</p>';
      html += '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-multi-continue"' +
        (sel.length === max ? '' : ' disabled') + '>' +
        '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-continue__label">' + esc(q.continueLabel || 'Continue') +
        ' <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</button>';
      return html;
    }

    /* v-evergreen archetype card layout (the_notice). A universal "who are they"
       grid of emoji + title + subtitle, modeled on the Character Quest. Cards use
       data-opt, so the standard choice binding (highlight + auto-advance) handles
       taps. The picked card's `trait` is what the AI message is built around. */
    if (q.layout === 'cards') {
      html += '<div class="ffg-archgrid">';
      for (var ci = 0; ci < q.options.length; ci++) {
        var co = q.options[ci];
        var con = (state.answers[idx] === ci) ? ' is-chosen' : '';
        html += '<button type="button" class="ffg-arch' + con + '" data-opt="' + ci + '">' +
          '<span class="ffg-arch__emoji" aria-hidden="true">' + esc(co.emoji || '') + '</span>' +
          '<span class="ffg-arch__title">' + esc(co.label || '') + '</span>' +
          (co.sub ? '<span class="ffg-arch__sub">' + esc(co.sub) + '</span>' : '') +
        '</button>';
      }
      html += '</div>';
      return html;
    }

    html += '<div class="ffg-options">';
    for (var i = 0; i < q.options.length; i++) {
      var on = state.answers[idx] === i;
      /* Timing question's Father's Day option carries a small gray
         italic micro line showing the order cutoff. Keyed by the
         semantic question key so the reorder does not move the badge
         onto the wrong option. */
      var extra = '';
      if (q.key === 'timing' && i === 0) {
        extra = '<span class="ffg-option__cutoff">Spots close ' + esc(cutoffLabel()) + '.</span>';
      }
      /* v23: an option can carry a tag (e.g. POPULAR) that renders as
         a small gold ribbon in the corner of the option button. Used
         on the gift_path question to steer toward the Quest Invitation
         path, which is the better-converting D&D-character route. */
      var tag = q.options[i].tag
        ? '<span class="ffg-option__tag">' + esc(q.options[i].tag) + '</span>'
        : '';
      var tagCls = q.options[i].tag ? ' ffg-option--tagged' : '';
      html += '<button type="button" class="ffg-option' + (on ? ' is-chosen' : '') + tagCls +
        '" data-opt="' + i + '">' + tag + '<span class="ffg-option__text">' + esc(q.options[i].label) + extra + '</span></button>';
    }
    html += '</div>';
    /* v37.6 (Change 5) on his_character, the "same one for years" answer is the
       only one that means a single character she might be able to name. Picking
       it reveals this optional name field + Continue in place (wired in
       bindQuestion) instead of auto-advancing. It renders hidden unless that
       option is the current answer, so a resume keeps it open. It is optional,
       so it never blocks. The other three options auto-advance unchanged. */
    if (q.key === 'his_character') {
      var sameIdx = storeIndex(q, 'same');
      var showName = state.answers[idx] === sameIdx;
      html += '<div class="ffg-charname" id="ffg-charname-panel"' + (showName ? '' : ' hidden') + '>' +
        '<input class="ffg-input ffg-charname__input" id="ffg-charname" type="text" maxlength="40" autocomplete="off" placeholder="Their character\'s name" value="' + esc(state.characterName || '') + '">' +
        '<p class="ffg-charname__help">Only if you know it.</p>' +
        '<button type="button" class="ffg-continue ffg-continue--hero" id="ffg-charname-continue">' +
          '<span class="ffg-continue__shimmer" aria-hidden="true"></span>' +
          '<span class="ffg-continue__label">Continue <span class="ffg-continue__arrow" aria-hidden="true">&rarr;</span></span>' +
        '</button>' +
      '</div>';
    }
    return html;
  }
  function bindQuestion(idx) {
    var screen = screenEl();
    var back = screen.querySelector('#ffg-back');
    if (back) back.addEventListener('click', function () { goBack(); });
    var q = QUESTIONS[idx];

    /* v31 text branch (his_name). The name updates state.hisName live and
       Continue (or Enter) records the answer and advances. The name is
       optional, so it never blocks. */
    /* v34 names branch. His name fills the greeting, her name signs the
       card. Enter on his field jumps to hers, Enter on hers (or Continue)
       commits. Both optional, so it never blocks. */
    /* v-evergreen occasion type-or-pick. Chips fill the input and set the key;
       typing derives the key by keyword and keeps her words as the detail.
       Continue commits and advances. Optional (defaults to a warm, dateless
       gift), so it never blocks. */
    if (q && q.type === 'occasion') {
      var occInput = screen.querySelector('#ffg-occ-input');
      var occChips = screen.querySelectorAll('[data-occ]');
      var occCont = screen.querySelector('#ffg-textq-continue');
      /* v-evergreen force a real answer. Continue stays dimmed until she has
         typed something or tapped a chip (a chip also fills the input). */
      var occValid = function () { return !!(occInput && occInput.value.replace(/^\s+|\s+$/g, '') !== ''); };
      var reflectOcc = function () { if (occCont) occCont.disabled = !occValid(); };
      var occLabels = {};
      for (var ol = 0; ol < q.options.length; ol++) { occLabels[q.options[ol].label.toLowerCase()] = true; }
      var mapOcc = function (text) {
        var t = (text || '').toLowerCase();
        if (!t) return '';
        if (/father/.test(t)) return 'fathers_day';
        if (/mother/.test(t)) return 'mothers_day';
        if (/anniversary|years together|years married/.test(t)) return 'anniversary';
        if (/birthday|bday|turning|\b\d{1,3}(st|nd|rd|th)\b/.test(t)) return 'birthday';
        if (/valentine/.test(t)) return 'valentines';
        if (/christmas|xmas|noel|holiday/.test(t)) return 'christmas';
        if (/graduat/.test(t)) return 'graduation';
        if (/wedding|engage|getting married/.test(t)) return 'wedding';
        if (/bbeg|big bad|final boss|boss fight|beat the boss|killed the|slayed/.test(t)) return 'defeated_bbeg';
        if (/fallen|character death|passed away|in memory|memoriam|memorial|tribute|\brip\b|\bdied\b/.test(t)) return 'fallen_hero';
        if (/campaign finale|finale|end of (the )?campaign|final session|last session|campaign wrap|wrapped (the|our) campaign/.test(t)) return 'campaign_finale';
        if (/new campaign|session zero|session 0|new character|new adventure|starting a campaign|kicking off/.test(t)) return 'new_campaign';
        if (/retire/.test(t)) return 'retirement';
        if (/congrat/.test(t)) return 'congratulations';
        if (/thank/.test(t)) return 'thank_you';
        if (/just because|no reason|no occasion/.test(t)) return 'just_because';
        return 'other';
      };
      var occHighlight = function () {
        Array.prototype.forEach.call(occChips, function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-occ') === state.occasion);
        });
      };
      var commitOcc = function () {
        if (screen.dataset.locked || !occValid()) return;
        var text = occInput ? occInput.value.replace(/^\s+|\s+$/g, '') : '';
        state.occasionText = text;
        state.occasion = mapOcc(text) || 'other';
        /* keep her words as the AI detail unless the box is just a bare chip label */
        state.occasionDetail = (text && !occLabels[text.toLowerCase()]) ? text : '';
        screen.dataset.locked = '1';
        state.answers[idx] = state.occasion;
        trackOnce('occasion_selected', function () {
          fbTrack('OccasionSelected', { occasion: state.occasion });
          gaTrack('occasion_selected', { occasion: state.occasion });
        });
        save();
        advance();
      };
      Array.prototype.forEach.call(occChips, function (b) {
        b.addEventListener('click', function () {
          var lbl = b.getAttribute('data-occ-label');
          if (occInput) occInput.value = lbl;
          state.occasionText = lbl;
          state.occasion = b.getAttribute('data-occ');
          occHighlight();
          reflectOcc();
          save();
        });
      });
      if (occInput) {
        occInput.addEventListener('input', function () {
          state.occasionText = occInput.value;
          state.occasion = mapOcc(occInput.value);
          occHighlight();
          reflectOcc();
        });
        occInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitOcc(); }
        });
      }
      if (occCont) occCont.addEventListener('click', commitOcc);
      occHighlight();
      reflectOcc();
      return;
    }

    /* v-evergreen recipient type-or-pick. Chips set the relationship key;
       typing maps her words to a key (girlfriend, brother, etc.). Continue
       commits, sets the group branch, and advances. */
    if (q && q.type === 'recipient') {
      var rcInput = screen.querySelector('#ffg-recip-input');
      var rcChips = screen.querySelectorAll('[data-recip]');
      var rcCont = screen.querySelector('#ffg-textq-continue');
      /* v-evergreen force a real answer, same as occasion. */
      var rcValid = function () { return !!(rcInput && rcInput.value.replace(/^\s+|\s+$/g, '') !== ''); };
      var reflectRc = function () { if (rcCont) rcCont.disabled = !rcValid(); };
      var mapRecip = function (text) {
        var t = (text || '').toLowerCase();
        if (!t) return '';
        if (/wife/.test(t)) return 'wife';
        if (/husband/.test(t)) return 'husband';
        if (/girlfriend/.test(t)) return 'girlfriend';
        if (/boyfriend/.test(t)) return 'boyfriend';
        if (/partner|spouse|fianc/.test(t)) return 'partner';
        if (/mother|\bmom\b|\bmum\b|mama|grandma|grandmother/.test(t)) return 'mom';
        if (/father|\bdad\b|papa|grandpa|grandfather/.test(t)) return 'dad';
        if (/daughter/.test(t)) return 'daughter';
        if (/\bson\b/.test(t)) return 'son';
        if (/sister/.test(t)) return 'sister';
        if (/brother/.test(t)) return 'brother';
        if (/famil/.test(t)) return 'whole_family';
        if (/players|party|\bgroup\b|d&d|dnd|table|campaign/.test(t)) return 'players';
        if (/friend|buddy|bestie|\bpal\b/.test(t)) return 'friend';
        return 'other';
      };
      var rcHighlight = function () {
        Array.prototype.forEach.call(rcChips, function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-recip') === state.recipient);
        });
      };
      var commitRecip = function () {
        if (screen.dataset.locked || !rcValid()) return;
        var text = rcInput ? rcInput.value.replace(/^\s+|\s+$/g, '') : '';
        state.recipientText = text;
        var key = text ? mapRecip(text) : (state.recipient || '');
        if (!key) key = 'other';
        state.recipient = key;
        var pm = RECIPIENT_MAP[key] || RECIPIENT_MAP.other;
        state.branch = pm.group ? 'Family' : 'Standard';
        screen.dataset.locked = '1';
        state.answers[idx] = key;
        trackOnce('recipient_selected', function () {
          fbTrack('RecipientSelected', { recipient: recipientObj().map });
          gaTrack('recipient_selected', { recipient: state.recipient });
        });
        save();
        advance();
      };
      Array.prototype.forEach.call(rcChips, function (b) {
        b.addEventListener('click', function () {
          var lbl = b.getAttribute('data-recip-label');
          if (rcInput) rcInput.value = lbl;
          state.recipientText = lbl;
          state.recipient = b.getAttribute('data-recip');
          rcHighlight();
          reflectRc();
          save();
        });
      });
      if (rcInput) {
        rcInput.addEventListener('input', function () {
          state.recipientText = rcInput.value;
          state.recipient = mapRecip(rcInput.value);
          rcHighlight();
          reflectRc();
        });
        rcInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitRecip(); }
        });
      }
      if (rcCont) rcCont.addEventListener('click', commitRecip);
      rcHighlight();
      reflectRc();
      return;
    }

    if (q && q.type === 'names') {
      var hisEl = screen.querySelector('#ffg-textq-his');
      var fromNameEl = screen.querySelector('#ffg-textq-from');
      var contN = screen.querySelector('#ffg-textq-continue');
      /* v-evergreen force their name (it goes on the front of the card). Your
         own name stays optional, the sign-off has a graceful fallback. */
      var nameValid = function () { return !!(hisEl && hisEl.value.replace(/^\s+|\s+$/g, '') !== ''); };
      var reflectNames = function () { if (contN) contN.disabled = !nameValid(); };
      function commitNames() {
        if (screen.dataset.locked || !nameValid()) return;
        screen.dataset.locked = '1';
        state.hisName = hisEl ? hisEl.value.replace(/^\s+|\s+$/g, '') : '';
        state.fromName = fromNameEl ? fromNameEl.value.replace(/^\s+|\s+$/g, '') : '';
        /* Store a non-null marker so answersComplete() passes even when
           both names are left blank. */
        state.answers[idx] = state.hisName;
        save();
        advance();
      }
      if (hisEl) {
        hisEl.addEventListener('input', function () { state.hisName = hisEl.value; reflectNames(); });
        hisEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            if (fromNameEl) { try { fromNameEl.focus(); } catch (er) {} } else commitNames();
          }
        });
      }
      if (fromNameEl) {
        fromNameEl.addEventListener('input', function () { state.fromName = fromNameEl.value; });
        fromNameEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitNames(); }
        });
      }
      if (contN) contN.addEventListener('click', commitNames);
      reflectNames();
      return;
    }

    if (q && q.type === 'text') {
      var input = screen.querySelector('#ffg-textq');
      var cont = screen.querySelector('#ffg-textq-continue');
      if (input && state.hisName) input.value = state.hisName;
      function commitText() {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        state.hisName = input ? input.value.replace(/^\s+|\s+$/g, '') : '';
        state.answers[idx] = state.hisName;
        save();
        advance();
      }
      if (input) {
        input.addEventListener('input', function () { state.hisName = input.value; });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitText(); }
        });
      }
      if (cont) cont.addEventListener('click', commitText);
      return;
    }

    /* v-evergreen longtext branch (the_detail). Live word-count guidance,
       Continue commits (newlines allowed so Enter does not submit). Optional. */
    if (q && q.type === 'longtext') {
      var area = screen.querySelector('#ffg-longq');
      var hint = screen.querySelector('#ffg-longq-hint');
      var contL = screen.querySelector('#ffg-textq-continue');
      /* v-evergreen force a real answer here too. This is the biggest lever on
         the AI message, so Continue waits until she has written something. */
      var longValid = function () { return !!(area && area.value.replace(/^\s+|\s+$/g, '') !== ''); };
      var reflectLong = function () { if (contL) contL.disabled = !longValid(); };
      var wordsOf = function (s) {
        s = (s || '').replace(/^\s+|\s+$/g, '');
        return s ? s.split(/\s+/).length : 0;
      };
      var reflectHint = function () {
        if (!hint) return;
        var n = wordsOf(area ? area.value : '');
        var msg, cls;
        if (n === 0) { msg = 'A few sentences is perfect. The more you tell me, the better the card.'; cls = ''; }
        else if (n < 12) { msg = 'Good start. Keep going, the specific details are what make it land.'; cls = 'is-nudge'; }
        else if (n < 25) { msg = 'Nice. Keep adding, a moment, a habit, something only you would notice.'; cls = 'is-nudge'; }
        else if (n < 40) { msg = 'This is great. The more you give me, the more the card will sound like you.'; cls = 'is-nudge'; }
        else { msg = 'Perfect. This is exactly what I need to write something that sounds like you.'; cls = 'is-good'; }
        hint.textContent = msg;
        hint.className = 'ffg-longq__hint ' + cls;
      };
      var commitLong = function () {
        if (screen.dataset.locked || !longValid()) return;
        screen.dataset.locked = '1';
        state.theDetail = area ? area.value.replace(/^\s+|\s+$/g, '') : '';
        state.detailAngle = activeDetailPrompt().angle;
        state.answers[idx] = state.theDetail;
        save();
        advance();
      };
      /* v-evergreen the refresh icon cycles to a different prompt. It swaps the
         stem text in place (no repaint, so her typed text and focus stay), and
         records the new angle for the AI. */
      var refreshBtn = screen.querySelector('#ffg-longq-refresh');
      var stemEl = screen.querySelector('#ffg-qstem');
      if (refreshBtn) {
        refreshBtn.addEventListener('click', function () {
          var order = detailPromptOrder();
          state.detailIdx = ((state.detailIdx || 0) + 1) % order.length;
          var dp = order[state.detailIdx];
          fadeSwapText(stemEl, dp.stem);
          state.detailAngle = dp.angle;
          save();
          refreshBtn.classList.remove('is-spin'); void refreshBtn.offsetWidth; refreshBtn.classList.add('is-spin');
          /* v-evergreen2 do NOT pull focus into the textarea on touch devices.
             Tapping the prompt-refresh icon should only swap the prompt, not pop
             the mobile keyboard or grab/select the field. Desktop (fine pointer)
             keeps the refocus so a mouse user can keep typing. */
          var finePointerLong = true;
          try { finePointerLong = !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) {}
          if (area && finePointerLong) { try { area.focus(); } catch (e) {} }
        });
      }
      if (area) {
        area.addEventListener('input', function () { state.theDetail = area.value; reflectHint(); reflectLong(); });
      }
      if (contL) contL.addEventListener('click', commitLong);
      reflectHint();
      reflectLong();
      return;
    }

    /* v33 capture branch (send_to). Email required, phone optional. On
       submit it subscribes her to Klaviyo (non-blocking, with a retry)
       and advances to the reveal. */
    if (q && q.type === 'capture') {
      var emailEl = screen.querySelector('#ffg-capture-email');
      var phoneEl = screen.querySelector('#ffg-capture-phone');
      var errEl = screen.querySelector('#ffg-capture-err');
      var goEl = screen.querySelector('#ffg-capture-go');
      if (emailEl) {
        emailEl.addEventListener('input', function () { errEl && errEl.setAttribute('hidden', ''); });
        emailEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); submitCapture(); } });
      }
      function submitCapture() {
        if (screen.dataset.locked) return;
        var email = emailEl ? emailEl.value.replace(/^\s+|\s+$/g, '') : '';
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          if (errEl) { errEl.textContent = 'That email does not look right. Try again.'; errEl.removeAttribute('hidden'); }
          if (emailEl) emailEl.classList.add('is-error');
          return;
        }
        screen.dataset.locked = '1';
        state.email = email;
        state.phone = phoneEl ? phoneEl.value : '';
        state.answers[idx] = email;
        save();
        submitQuizCapture();
        advance();
      }
      if (goEl) goEl.addEventListener('click', submitCapture);
      return;
    }

    /* Multi-select branch. Toggles selection in state.answers[idx],
       updates the counter, enables Continue at exactly maxPicks. */
    if (q && q.type === 'multi') {
      var max = q.maxPicks || 3;
      if (!Array.isArray(state.answers[idx])) state.answers[idx] = [];
      var mbtns = screen.querySelectorAll('[data-mopt]');
      var counter = screen.querySelector('#ffg-multi-counter');
      var contBtn = screen.querySelector('#ffg-multi-continue');
      function refresh() {
        var sel = state.answers[idx];
        Array.prototype.forEach.call(mbtns, function (b) {
          var mi = parseInt(b.getAttribute('data-mopt'), 10);
          var on = sel.indexOf(mi) !== -1;
          b.classList.toggle('is-chosen', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          /* Disable visually if at max and not currently selected. */
          if (!on && sel.length >= max) {
            b.classList.add('is-disabled');
          } else {
            b.classList.remove('is-disabled');
          }
        });
        if (counter) counter.textContent = sel.length + ' of ' + max + ' picked';
        if (contBtn) contBtn.disabled = sel.length !== max;
      }
      Array.prototype.forEach.call(mbtns, function (btn) {
        btn.addEventListener('click', function () {
          if (screen.dataset.locked) return;
          var mi = parseInt(btn.getAttribute('data-mopt'), 10);
          var sel = state.answers[idx];
          var pos = sel.indexOf(mi);
          if (pos !== -1) {
            sel.splice(pos, 1);
          } else if (sel.length < max) {
            sel.push(mi);
          }
          /* If at max + tried to add a new one, silently ignore.
             The visual "is-disabled" hint already communicates this. */
          save();
          refresh();
        });
      });
      if (contBtn) {
        contBtn.addEventListener('click', function () {
          if (screen.dataset.locked) return;
          if (state.answers[idx].length !== max) return;
          screen.dataset.locked = '1';
          save();
          advance();
        });
      }
      refresh();
      return;
    }

    var btns = screen.querySelectorAll('[data-opt]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        state.answers[idx] = oi;
        /* The recipient picker is the first question in v3 (moved off
           the homepage). When it is answered we mirror the option onto
           state.recipient + state.branch so everything downstream that
           still reads those fields (revealData, family branch
           routing, Klaviyo property writes, first text template,
           image lookup for the hobby question's family variant) keeps
           working unchanged. */
        /* v-evergreen Q1 occasion sets the card datestamp, greeting, reveal
           headline, and buyer step through the occasion helpers. Store the
           occasion KEY straight off the picked option so occasionKey() reads it.
           Assigned on every pick (outside trackOnce) so re-answering updates it. */
        if (QUESTIONS[idx].key === 'occasion') {
          state.occasion = (QUESTIONS[idx].options[oi] && QUESTIONS[idx].options[oi].store) || '';
          trackOnce('occasion_selected', function () {
            fbTrack('OccasionSelected', { occasion: state.occasion });
            gaTrack('occasion_selected', { occasion: state.occasion });
          });
        }
        if (QUESTIONS[idx].key === 'recipient') {
          state.recipient = (QUESTIONS[idx].options[oi] && QUESTIONS[idx].options[oi].store) || 'other';
          state.branch = (RECIPIENT_MAP[state.recipient] || RECIPIENT_MAP.other).group ? 'Family' : 'Standard';
          trackOnce('recipient_selected', function () {
            fbTrack('RecipientSelected', { recipient: recipientObj().map });
            gaTrack('recipient_selected', { recipient: state.recipient });
          });
        }
        /* v33 Q1 stance sets the voice of the breath and the read. */
        if (QUESTIONS[idx].key === 'stance') {
          var stanceValues = ['insider', 'semi', 'outsider'];
          state.stance = stanceValues[oi] || '';
          trackOnce('stance_selected', function () {
            fbTrack('QuizStance', { stance: state.stance });
            gaTrack('quiz_stance', { stance: state.stance });
          });
        }
        /* Clear any prior highlight first, so only the option she just
           picked looks selected. Otherwise a previous pick and the new
           one both stay lit. */
        Array.prototype.forEach.call(btns, function (b) {
          b.classList.remove('is-selected');
          b.classList.remove('is-chosen');
        });
        btn.classList.add('is-chosen');
        /* v37.6 (Change 5) his_character: picking "the same one for years"
           reveals the optional character-name field in place instead of
           auto-advancing, so she can name him if she knows it. The screen is
           unlocked again so Continue, a re-pick, or another option still work.
           Any other answer hides the field and drops a previously typed name,
           then advances normally. */
        if (QUESTIONS[idx].key === 'his_character') {
          var sameIdx2 = storeIndex(QUESTIONS[idx], 'same');
          var charPanel = screen.querySelector('#ffg-charname-panel');
          if (oi === sameIdx2) {
            if (charPanel) charPanel.hidden = false;
            screen.dataset.locked = '';
            save();
            var nameEl = screen.querySelector('#ffg-charname');
            if (nameEl) { try { nameEl.focus(); } catch (e) {} }
            return;
          }
          if (charPanel) charPanel.hidden = true;
          state.characterName = '';
        }
        save();
        setTimeout(function () { advance(); }, T_CONFIRM);
      });
    });
    /* v37.6 (Change 5) bindings for the optional character-name field the
       "same one for years" option reveals. Typing updates state live, Continue
       or Enter records it and advances (the breath after his_character fires as
       usual). It is optional, so an empty field still advances. */
    if (q && q.key === 'his_character') {
      var charInput = screen.querySelector('#ffg-charname');
      var charCont = screen.querySelector('#ffg-charname-continue');
      var commitCharName = function () {
        if (screen.dataset.locked) return;
        screen.dataset.locked = '1';
        state.characterName = charInput ? charInput.value.replace(/^\s+|\s+$/g, '') : '';
        save();
        advance();
      };
      if (charInput) {
        charInput.addEventListener('input', function () { state.characterName = charInput.value; });
        charInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); commitCharName(); }
        });
      }
      if (charCont) charCont.addEventListener('click', commitCharName);
    }
    /* Shrink near-square question media. Uploads with a ratio between
       0.8 and 1.25 (roughly 4:5 to 5:4) otherwise render full width and
       eat the whole viewport. Landscape and tall portraits are left
       alone so they still render at their natural width. Same rule
       applies to videos, measured from videoWidth and videoHeight once
       metadata is ready. */
    var applySquareIfNeeded = function (wrap, w, h) {
      if (!w || !h) return;
      var r = w / h;
      if (r >= 0.8 && r <= 1.25) wrap.classList.add('ffg-qhero--square');
    };
    var heroImg = screen.querySelector('.ffg-qhero img');
    if (heroImg) {
      var checkImg = function () { applySquareIfNeeded(heroImg.parentNode, heroImg.naturalWidth, heroImg.naturalHeight); };
      if (heroImg.complete) checkImg();
      else heroImg.addEventListener('load', checkImg);
    }
    var heroVid = screen.querySelector('.ffg-qhero video');
    if (heroVid) {
      var checkVid = function () { applySquareIfNeeded(heroVid.parentNode, heroVid.videoWidth, heroVid.videoHeight); };
      if (heroVid.readyState >= 1) checkVid();
      else heroVid.addEventListener('loadedmetadata', checkVid);
      /* Safari sometimes pauses autoplay on transition. Calling play()
         after the element is in the DOM nudges it. The promise is
         swallowed because rejection just means the browser blocked it,
         which is fine, the poster stays visible. */
      var p = heroVid.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }
  function paintQuestion(instant) {
    state.view = 'quiz';
    paint(questionHTML(state.step), instant, function () {
      bindQuestion(state.step);
      if (state.step >= 2) preloadReveals();
    });
  }
  function advance() {
    /* Belief-installing breath screens are anchored to the question
       the visitor JUST answered (not to an array index), so reordering
       QUESTIONS does not move the breaths to the wrong spot.
       Reframe lands after the first scored question (hobby_vibe).
       Heirloom lands after the second scored question (personality).
       Each fires at most once per session. The step counter does not
       move here; paintBreath leaves state.step on the just-answered
       question and lets the breath screen advance the step itself. */
    var justAnswered = QUESTIONS[state.step] && QUESTIONS[state.step].key;
    /* v33 the single breath fires after his_character (Q5), right before
       the_notice (Q6). Two short lines, branched by her stance. */
    if (justAnswered === 'his_character' && !state.breathShown.hinge) {
      paintBreath('hinge');
      return;
    }
    if (state.step < QUESTIONS.length - 1) {
      state.step++;
      save();
      paintQuestion();
    } else {
      finishQuiz();
    }
  }
  function goBack() {
    /* v-evergreen once the card is built, never navigate back into the quiz. */
    if (state.cardBuilt) { renderBuilder(); return; }
    /* Back from any question also kills a pending breath timer.
       In practice the timer is only live while a breath screen is
       on screen, but the clear is cheap and keeps the invariant. */
    clearBreathTimer();
    if (state.step <= 0) { goToIntro(); return; }
    state.step--;
    save();
    paintQuestion();
  }

  /* ---------- Breath screens ----------
     A breath screen sits between two questions as a content moment, no
     option buttons. It auto advances after T_BREATH and also advances
     on tap. Tracked once per session so it does not re-appear if the
     visitor backs out and re-answers the prior question. */
  /* v33 the breath branches on her stance from Q1. The insider, who plays
     with him, gets respect. The semi and outsider get the gentle relief.
     Two short lines, nothing more. */
  function breathLines() {
    /* v-evergreen pronoun-resolved pause copy. Same belief either way: it is
       easy, the recipient brings it to life. The avatar-specific voice tuning
       lands in the funnel-retune phase; here the pronouns simply resolve. */
    var p = pron();
    var S = p.subj, O = p.obj, P = p.pos, isPl = (S === 'they');
    if (state.stance === 'insider') {
      return {
        headline: 'You already know exactly who ' + S + ' ' + (isPl ? 'play' : 'plays') + '.',
        subline: 'The kind of gift ' + S + ' ' + (isPl ? 'open' : 'opens') + ', then ' + (isPl ? 'watch' : 'watches') + ' come to life.',
        add: 'All you do is open the door for ' + O + '.'
      };
    }
    return {
      headline: 'You do not have to know ' + P + ' character.',
      subline: cap(S) + ' ' + (isPl ? 'bring' : 'brings') + ' it to life ' + p.refl + '.',
      add: 'All you do is open the door for ' + O + '.'
    };
  }
  function breathHTML(kind) {
    var b = BREATH[kind] || BREATH_DEFAULTS[kind];
    var lines = breathLines();
    var prompt = (b && b.prompt) || 'continue';
    var img = (b.image && b.image.full) || '';
    var vidSources = (b.video && b.video.sources) || [];
    var media = '';
    if (vidSources.length) {
      media = '<div class="ffg-breath__media">' +
        '<video autoplay muted loop playsinline preload="auto" disableremoteplayback' +
        (img ? ' poster="' + esc(img) + '"' : '') + '>';
      for (var vi = 0; vi < vidSources.length; vi++) {
        var s = vidSources[vi];
        if (s && s.url) {
          media += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      media += '</video></div>';
    } else if (img) {
      media = '<div class="ffg-breath__media"><img src="' + esc(img) +
        '" alt="" aria-hidden="true" decoding="async"></div>';
    } else {
      /* v37.2 the pause screens carry a real placeholder image too. */
      media = breathPlaceholderImgHTML();
    }
    return '<div class="ffg-breath ffg-breath--' + esc(kind) + '" id="ffg-breath" role="button" tabindex="0">' +
      '<h2 class="ffg-breath__headline">' + esc(lines.headline) + '</h2>' +
      media +
      '<p class="ffg-breath__subline">' + esc(lines.subline) + '</p>' +
      (lines.add ? '<p class="ffg-breath__subline">' + esc(lines.add) + '</p>' : '') +
      '<p class="ffg-breath__prompt">' + esc(prompt) + ' &rsaquo;</p>' +
      '</div>';
  }
  function paintBreath(kind) {
    state.breathShown[kind] = true;
    state.view = 'breath';
    /* Fire tracking once per session per breath, on first paint. */
    if (kind === 'reframe') {
      trackOnce('breath_reframe', function () {
        fbTrack('BreathReframeView', { content_name: 'Gift Quiz Evergreen' });
        gaTrack('breath_reframe_view', {});
      });
    } else if (kind === 'heirloom') {
      trackOnce('breath_heirloom', function () {
        fbTrack('BreathHeirloomView', { content_name: 'Gift Quiz Evergreen' });
        gaTrack('breath_heirloom_view', {});
      });
    }
    paint(breathHTML(kind), false, function () { bindBreath(kind); });
  }
  function bindBreath(kind) {
    clearBreathTimer();
    var el = document.getElementById('ffg-breath');
    if (!el) return;
    var fired = false;
    function advanceFromBreath() {
      if (fired) return;
      fired = true;
      clearBreathTimer();
      /* Move on to the next question. state.step was left at the
         just-answered question, so ++ lands on the next one. */
      if (state.step < QUESTIONS.length - 1) {
        state.step++;
        state.view = 'quiz';
        save();
        paintQuestion();
      } else {
        finishQuiz();
      }
    }
    el.addEventListener('click', advanceFromBreath);
    breathTimer = setTimeout(advanceFromBreath, T_BREATH);
  }

  /* ---------- Preloading ---------- */
  function preloadList(urls) {
    for (var i = 0; i < urls.length; i++) {
      if (urls[i]) { var im = new Image(); im.src = urls[i]; }
    }
  }
  var qImgPreloaded = false;
  function preloadQuestionImages() {
    if (qImgPreloaded) return;
    qImgPreloaded = true;
    var singles = ['occasion', 'stance', 'recipient', 'q3', 'q1', 'q4', 'q6', 'detail'];
    for (var i = 0; i < singles.length; i++) {
      if (Q_IMAGES[singles[i]]) preloadList([Q_IMAGES[singles[i]]]);
    }
  }
  var preloaded = false;
  function preloadReveals() {
    if (preloaded) return;
    preloaded = true;
    for (var k in IMG) {
      if (IMG.hasOwnProperty(k) && IMG[k] && IMG[k].full) {
        var im = new Image();
        im.src = IMG[k].full;
      }
    }
  }

  /* ============================================================
     THE ENDING  -  one continuous screen
     The reveal, the proof gallery, and the opt in form all render
     here. On a successful submit the opt in block swaps in place
     to the confirmation and the card.
     ============================================================ */
  function finishQuiz() {
    /* v24: no archetype is computed. We compute the gift route and seed
       the invitation card from her answers, then go to the builder,
       which is the card + gift end screen for both routes. The old
       archetype reveal (renderResult) is retired from the flow. */
    computeRoute();
    state.cardBuilt = true;   /* v-evergreen lock the funnel forward, no re-quiz, caps AI cost */
    seedCardFromAnswers();
    /* v-evergreen kick off the AI message now so it overlaps the loader beat.
       The preset is already seeded as the instant fallback; the AI swaps in
       when it returns (if she has not edited the message herself). */
    aiGenerateCard();
    state.view = 'builder';
    save();
    /* The message seeds from her the_notice answer (preset), then the AI
       message replaces it on return unless she writes her own. */
    trackOnce('completed', function () {
      fbTrack('QuizCompleted', {
        content_name: 'Gift Quiz Evergreen',
        route: state.giftRoute,
        branch: state.branch,
        world: answerByKey('his_world')
      });
      gaTrack('quiz_complete', { route: state.giftRoute });
    });
    var screen = screenEl();
    screen.classList.add('is-hidden');
    renderProgress();
    setTimeout(function () {
      screen.innerHTML = '<div class="ffg-reveal-beat">' +
        '<div class="ffg-reveal-beat__ring"></div>' +
        '<div class="ffg-reveal-beat__text">Bringing the card to life…</div></div>';
      screen.classList.remove('is-hidden');
    }, T_FADE);
    setTimeout(renderBuilder, T_FADE + T_BEAT);
  }

  function renderResult() {
    var d = revealData();
    var heroFull = (IMG[d.imageKey] && IMG[d.imageKey].full) || '';
    var hero = heroFull
      ? '<div class="ffg-hero"><img src="' + esc(heroFull) + '" alt="A Jan portrait"></div>'
      : '<div class="ffg-hero"><div class="ffg-hero__ph">Portrait</div></div>';
    var reads = '';
    for (var i = 0; i < d.read.length; i++) {
      reads += '<p class="ffg-readout__p">' + esc(d.read[i]) + '</p>';
    }
    /* Bridge line. A small gold Cinzel caption between the hero and
       the readout. Inline-styled with brand CSS vars so the CSS file
       does not need a new rule. Universal "Here's what that means
       about him." for archetypes, slightly shorter for Family. */
    var bridgeStyle = 'font-family:var(--ffg-display);font-size:14.5px;font-weight:600;letter-spacing:0.22em;text-transform:uppercase;color:var(--ffg-gold);text-align:center;margin:24px 0 10px;opacity:0.9;';
    var bridge = d.bridge
      ? '<p class="ffg-readout__bridge" style="' + bridgeStyle + '">' + esc(d.bridge) + '</p>'
      : '';
    /* v22 result page. The quiz no longer dead-ends on an archetype
       label. The reveal stays as recognition (the witness line + 2
       read paragraphs still carry the emotional peak), but the page
       headline is now "Here is the version of him I heard." and the
       read closes with a line that hands the buyer the next step.
       Below the read, the page splits on state.giftPath (from Q8)
       into one of two recommendation blocks: Direct Portrait or
       Quest Invitation. One primary CTA per branch, near the end. */
    var isFamily = state.branch === 'Family';
    /* Read the routing answer. Q8 stores 'direct' or 'invitation'.
       Default to 'direct' if the answer is missing (defensive — covers
       resume-from-old-storage edge cases). */
    var giftPath = answerByKey('gift_path') || 'direct';
    var newHeadline = isFamily
      ? 'Here is the version of your family I heard.'
      : 'Here is the version of him I heard.';
    /* Close line. Names that this is the part of him nobody else
       sees and pivots from recognition into the recommendation. */
    var closeLine = isFamily
      ? 'This is what your family is from the inside. Now you can hand it to him.'
      : 'This is the part of him nobody else sees. Now you can make sure he gets seen.';
    var html =
      '<div class="ffg-result">' +
        /* Small FRAMEDFANTASY wordmark above the headline on the
           reveal screen only. Doubles as a quiet return-home link. */
        '<a class="ffg-wordmark ffg-result__wordmark" href="/" aria-label="FramedFantasy home">FRAMEDFANTASY</a>' +
        /* ----- v22 reveal heading: no longer the archetype label.
           The tagline below it stays — it now reads as a quiet
           subhead under the new headline rather than a typed answer. */
        '<h1 class="ffg-result__headline" id="ffg-headline">' + esc(newHeadline) + '</h1>' +
        '<p class="ffg-result__tagline">' + esc(d.tagline) + '</p>' +
        hero +
        bridge +
        '<div class="ffg-readout">' + reads +
          /* v22 read close line — appended INSIDE the readout block
             so it sits visually with the read, not separated from it. */
          '<p class="ffg-readout__p ffg-readout__close">' + esc(closeLine) + '</p>' +
        '</div>' +
        '<div class="ffg-readout__sign">Jan, FramedFantasy</div>' +
        /* ----- Card download. A free recognition keepsake she can
           save or share. v23: shown on the DIRECT path only. On the
           invitation path it is suppressed on purpose, because a free
           downloadable finished card before the builder would fill the
           gap the empty-envelope builder is built to open. On the
           invitation path the card experience IS the builder, reached
           through the recommendation below. ----- */
        (giftPath === 'invitation' ? '' :
          '<div class="ffg-cardblock">' +
            '<p class="ffg-cardblock__head">Save his archetype card. Keep it, or send it to someone who knows him.</p>' +
            '<button type="button" class="ffg-cardbtn" id="ffg-cardbtn">' +
              '<span class="ffg-cardbtn__label">' +
                esc(cardButtonLabel().replace(/ ARCHETYPE CARD$/, '')) +
                '<br class="ffg-br-mobile">' +
                ' ARCHETYPE CARD' +
              '</span>' +
              '<svg class="ffg-cardbtn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>' +
                '<polyline points="7 10 12 15 17 10"/>' +
                '<line x1="12" y1="15" x2="12" y2="3"/>' +
              '</svg>' +
            '</button>' +
          '</div>') +
        /* ----- Real portraits, real homes. Visual proof of what a
           finished painting looks like for real customers. ----- */
        galleryHTML() +
        /* ----- v22 recommendation block. Branched on giftPath
           (set by Q8). Each branch has its own heading, body, button,
           and timing/note pair. Direct Portrait is the buy-by-cutoff
           path. Quest Invitation is the deadline-free path that ends
           in a downloadable card she designs herself. One CTA
           per branch, sized as the page's primary action. ----- */
        (function () {
          if (giftPath === 'invitation') {
            /* Quest Invitation. Defuses the two biggest blocks (does
               not need to know his character, deadline is gone) and
               positions the invitation as the gift, not packaging.
               The button opens the card builder (renderBuilder), not
               the product page. The builder is where she designs the
               invitation and meets the empty-envelope gap that the
               purchase closes. */
            var inviteHead = isFamily
              ? 'The gift that fits is an invitation.'
              : 'The gift that fits him is an invitation.';
            var inviteBody = isFamily
              ? 'You do not have to know each character. You hand him the adventure and your family brings it to life. He plays, his character takes shape, and I paint it by hand from there. Because it is a code, you can give it to him on Father\'s Day itself. Nothing to ship, nothing to race.'
              : 'You do not have to know his character. You hand him the adventure and he brings it to life himself. He plays, his character takes shape, and I paint it by hand from there. Because it is a code, you can give it to him on Father\'s Day itself. Nothing to ship, nothing to race.';
            var builderIntro = 'Let me help you make his invitation. Write him a line, or use one of mine. You will see exactly what he opens.';
            return '<div class="ffg-rec ffg-rec--invitation">' +
              '<h2 class="ffg-rec__head">' + esc(inviteHead) + '</h2>' +
              '<p class="ffg-rec__body">' + esc(inviteBody) + '</p>' +
              '<p class="ffg-rec__builder">' + esc(builderIntro) + '</p>' +
              '<button type="button" class="ffg-cta-primary" id="ffg-open-builder">' +
                '<span class="ffg-cta-primary__shimmer" aria-hidden="true"></span>' +
                '<span class="ffg-cta-primary__label">Make his invitation <span class="ffg-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
              '</button>' +
            '</div>';
          }
          /* Direct Portrait (default). Short heading, short body,
             timing line, button, descent line. */
          var directHead = isFamily
            ? 'You know them well enough to surprise him.'
            : 'You know him well enough to surprise him.';
          var directBody = isFamily
            ? 'Send me the photos and tell me what you know. I ask the rest. Nothing ships until it looks like all of you.'
            : 'Send me one photo and tell me what you know. I ask the rest. Nothing ships until it looks like him.';
          var directTiming = isFamily
            ? 'I can still finish theirs by Father\'s Day if you start by June 7.'
            : 'I can still finish his by Father\'s Day if you start by June 7.';
          var directBtnLabel = isFamily ? 'Start the portrait' : 'Start his portrait';
          return '<div class="ffg-rec ffg-rec--direct">' +
            '<h2 class="ffg-rec__head">' + esc(directHead) + '</h2>' +
            '<p class="ffg-rec__body">' + esc(directBody) + '</p>' +
            primaryButtonHTML('ffg-cta-start-1', directBtnLabel) +
            '<p class="ffg-cta-note ffg-cta-note--urgent">' + esc(directTiming) + '</p>' +
            '<p class="ffg-cta-note">Most people only wish they had done it sooner.</p>' +
          '</div>';
        })() +
        /* ----- v22 trust band. Carries the two load-bearing trust
           signals the page would otherwise lose: the money-back line
           and the personal-text line. Both are required per brief;
           do not cut either to save length. ----- */
        '<div class="ffg-trustband">' +
          '<p class="ffg-trustband__line">' + esc(isFamily
            ? 'If it does not feel right when you see it, you get your money back.'
            : 'If it does not feel like him when you see it, you get your money back.') + '</p>' +
          '<p class="ffg-trustband__line">You hear from me personally the whole way through.</p>' +
        '</div>' +
        /* ----- Loox reviews. The last main content block. ----- */
        '<div id="ffg-loox-mount" class="ffg-loox-mount" aria-label="Customer reviews"></div>' +
        /* ----- Retake link. The only thing below the reviews. ----- */
        '<button type="button" class="ffg-retake" id="ffg-retake">Retake the quiz from the start</button>' +
        /* ----- Sticky mobile CTA. v23 fix: only on the DIRECT path,
           where it links to the portrait product. On the invitation
           path it is omitted, because the action there is opening the
           builder (a JS view switch), which a plain link cannot do, and
           a sticky pointing at the portrait product would send her to
           the wrong place. The in-page "Make his invitation" button is
           the action on that path. ----- */
        (giftPath === 'invitation' ? '' :
          '<a class="ffg-sticky-cta" id="ffg-sticky-cta" href="' + esc(PRODUCT_URL) + '" data-ffg-cta="sticky"><span class="ffg-sticky-cta__label">' + esc(isFamily ? 'Start the portrait' : 'Start his portrait') + '</span><span class="ffg-sticky-cta__arrow" aria-hidden="true">&rarr;</span></a>') +
      '</div>';
    state.view = 'result';
    save();
    paint(html, true, function () {
      renderProgress();
      bindResult();
      /* Move the page level Loox section into the result screen. */
      mountLoox();
      trackOnce('reveal', function () {
        /* Keep the existing ResultRevealView event for continuity
           with the prior pixel rules and Klaviyo segments, and fire
           the new reveal_view event the v18 brief calls for. */
        fbTrack('ResultRevealView', {
          content_name: 'Gift Quiz Evergreen',
          archetype: (ARCH[state.archetype] || {}).name || ''
        });
        gaTrack('result_reveal_view', { archetype: state.archetype });
        fbTrack('reveal_view', {
          content_name: 'Gift Quiz Evergreen',
          archetype: (ARCH[state.archetype] || {}).name || ''
        });
        gaTrack('reveal_view', { archetype: state.archetype });
      });
    });
  }
  /* ---------- Primary CTA helper ----------
     The buy button. Identical markup wherever it appears on the page
     so the click handler can find each instance by class. The href
     points at PRODUCT_URL with no query params so the product page
     renders its normal standalone self. */
  function primaryButtonHTML(id, label) {
    /* v21 accepts a label so the family branch can swap "Start his
       portrait" for "Start the portrait". Sticky mobile CTA stays
       hardcoded per the brief, so the swap only applies here in the
       offer block. */
    var lbl = label || 'Start his portrait';
    return '<a class="ffg-cta-primary" id="' + esc(id) + '" href="' + esc(PRODUCT_URL) + '" data-ffg-cta="primary">' +
      '<span class="ffg-cta-primary__shimmer" aria-hidden="true"></span>' +
      '<span class="ffg-cta-primary__label">' + esc(lbl) + ' <span class="ffg-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
    '</a>';
  }
  /* ---------- Trust band helper ----------
     Jan in first person, then a row of trust signals as badges. This
     is the work the personal text used to do, now living on the page
     because the personal text no longer fires before the sale. An
     optional square video sits above the intro when a merchant has
     uploaded one in the theme editor. autoplay muted loop playsinline
     is the only combo that auto starts on iOS Safari and modern
     Chrome, so the clip starts on its own without any user gesture
     and the page never gets browser-blocked audio. The poster image,
     if also set, shows instantly while the video buffers. */
  function trustVideoHTML() {
    var tv = (CONFIG && CONFIG.trustVideo) || {};
    var sources = tv.sources || [];
    var poster = tv.poster || '';
    if (!sources.length && !poster) return '';
    var html = '<div class="ffg-trust__video">';
    if (sources.length) {
      html += '<video class="ffg-trust__videoel" autoplay muted loop playsinline preload="auto" disableremoteplayback';
      if (poster) html += ' poster="' + esc(poster) + '"';
      html += '>';
      for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        if (s && s.url) {
          html += '<source src="' + esc(s.url) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>';
        }
      }
      html += '</video>';
    } else if (poster) {
      /* No video set, only a poster image. Render the still on its
         own so the slot is not blank when a merchant uploaded just
         the poster. */
      html += '<img class="ffg-trust__videoel" src="' + esc(poster) + '" alt="" aria-hidden="true" decoding="async" loading="lazy">';
    }
    html += '</div>';
    return html;
  }
  function trustBandHTML() {
    var badges = [
      'Money back guarantee',
      'Unlimited revisions until it looks like him',
      '1000+ portraits painted',
      '500+ five star reviews',
      'Hand painted by Jan and her team, start to finish'
    ];
    var items = '';
    for (var i = 0; i < badges.length; i++) {
      items += '<li class="ffg-trust__badge">' + esc(badges[i]) + '</li>';
    }
    return '<div class="ffg-trust">' +
      trustVideoHTML() +
      '<p class="ffg-trust__intro">Hi, I am Jan. I paint every portrait by hand with my team of vetted artists, and I run every order myself. You do not play and you do not need to. You tell me who they are and I take it from there.</p>' +
      '<ul class="ffg-trust__badges">' + items + '</ul>' +
    '</div>';
  }

  /* ---------- The opt in block ---------- */
  /* The opt in sub line references the deadline she picked on question 3. */
  function fathersDayCutoffDate() {
    var parts = String(FD_CUTOFF).split('-');
    var y = parseInt(parts[0], 10), m = parseInt(parts[1], 10), d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  }
  function fathersDayDoable() {
    var c = fathersDayCutoffDate();
    if (!c) return true;
    return new Date() < c;
  }
  function cutoffLabel() {
    var c = fathersDayCutoffDate();
    if (!c) return 'the cutoff';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[c.getMonth()] + ' ' + c.getDate();
  }
  /* v12 dynamic opt-in copy. Both the headline and subhead now key off
     state.recipient (set by Q1) and state.archetype (set by computeResult)
     so the form mirrors back exactly what she just told us. The Family
     branch gets its own headline + subhead because there's no single
     archetype to name. The cutoff date inside both subhead variants
     still flows from cutoffLabel() so the theme editor's fathers_day_cutoff
     setting continues to drive it. */
  function archetypeShortNoun() {
    /* "the Knight" / "the Bard" / etc. — short noun form for the
       opt-in headline, distinct from the full ARCH[].name ("Noble
       Knight") used in the reveal headline above. Dungeon Master
       stays two-word because there's no shorter version. */
    var map = {
      noble_knight:       'Knight',
      devoted_cleric:     'Cleric',
      charismatic_bard:   'Bard',
      arcane_spellcaster: 'Spellcaster',
      wild_ranger:        'Ranger',
      sneaky_rogue:       'Rogue',
      mighty_barbarian:   'Barbarian',
      dungeon_master:     'Dungeon Master'
    };
    return map[state.archetype] || 'character';
  }
  function recipientNoun() {
    /* Q1 collapses boyfriend + partner into a single "boyfriend or
       partner" option, so we render that branch as "partner" — the
       more universal word and the one the spec calls for when the
       Q1 option covers both. */
    var map = {
      husband:   'husband',
      boyfriend: 'partner',
      dad:       'dad'
    };
    return map[state.recipient] || 'guy';
  }
  function optinHeadline() {
    if (state.branch === 'Family') {
      return 'Want your family painted as your adventuring party?';
    }
    return 'Want your ' + recipientNoun() +
      ' hand painted as the ' + archetypeShortNoun() + '?';
  }
  function optinSubhead() {
    /* v18 subhead. The result page primary CTA is now the buy button.
       The opt-in lives only as the collapsed fallback ("Not ready
       today?"), so the headline + subhead are no longer rendered above
       the fields. This helper is kept so the function reference exists
       in case downstream callers expect it, but it returns an empty
       string in v18 and the fallback's link copy provides the framing. */
    return '';
  }
  /* v17 timing question lives on the SMS opt-in form as inline form
     data, not in the quiz body. Same four options that used to be
     Q3. The picked value is written to state.timing on form submit
     and pushed to Klaviyo as FathersDayQuiz_Timing. */
  /* v17.3: ASAP option removed. The "show me what's open" framing
     was reading as a sales qualifier instead of a timing pick, and
     the buyer most likely to pick ASAP is already covered by the
     Father's Day choice when the cutoff is close. Three options
     keep the form tighter and the choice cleaner. */
  var TIMING_OPTIONS = [
    { value: 'Fathers Day',             label: 'Father\'s Day this year, June 21' },
    { value: 'Birthday or anniversary', label: 'A birthday or anniversary coming up' },
    { value: 'No rush',                 label: 'No rush, whenever it is ready' }
  ];
  function timingFieldHTML() {
    var html = '<fieldset class="ffg-timing">' +
      '<legend class="ffg-label">When are you thinking?</legend>';
    for (var i = 0; i < TIMING_OPTIONS.length; i++) {
      var opt = TIMING_OPTIONS[i];
      var checked = state.timing === opt.value ? ' checked' : '';
      html += '<label class="ffg-timing__opt">' +
        '<input type="radio" name="ffg-timing" value="' + esc(opt.value) + '"' + checked + '>' +
        '<span>' + esc(opt.label) + '</span>' +
        '</label>';
    }
    html += '<p class="ffg-fielderror" id="ffg-timing-err" hidden></p></fieldset>';
    return html;
  }
  function optinInnerHTML() {
    /* v18 fallback form. Headline and subhead removed because the
       fallback link "Not ready today? Jan will text you once before
       June 7." now provides the framing. The form holds the timing
       question (kept because the SMS nurture uses it), first name,
       mobile number, the submit button, and one line of microcopy.
       Submission still posts to the same Klaviyo destination. */
    return timingFieldHTML() +
      '<div class="ffg-field">' +
        '<label class="ffg-label" for="ffg-fname">First name</label>' +
        '<input class="ffg-input" id="ffg-fname" type="text" autocomplete="given-name" placeholder="Your first name">' +
        '<p class="ffg-fielderror" id="ffg-fname-err" hidden></p>' +
      '</div>' +
      '<div class="ffg-field">' +
        '<label class="ffg-label" for="ffg-phone">Mobile number</label>' +
        '<div class="ffg-phone-row">' +
          '<select class="ffg-country" id="ffg-country" aria-label="Country code">' +
            '<option value="US">US +1</option>' +
            '<option value="CA">CA +1</option>' +
          '</select>' +
          '<input class="ffg-input" id="ffg-phone" type="tel" autocomplete="tel-national" inputmode="numeric" placeholder="(555) 123-4567">' +
        '</div>' +
        '<p class="ffg-fielderror" id="ffg-phone-err" hidden></p>' +
      '</div>' +
      '<button type="button" class="ffg-submit" id="ffg-submit">Have Jan text me</button>' +
      '<p class="ffg-micro-note">I text you personally. The same number works to talk through the photo and the character. No spam, just me.</p>';
  }
  function bindResult() {
    var screen = screenEl();
    var retake = screen.querySelector('#ffg-retake');
    var cardBtn = screen.querySelector('#ffg-cardbtn');
    if (retake) retake.addEventListener('click', resetQuiz);
    if (cardBtn) cardBtn.addEventListener('click', saveCard);
    /* v23: the invitation-path recommendation button opens the card
       builder (a new in-app view), not the product page. */
    var openBuilder = screen.querySelector('#ffg-open-builder');
    if (openBuilder) {
      openBuilder.addEventListener('click', function () {
        fbTrack('build_invitation_open', { content_name: 'Gift Quiz Evergreen' });
        gaTrack('build_invitation_open', {});
        renderBuilder();
      });
    }
    /* v19 primary CTA. Both Start his portrait buttons and the
       sticky mobile CTA fire start_portrait_click before the browser
       follows the href. The pixel and gtag beacons are designed to
       survive same-tab navigation, so no preventDefault is needed. */
    var primaryButtons = screen.querySelectorAll('[data-ffg-cta]');
    Array.prototype.forEach.call(primaryButtons, function (btn) {
      btn.addEventListener('click', function () {
        fbTrack('start_portrait_click', {
          content_name: 'Gift Quiz Evergreen',
          archetype: (ARCH[state.archetype] || {}).name || '',
          placement: btn.getAttribute('data-ffg-cta') || 'primary'
        });
        gaTrack('start_portrait_click', {
          archetype: state.archetype,
          placement: btn.getAttribute('data-ffg-cta') || 'primary'
        });
      });
    });
    /* Trust band square video. Safari sometimes pauses autoplay on
       screen transitions, so a play() nudge after the element is in
       the DOM kicks it back on. Promise rejection is swallowed
       because a block just means the poster stays visible. */
    var trustVid = screen.querySelector('.ffg-trust__video video');
    if (trustVid) {
      var tp = trustVid.play();
      if (tp && typeof tp.catch === 'function') tp.catch(function () {});
    }
  }

  /* ============================================================
     v23 QUEST INVITATION CARD BUILDER  (Path A)
     ============================================================
     The emotional and commercial centerpiece of the invitation path.
     She designs the OUTSIDE of an invitation she will give him. The
     live preview is HTML and CSS, not canvas, so it updates smoothly
     on every keystroke and lets the empty-envelope gap render cleanly.

     The non-negotiable rule. The free card is an empty envelope. The
     preview shows a finished-looking invitation with a visibly SEALED,
     empty code slot. There is no quest, no code, and no portrait
     behind it yet. The download is locked. The only move that fills
     the gap is the purchase. She builds the wrapping for free and owns
     it emotionally, but she cannot complete or download it until she
     puts his adventure inside. That tension is the whole engine.

     The builder stays an emotional act, not a design tool. Three
     inputs only. The polish is locked. The message presets pull care
     and protection of a loved one. The descent line survives right
     before the button. */

  /* Four invitation art themes, matching the four worlds in the brief:
     a tavern, an arcane study, the wilds, a grand hall. Each maps to an
     optional theme-editor image (CONFIG.inviteArt[key]). When no image
     is set the card fills with a hand-drawn SVG scene (not a flat
     color) so picking a world changes the whole scene, which is what
     turns the builder from a form into a gift. When Jan uploads real
     scene art it takes over and the SVG is the fallback. */
  /* v34 the five card themes. Each is a full theme: a research-backed
     jewel-tone palette plus a hand drawn scene, with gold the constant
     accent (gold reads as a keepsake on any ground). The swatch is the
     darker palette anchor shown on the picker chip. Default is derived
     from his world in defaultThemeForHobby, and she can pick any of them. */
  var INVITE_ART_THEMES = [
    /* v36.9 a romantic option in the FramedFantasy brand colours, with a scene
       of floating hearts. The swatch is the two brand colours blended.
       v37.3 Jan: Love leads the picker and is the default for everyone. */
    { key: 'love',   label: 'Love',      swatch: 'linear-gradient(135deg, #ED96FD, #AAFEFE)' },
    { key: 'tavern', label: 'Candlelit', swatch: '#5a4019' },
    { key: 'arcane', label: 'Arcane',    swatch: '#3a2a63' },
    { key: 'wilds',  label: 'Wilds',     swatch: '#1b3d27' },
    { key: 'hall',   label: 'Royal',     swatch: '#1c2c5a' },
    { key: 'ember',  label: 'Ember',     swatch: '#4a1a20' }
  ];
  function defaultThemeForHobby() {
    /* v37.3 Jan: Love is the default colour for everyone now (it also leads the
       picker). The earlier hobby-derived default (DnD->tavern, Reading->arcane,
       VideoGame->hall, else wilds) is retired. */
    return 'love';
  }
  function inviteArtUrl(key) {
    var art = (CONFIG && CONFIG.inviteArt) || {};
    return art[key] || '';
  }
  /* v24 route-aware copy for the builder + invitation. The character
     route (default) frames the gift as an adventure he plays to bring
     his own character to life. The portrait route frames it as turning
     him into the hero from one photo she sends. Both buy the same gift
     card and keep the empty-envelope gap. */
  function routeCopy() {
    /* v-evergreen route copy is pronoun-resolved from pron(). Singular they and
       any group take plural verbs; he/she take singular. The card never assumes
       a gender. The codeHint and status lines are now occasion + gender neutral. */
    var p = pron();
    var S = p.subj, O = p.obj, P = p.pos, Scap = cap(S), Pcap = cap(P);
    var isPl = (S === 'they');
    var show = isPl ? 'show' : 'shows', play = isPl ? 'play' : 'plays', doWord = isPl ? 'do' : 'does';
    var heroWord = p.group ? 'heroes' : 'the hero';
    var photoWord = p.group ? 'the photos' : 'one photo';
    if (state.giftRoute === 'portrait') {
      return {
        summons: 'About to be made real.',
        codeLabel: 'To claim your portrait',
        codeHintSample: 'A sample. The real code appears here once you finish the gift.',
        codeHintReal: 'Enter this code at FramedFantasy.com/Gift',
        gift: cap(O) + ', turned into ' + heroWord + ', painted by hand from ' + photoWord + ' you send.',
        status: 'The card is ready. One step puts the portrait behind it.',
        cta: 'Give ' + O + ' the gift',
        trust: 'You send me ' + photoWord + '. I paint ' + O + ' by hand.'
      };
    }
    return {
      summons: 'Time to bring them to life.',
      codeLabel: 'To claim your portrait',
      codeHintSample: 'A sample. The real code appears here once you finish the gift.',
      codeHintReal: 'Enter this code at FramedFantasy.com/Gift',
      gift: Pcap + ' character, painted by hand and ' + posInd(P) + ' to keep. ' + Pcap + ' part is already paid for, so all ' + S + ' ' + doWord + ' is show up and play.',
      status: 'The card is ready. One step puts the portrait behind it.',
      cta: 'Give ' + O + ' ' + P + ' adventure',
      trust: Pcap + ' slot is already paid for. ' + Scap + ' just ' + show + ' up and ' + play + '.'
    };
  }
  /* Hand-drawn scene per world. Gold silhouettes over the theme
     gradient (the gradient lives in CSS). Simple and atmospheric, not
     busy. preserveAspectRatio slices so it always fills the band. */
  function inviteSceneSVG(key) {
    var g = '#c9a84c', gb = '#e8c674';
    var open = '<svg class="ffg-invite__scene" viewBox="0 0 400 200" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    var scenes = {
      tavern:
        /* v36.3 candlelit. v37.11 the flames flicker (per-candle, staggered)
           and the glow breathes. */
        '<circle class="ffg-anim-glow" cx="200" cy="74" r="46" fill="' + gb + '" opacity="0.10"/>' +
        '<g fill="' + g + '" opacity="0.5">' +
          '<rect x="151" y="92" width="15" height="66" rx="4"/>' +
          '<rect x="192" y="74" width="16" height="84" rx="4"/>' +
          '<rect x="234" y="100" width="15" height="58" rx="4"/>' +
        '</g>' +
        '<g fill="' + gb + '" opacity="0.3">' +
          '<ellipse cx="158.5" cy="92" rx="7.5" ry="2.5"/>' +
          '<ellipse cx="200" cy="74" rx="8" ry="2.5"/>' +
          '<ellipse cx="241.5" cy="100" rx="7.5" ry="2.5"/>' +
        '</g>' +
        '<g fill="' + gb + '" opacity="0.8">' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.2s" d="M158.5 90 C151 82, 154 72, 158.5 66 C163 72, 166 82, 158.5 90 Z"/></g>' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-1.1s" d="M200 72 C191 63, 195 50, 200 43 C205 50, 209 63, 200 72 Z"/></g>' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.6s" d="M241.5 98 C234 90, 237 80, 241.5 74 C246 80, 249 90, 241.5 98 Z"/></g>' +
        '</g>' +
        '<g fill="#fff3d6" opacity="0.55">' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.45s" d="M158.5 88 C154 82, 156 75, 158.5 71 C161 75, 163 82, 158.5 88 Z"/></g>' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-1.4s" d="M200 70 C195 63, 197 53, 200 48 C203 53, 205 63, 200 70 Z"/></g>' +
          '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.85s" d="M241.5 96 C237 90, 239 83, 241.5 79 C244 83, 246 90, 241.5 96 Z"/></g>' +
        '</g>' +
        '<rect x="120" y="158" width="160" height="4" rx="2" fill="' + g + '" opacity="0.4"/>',
      arcane:
        /* v35 wizard hat. v37.11 the star shines/glows purple. */
        '<g class="ffg-h-hat">' +
          '<ellipse cx="200" cy="151" rx="76" ry="12" fill="' + g + '" opacity="0.4"/>' +
          '<path d="M162 151 Q190 120 199 82 Q203 62 217 58 Q206 76 209 98 Q214 126 238 151 Z" fill="' + g + '" opacity="0.55"/>' +
          '<path d="M178 132 Q200 142 222 132 L220 124 Q200 133 180 124 Z" fill="' + gb + '" opacity="0.45"/>' +
          '<g class="ffg-h-star" fill="' + gb + '" opacity="0.8"><polygon class="ffg-anim-star" points="200,92 203,103 214,103 205,110 208,121 200,114 192,121 195,110 186,103 197,103"/></g>' +
        '</g>' +
        /* v38.2 magic sparkles drift around the whole hat, staggered so a little burst of
           magic pops every so often. Each is base opacity 0 (hidden in the static
           PNG export); the animation brings it in only on the live card + the present
           reveal. Outer g positions, inner g animates (avoids the SVG-attr vs CSS
           transform conflict). */
        '<g class="ffg-h-sparks" fill="' + gb + '">' +
          '<g transform="translate(208 44) scale(0.9)"><g class="ffg-anim-magic" opacity="0" style="animation-delay:0s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(252 78)"><g class="ffg-anim-magic" opacity="0" style="animation-delay:-1.4s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(268 126) scale(0.7)"><g class="ffg-anim-magic" opacity="0" style="animation-delay:-2.6s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(134 124) scale(0.8)"><g class="ffg-anim-magic" opacity="0" style="animation-delay:-0.7s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
          '<g transform="translate(156 74) scale(0.6)"><g class="ffg-anim-magic" opacity="0" style="animation-delay:-3.4s"><path d="M0 -6 C0.9 -1.8 1.8 -0.9 6 0 C1.8 0.9 0.9 1.8 0 6 C-0.9 1.8 -1.8 0.9 -6 0 C-1.8 -0.9 -0.9 -1.8 0 -6 Z"/></g></g>' +
        '</g>',
      wilds:
        /* v-evergreen2 the sun is centred and sways in a slow, smooth arc that
           stays in frame (see ffgSceneOrbit). It no longer fades out or resets. */
        '<g class="ffg-anim-orbit">' +
          '<circle cx="200" cy="48" r="20" fill="' + gb + '" opacity="0.2"/>' +
          '<circle cx="200" cy="48" r="20" fill="none" stroke="' + gb + '" stroke-width="1.5" opacity="0.55"/>' +
        '</g>' +
        '<g class="ffg-h-mtn--front" fill="' + g + '" opacity="0.45">' +
          '<polygon points="60,165 100,95 140,165"/><polygon points="120,165 165,80 210,165"/>' +
          '<polygon points="250,165 295,100 340,165"/>' +
        '</g>' +
        '<g class="ffg-h-mtn--back" fill="' + g + '" opacity="0.3"><polygon points="0,165 70,120 150,165"/><polygon points="230,165 320,118 400,165"/></g>' +
        '<rect x="0" y="163" width="400" height="4" fill="' + g + '" opacity="0.4"/>',
      hall:
        /* v-evergreen each pillar carries its own arch cap in the same group, so
           when a pillar lowers on hover the cap sinks with it instead of floating. */
        '<g class="ffg-h-pillars">' +
          '<g class="ffg-h-pillar"><rect x="74" y="60" width="16" height="100" fill="' + g + '" opacity="0.4"/><path d="M74 60 Q82 44 90 60" fill="none" stroke="' + g + '" stroke-width="2" opacity="0.45"/></g>' +
          '<g class="ffg-h-pillar"><rect x="150" y="60" width="16" height="100" fill="' + g + '" opacity="0.4"/><path d="M150 60 Q158 44 166 60" fill="none" stroke="' + g + '" stroke-width="2" opacity="0.45"/></g>' +
          '<g class="ffg-h-pillar"><rect x="234" y="60" width="16" height="100" fill="' + g + '" opacity="0.4"/><path d="M234 60 Q242 44 250 60" fill="none" stroke="' + g + '" stroke-width="2" opacity="0.45"/></g>' +
          '<g class="ffg-h-pillar"><rect x="310" y="60" width="16" height="100" fill="' + g + '" opacity="0.4"/><path d="M310 60 Q318 44 326 60" fill="none" stroke="' + g + '" stroke-width="2" opacity="0.45"/></g>' +
        '</g>' +
        /* v37.11 extra pillars rise in then vanish, so the hall keeps shifting
           back to its four. Hidden (opacity 0) in the static export. */
        '<g fill="' + g + '">' +
          '<rect class="ffg-anim-pillar" style="animation-delay:0s" x="112" y="60" width="16" height="100" opacity="0"/>' +
          '<rect class="ffg-anim-pillar" style="animation-delay:-1.1s" x="40" y="60" width="16" height="100" opacity="0"/>' +
          '<rect class="ffg-anim-pillar" style="animation-delay:-2.2s" x="272" y="60" width="16" height="100" opacity="0"/>' +
          '<rect class="ffg-anim-pillar" style="animation-delay:-3.3s" x="344" y="60" width="16" height="100" opacity="0"/>' +
        '</g>' +
        /* v-evergreen2 a throne stands at the centre where the middle pillar
           would be. Tall rounded back with an upholstered inset, a small crown
           and corner orbs, scrolled arms, a cushioned seat on layered steps, a
           hanging banner behind, and a soft glow. Smooth curves throughout,
           gold to match, the static centrepiece of the hall. */
        '<circle class="ffg-anim-glow ffg-glow--soft" cx="200" cy="104" r="60" fill="' + gb + '" opacity="0.06"/>' +
        /* arched alcove behind the throne, echoing the pillar caps */
        '<path d="M174,152 L174,88 Q174,56 200,56 Q226,56 226,88 L226,152 Z" fill="' + g + '" opacity="0.10"/>' +
        '<path d="M174,152 L174,88 Q174,56 200,56 Q226,56 226,88 L226,152" fill="none" stroke="' + g + '" stroke-width="2" opacity="0.30"/>' +
        /* layered dais steps */
        '<g fill="' + g + '" opacity="0.5">' +
          '<rect x="160" y="151" width="80" height="9" rx="2.5"/>' +
          '<rect x="171" y="143" width="58" height="9" rx="2.5"/>' +
        '</g>' +
        /* tall throne back, corner orbs */
        '<g fill="' + g + '" opacity="0.6">' +
          '<path d="M185,130 L185,92 Q185,80 197,79 L203,79 Q215,80 215,92 L215,130 Z"/>' +
          '<circle cx="186" cy="86" r="3.2"/><circle cx="214" cy="86" r="3.2"/>' +
        '</g>' +
        /* upholstered inset on the back */
        '<path d="M191,125 L191,95 Q191,86 199,85 L201,85 Q209,86 209,95 L209,125 Z" fill="' + gb + '" opacity="0.28"/>' +
        /* crown finial above the back */
        '<g fill="' + gb + '" opacity="0.6">' +
          '<path d="M193,80 L195,71 L200,77 L205,71 L207,80 Z"/>' +
          '<circle cx="195" cy="70" r="1.6"/><circle cx="205" cy="70" r="1.6"/><circle cx="200" cy="75" r="1.7"/>' +
        '</g>' +
        /* scrolled arms with round volute ends */
        '<g fill="' + g + '" opacity="0.6">' +
          '<rect x="173" y="113" width="14" height="5" rx="2.5"/><circle cx="174" cy="120" r="4"/>' +
          '<rect x="213" y="113" width="14" height="5" rx="2.5"/><circle cx="226" cy="120" r="4"/>' +
        '</g>' +
        /* cushioned seat + apron */
        '<g fill="' + g + '" opacity="0.6">' +
          '<rect x="180" y="124" width="40" height="9" rx="3"/>' +
          '<rect x="182" y="132" width="36" height="9" rx="2"/>' +
        '</g>' +
        '<rect x="184" y="126" width="32" height="3" rx="1.5" fill="' + gb + '" opacity="0.3"/>' +
        /* v-evergreen2 a few clean motes drift up off the throne. Base opacity 0 so
           the static export stays still; the live card animates them in, staggered
           so only one or two show at a time. */
        '<g fill="' + gb + '">' +
          '<circle class="ffg-anim-spark ffg-spark--soft" style="animation-delay:0s" cx="200" cy="72" r="1.4" opacity="0"/>' +
          '<circle class="ffg-anim-spark ffg-spark--soft" style="animation-delay:-0.7s" cx="190" cy="92" r="1.2" opacity="0"/>' +
          '<circle class="ffg-anim-spark ffg-spark--soft" style="animation-delay:-1.3s" cx="210" cy="90" r="1.1" opacity="0"/>' +
          '<circle class="ffg-anim-spark ffg-spark--soft" style="animation-delay:-2s" cx="176" cy="116" r="1.2" opacity="0"/>' +
          '<circle class="ffg-anim-spark ffg-spark--soft" style="animation-delay:-2.5s" cx="224" cy="116" r="1.2" opacity="0"/>' +
        '</g>' +
        '<rect x="0" y="160" width="400" height="4" fill="' + g + '" opacity="0.4"/>',
      ember:
        /* v35 symmetric flame. v37.11 the flame flickers + sparks rise off it. */
        '<circle class="ffg-anim-glow" cx="200" cy="106" r="58" fill="' + gb + '" opacity="0.10"/>' +
        '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.3s" d="M200 152 C 158 124, 176 82, 200 58 C 224 82, 242 124, 200 152 Z" fill="' + g + '" opacity="0.5"/></g>' +
        '<g class="ffg-h-flame"><path class="ffg-anim-flame" style="animation-delay:-.9s" d="M200 146 C 178 126, 188 98, 200 80 C 212 98, 222 126, 200 146 Z" fill="' + gb + '" opacity="0.75"/></g>' +
        '<g fill="' + gb + '">' +
          '<circle class="ffg-anim-spark" style="animation-delay:0s" cx="188" cy="120" r="2.2" opacity="0"/>' +
          '<circle class="ffg-anim-spark" style="animation-delay:-1.3s" cx="212" cy="120" r="1.8" opacity="0"/>' +
          '<circle class="ffg-anim-spark" style="animation-delay:-2.4s" cx="200" cy="118" r="2" opacity="0"/>' +
          '<circle class="ffg-anim-spark" style="animation-delay:-3.2s" cx="178" cy="122" r="1.5" opacity="0"/>' +
        '</g>' +
        '<rect x="120" y="158" width="160" height="3" rx="1.5" fill="' + g + '" opacity="0.4"/>',
      /* v36.9 Love hearts. v37.11 each heart gently drifts + breathes (staggered). */
      love: (function () {
        var hp = 'M12 21 C12 21 3 13.5 3 8.5 C3 5.5 5.5 4 7.5 4 C9.5 4 11 5.5 12 7 C13 5.5 14.5 4 16.5 4 C18.5 4 21 5.5 21 8.5 C21 13.5 12 21 12 21 Z';
        var pink = '#ED96FD', cyan = '#AAFEFE';
        var hearts = [
          [200, 80, 2.4, pink, 0.85], [120, 60, 1.2, cyan, 0.6], [285, 55, 1.5, gb, 0.55],
          [80, 122, 1.1, cyan, 0.5], [322, 120, 1.3, pink, 0.6], [156, 142, 1.0, gb, 0.5],
          [246, 138, 1.2, cyan, 0.55], [58, 82, 0.85, pink, 0.45], [350, 78, 0.95, gb, 0.4]
        ];
        var out = '<circle class="ffg-anim-glow" cx="200" cy="82" r="58" fill="' + pink + '" opacity="0.10"/>';
        for (var hi = 0; hi < hearts.length; hi++) {
          var ht = hearts[hi];
          out += '<g class="ffg-h-heart" data-bx="' + ht[0] + '" data-by="' + ht[1] + '" transform="translate(' + ht[0] + ',' + ht[1] + ')">' +
            '<g class="ffg-anim-fheart" style="animation-delay:' + (-(hi * 0.6)).toFixed(1) + 's">' +
              '<path transform="scale(' + ht[2] + ') translate(-12,-12)" d="' + hp + '" fill="' + ht[3] + '" opacity="' + ht[4] + '"/>' +
            '</g>' +
          '</g>';
        }
        return out;
      })()
    };
    return open + (scenes[key] || scenes.wilds) + '</svg>';
  }
  /* v30 the same scene as a data URL, so the export canvas can raster it
     into the banner and match the on-screen preview. Self-contained SVG
     (inline colors, no external refs), so it does not taint the canvas. */
  function inviteSceneDataUrl(key) {
    /* Add an explicit intrinsic size so the rasterized image scales
       predictably when drawn onto the export canvas. */
    var svg = inviteSceneSVG(key).replace('<svg ', '<svg width="400" height="200" ');
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  /* Small wax seal motif for the sealed code slot. A serrated gold
     disc with the FF monogram, so the empty slot reads as a sealed
     envelope she has not opened yet. */
  function inviteSealSVG() {
    return '<svg class="ffg-invite__waxsvg" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="32" cy="32" r="22" fill="#7a1f1a"/>' +
      '<circle cx="32" cy="32" r="22" fill="none" stroke="#9c2a22" stroke-width="3"/>' +
      '<circle cx="32" cy="32" r="15" fill="none" stroke="#c9837c" stroke-width="1" opacity="0.6"/>' +
      '<text x="32" y="39" text-anchor="middle" font-family="Cinzel, Georgia, serif" font-size="16" font-weight="700" fill="#e8c0bc">FF</text>' +
      '</svg>';
  }
  /* v27 sanitize a pasted code. Uppercase, keep letters, numbers, and
     dashes only, cap the length. Returns '' for anything too short to be
     a real Shopify code. No server check, this only prints her code onto
     the card, he claims his portrait at FramedFantasy.com/Gift. */
  function sanitizeCode(s) {
    var c = (s || '').toUpperCase().replace(/[^A-Z0-9\-]/g, '').slice(0, 32);
    return c.length >= 4 ? c : '';
  }
  /* Message presets. First person, from her to him, tuned to pull care
     and protection of a loved one (she honors him, she protects the
     part of him the world overlooks). She can use one untouched or
     edit it. The build-it-and-own-it effect fires either way because
     she chose and placed it. */
  var INVITE_PRESETS = [
    'Most people never see this side of you. I do. This year I wanted you to see it too.',
    'You are always the one looking out for everyone else. This time it is your turn to be looked after.',
    'You have carried this whole crew for as long as I have known you. I made you something that says I noticed.',
    'There is a version of you that only comes out when you play. I wanted to give that part of you a face.',
    'You step in before any of us even sees it coming. I notice, even when you think no one does.',
    /* v26: index 5 funny, index 6 clever. */
    'You are the one who makes the whole table laugh. I wanted to give that part of you a face.',
    'You are always three moves ahead, and I love watching you do it. I wanted to give that part of you a face.'
  ];
  /* v30 short labels for the message picker. The picker shows the gist so
     the list stays scannable. The full line above goes on the card, where
     she reads it in full. Index-aligned with INVITE_PRESETS. */
  var INVITE_PRESET_LABELS = [
    'The side only I see',
    'Your turn to be the hero',
    'You carry us all',
    'The character you play',
    'You step in for us',
    'You make the whole table laugh',
    'You are always three moves ahead'
  ];
  /* The collapsed picker's current line. A preset shows its gist, her own
     written line shows its text (the field truncates it). */
  function msgPickLabel() {
    var p = state.cardMsgPreset;
    if (p !== 'custom' && p !== '' && INVITE_PRESET_LABELS[parseInt(p, 10)]) {
      return INVITE_PRESET_LABELS[parseInt(p, 10)];
    }
    return (state.cardMessage || '').trim() || 'Choose a message';
  }

  function renderBuilder() {
    state.view = 'builder';
    if (!state.cardTheme) state.cardTheme = defaultThemeForHobby();
    /* v-evergreen seed the preset as the instant fallback, then ask the AI for
       the personalized message (cached + guarded, so this is a no-op if it has
       already run or is in flight). It applies in place when it returns. */
    if (!state.cardMessage) seedCardFromAnswers();
    aiGenerateCard();
    save();
    paint(builderHTML(), false, function () {
      bindBuilder();
      mountMarquees(screenEl());
      /* v28 bring the page's real reviews into the proof beat. No-ops if
         there is no Loox section on the page. */
      mountLoox();
    });
  }

  /* The invitation preview, inner HTML only (no wrapper). Re-rendered
     on every edit. Lives in its own node so re-rendering it never
     disturbs focus in the control fields. */
  /* A made-up code shown in the preview so she sees exactly what the
     finished card looks like before she buys. Her real code replaces it
     once she pastes it (paste-to-unlock). It is only a sample. */
  var SAMPLE_CODE = 'XXXX-XXXX';
  /* The name line. Her typed name wins. With no name it falls back to
     who she is buying for, so it reads "For your partner" not a generic
     line. */
  /* v37.1 occasion. The first quiz question lets her pick Father's Day (the
     default) or his birthday, and that re-themes the card copy that depends on
     the occasion: the greeting, the date stamp, and the "give him the card on X"
     buyer step. Father's Day keeps everything Father's-Day; birthday swaps it.
     Read dynamically so EYEBROW_LABEL (editor-set) still drives the FD stamp. */
  /* v-evergreen2 holiday timing. The four fixed-date occasions only belong on the
     Q1 list near their date. Each shows inside a lead window and hides the day
     after. Everything else (birthday, anniversary, the D&D milestones) is dateless
     and always shows. HOLIDAY_LEAD is the only knob, the days before the date a
     holiday starts showing. Christmas gets a longer runway for gift lead time. */
  var HOLIDAY_LEAD = { valentines: 42, mothers_day: 42, fathers_day: 42, christmas: 56 };
  function ffgMidnight(d) { d.setHours(0, 0, 0, 0); return d; }
  /* nth weekday of a month. month is 0 based, weekday 0 is Sunday. Used for the two
     floating holidays, Mother's Day (2nd Sunday of May) and Father's Day (3rd Sunday
     of June). Valentine's and Christmas are fixed dates. */
  function nthWeekdayOfMonth(year, month, weekday, n) {
    var first = new Date(year, month, 1).getDay();
    var day = 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
    return new Date(year, month, day);
  }
  function holidayDateForYear(key, year) {
    if (key === 'valentines') return new Date(year, 1, 14);
    if (key === 'christmas') return new Date(year, 11, 25);
    if (key === 'mothers_day') return nthWeekdayOfMonth(year, 4, 0, 2);
    if (key === 'fathers_day') return nthWeekdayOfMonth(year, 5, 0, 3);
    return null;
  }
  /* Whole days from today to the next time a holiday lands. If this year's date has
     already passed, it rolls to next year, so a holiday that just ended reads as far
     off (and stays hidden) instead of going negative. */
  function holidayDaysUntil(key) {
    var today = ffgMidnight(new Date());
    var d = holidayDateForYear(key, today.getFullYear());
    if (!d) return null;
    ffgMidnight(d);
    if (d.getTime() < today.getTime()) { d = holidayDateForYear(key, today.getFullYear() + 1); ffgMidnight(d); }
    return Math.round((d.getTime() - today.getTime()) / 86400000);
  }
  function holidayVisible(key) {
    var lead = HOLIDAY_LEAD[key];
    if (lead == null) return true;
    var du = holidayDaysUntil(key);
    if (du == null) return false;
    return du >= 0 && du <= lead;
  }
  /* The Q1 chips, date filtered and ordered. Visible holidays come first, nearest
     date first, so the closest holiday is the lead chip. The dateless reasons follow
     in their listed order. Hidden holidays drop off the chips but still map from
     typed text, so someone can always type "valentines" out of season. */
  function occasionOptions() {
    var all = (function () {
      for (var i = 0; i < QUESTIONS.length; i++) { if (QUESTIONS[i].key === 'occasion') return QUESTIONS[i].options; }
      return [];
    })();
    var holidays = [], evergreen = [];
    for (var j = 0; j < all.length; j++) {
      var o = all[j];
      if (o.holiday) { if (holidayVisible(o.holiday)) holidays.push({ o: o, du: holidayDaysUntil(o.holiday) }); }
      else evergreen.push(o);
    }
    holidays.sort(function (a, b) { return a.du - b.du; });
    var out = [];
    for (var h = 0; h < holidays.length; h++) out.push(holidays[h].o);
    for (var e = 0; e < evergreen.length; e++) out.push(evergreen[e]);
    return out;
  }
  function occasionKey() {
    /* v-evergreen reads the occasion she picked on Q1 (stored as the key).
       Falls back to 'other' (a warm, dateless gift) if somehow unset, so the
       card never silently assumes Father's Day. */
    return state.occasion || 'other';
  }
  /* The big line on the card. "Other" has no fixed occasion phrase, so it greets
     him warmly without naming a day. */
  function occasionGreet() {
    var map = {
      fathers_day: 'Happy Father\'s Day',
      mothers_day: 'Happy Mother\'s Day',
      birthday: 'Happy Birthday',
      anniversary: 'Happy Anniversary',
      valentines: 'Happy Valentine\'s Day',
      christmas: 'Merry Christmas',
      graduation: 'Congratulations',
      wedding: 'Congratulations',
      retirement: 'Congratulations',
      congratulations: 'Congratulations',
      thank_you: 'Thank You',
      defeated_bbeg: 'Victory',
      campaign_finale: 'What a run',
      fallen_hero: 'Never forgotten',
      new_campaign: 'A new adventure',
      just_because: 'For you',
      other: 'For you'
    };
    return map[occasionKey()] || 'For you';
  }
  /* The small datestamp above the greeting. FD uses the editor-set label so the
     year stays current; the rest get a fixed stamp. */
  function occasionStamp() {
    var map = {
      fathers_day: 'HAPPY FATHER\'S DAY',
      mothers_day: 'HAPPY MOTHER\'S DAY',
      birthday: 'HAPPY BIRTHDAY',
      anniversary: 'HAPPY ANNIVERSARY',
      valentines: 'HAPPY VALENTINE\'S DAY',
      christmas: 'MERRY CHRISTMAS',
      graduation: 'CONGRATULATIONS',
      wedding: 'CONGRATULATIONS',
      retirement: 'CONGRATULATIONS',
      congratulations: 'CONGRATULATIONS',
      thank_you: 'THANK YOU',
      defeated_bbeg: 'VICTORY',
      campaign_finale: 'CAMPAIGN COMPLETE',
      fallen_hero: 'IN MEMORY',
      new_campaign: 'A NEW CAMPAIGN',
      just_because: 'A GIFT FOR YOU',
      other: 'A GIFT FOR YOU'
    };
    return map[occasionKey()] || 'A GIFT FOR YOU';
  }
  /* The "when do I hand it over" buyer step. FD/birthday/anniversary name the day;
     "other" stays open since there is no fixed date. Returns the full sentence so
     each case reads naturally. */
  function occasionGiveStep() {
    /* v-evergreen3 step 3. Dated occasions name the day, open-ended ones stay
       flexible. The line now describes the recipient's small part (open the card,
       answer a few quick questions) instead of pointing at the in-page present
       reveal, so the three steps read as one clean path. First person on the last
       sentence keeps the by-hand artisan voice. */
    var when = {
      fathers_day: 'On Father\'s Day',
      mothers_day: 'On Mother\'s Day',
      birthday: 'On their birthday',
      anniversary: 'On your anniversary',
      valentines: 'On Valentine\'s Day',
      christmas: 'On Christmas morning',
      graduation: 'At the celebration',
      wedding: 'At the celebration',
      retirement: 'At the send-off',
      congratulations: 'When you celebrate',
      thank_you: 'When the moment is right',
      defeated_bbeg: 'At your next session',
      campaign_finale: 'At the last session',
      fallen_hero: 'When the moment is right',
      new_campaign: 'At session zero',
      just_because: 'When the moment is right',
      other: 'When the moment is right'
    }[occasionKey()] || 'When the moment is right';
    return when + ', they open the card and answer a few quick questions about their character. [[I take care of the rest]] by hand.';
  }
  /* v38.26 device detection for the "keep this page" step. Touch/coarse pointer or
     a mobile UA reads as a phone (say save the link); otherwise a computer (say
     bookmark it). No keyboard shortcut. The code is mentioned in step 1 now. */
  function ffgIsTouch() {
    try {
      if ((navigator.maxTouchPoints || 0) > 1) return true;
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    } catch (e) { return false; }
  }
  function bookmarkStep() {
    return ffgIsTouch()
      ? 'Save this page so it is ready on the day.'
      : 'Bookmark this page so it is ready on the day.';
  }
  /* v37.9.4 the occasion worded for the reveal headline ("Customize your ___ card").
     "Something else" has no label, so the headline reads just "your card". */
  function occasionLabel() {
    var map = {
      fathers_day: 'Father\'s Day',
      mothers_day: 'Mother\'s Day',
      birthday: 'birthday',
      anniversary: 'anniversary',
      valentines: 'Valentine\'s',
      christmas: 'Christmas',
      graduation: 'graduation',
      wedding: 'wedding',
      defeated_bbeg: 'victory',
      campaign_finale: 'campaign',
      fallen_hero: 'tribute',
      new_campaign: 'adventure'
    };
    return map[occasionKey()] || '';
  }
  /* v29 the big line is the occasion greeting, so the card reads as the right
     card the moment he sees it. Her name for him wins. With no name, the dad and
     family routes still address him as Dad, the others greet him without a name. */
  function inviteGreeting() {
    var g = occasionGreet();
    var name = (state.hisName || '').trim();
    if (name) return g + ', ' + name;
    var voc = pron().vocative;
    if (voc) return g + ', ' + voc;
    return g;
  }
  /* v29 the sign-off, so the card is signed by whoever sent it. Her own
     name wins on any route. Otherwise it falls back to the relationship
     she gave on question one, so most routes need no extra input. The
     dad route has no fitting relationship word, so with no name it signs
     from the family. */
  function inviteSignoff() {
    var from = (state.fromName || '').trim();
    var p = pron();
    /* Friendly and celebratory registers do not sign with "Love,". */
    if (p.register === 'celebratory') return from ? (from + ', your DM') : 'Your DM';
    if (p.register === 'friendly') return from ? ('Your friend, ' + from) : 'Your friend';
    if (from) return 'Love, ' + from;
    if (p.signoff) return 'Love, ' + p.signoff;
    return 'With love';
  }
  /* The hint shown in the optional from field, so she can see what the
     card will say if she leaves it blank. */
  function fromPlaceholder() {
    var p = pron();
    if (p.register === 'celebratory') return 'Leave blank to sign from your DM';
    if (p.register === 'friendly') return 'Leave blank to sign from your friend';
    if (p.signoff) return 'Leave blank to sign from ' + p.signoff;
    return 'Add your name';
  }
  /* v36.6 the claim block at the bottom of the card. Instead of a bare code
     and a hover "?", the card itself spells out exactly how he brings his
     character to life: the gift he has, the three steps, and his code. It is
     written so the card reads as a finished, prepackaged gift the moment he
     opens it. Before she finishes his gift it shows a sample code and a clear
     disclaimer that the steps go live once she does, so a downloaded sample
     never reads as a working gift. Route-aware (quest vs photo). */
  /* v37.6 (Changes 4 + 5) the editable "your character" value for the claim
     gift line on the card. Her in-place card edit wins, then the name she
     captured in the quiz (the "same one for years" answer), then the default
     "your character". Shared by the live card and the PNG export so they stay
     in sync. */
  function cardCharacterValue() {
    var edit = (state.cardCharacter && state.cardCharacter.trim());
    if (edit) return edit;
    var quiz = (state.characterName && state.characterName.trim());
    if (quiz) return quiz;
    return 'your character';
  }
  /* v37.0 the gift line is the white SUBTEXT under the gold eyebrow, leading
     into the three steps (copy per Jan).
     v37.6 (Change 4) only the "your character" words are editable on the
     card, so she can put his character's name on it (for example "a hand
     painted Thigh up portrait of Bramblefoot."). The size word, the rest of
     the sentence, and the trailing period stay fixed. The photo route keeps
     the fixed "you as the hero" since there is no single character there.
     v39.1 extracted so a size change can rebuild just this line in place
     (updateClaimGiftLine) instead of repainting the whole card front. */
  function claimGiftHTML() {
    var character = state.giftRoute !== 'portrait';
    var sz = selectedSize();
    var giftPrefix = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of '
      : 'Your gift is a hand painted portrait of ';
    return character
      ? esc(giftPrefix) +
          '<span class="ffg-invite__claim-char" id="ffg-invite-character" contenteditable="true" role="textbox" spellcheck="false" aria-label="The character name, tap to edit" data-ph="your character">' +
            esc(cardCharacterValue()) +
          '</span>.'
      : esc(giftPrefix + 'you as the hero.');
  }
  function inviteCodeBox(rc) {
    var character = state.giftRoute !== 'portrait';
    var giftHTML = claimGiftHTML();
    /* v37.4 Jan: "Here is how to bring it to life." sits on its own line. */
    var bringLine = 'Here is how to bring it to life.';
    /* The three steps he follows. Static copy, so the URL can be bolded
       directly. Step 2 is route-aware (quest vs photo). */
    var step2 = character
      ? 'Take the character quest and download your blueprint.'
      : 'Send your best photo so I have your likeness.';
    /* v37.5 (Change 6) — step 3 rewrite. The old line never told him to
       send the blueprint; the flow was missing its handoff. The new line
       names the explicit action (check out, then send the blueprint) and
       keeps the timeline beat. Verbatim per the build prompt. */
    var steps = [
      'Go to <b class="ffg-invite__claim-url">FramedFantasy.com/Gift</b>.',
      step2,
      'Check out with your code, then send me your blueprint. About two weeks later you review your finished portrait.'
    ];
    var stepsHTML = '';
    for (var i = 0; i < steps.length; i++) {
      stepsHTML += '<li><span class="ffg-invite__claim-n">' + (i + 1) + '</span><span>' + steps[i] + '</span></li>';
    }
    /* v36.9 gold eyebrow on top, then the white subtext, then the steps. */
    return '<div class="ffg-invite__claim">' +
        '<p class="ffg-invite__claim-head">Claim your portrait</p>' +
        '<p class="ffg-invite__claim-gift">' + giftHTML + '</p>' +
        '<p class="ffg-invite__claim-bring">' + esc(bringLine) + '</p>' +
        '<ol class="ffg-invite__claim-steps">' + stepsHTML + '</ol>' +
      '</div>';
  }

  function invitePreviewInner() {
    var rc = routeCopy();
    /* v34.1 every line is edited in place on the card. Each shows her
       override if she typed one, otherwise the value built from her answers. */
    var greeting = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
    var summons = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : rc.summons;
    var signoff = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
    var msg = (state.cardMessage || '').replace(/^\s+|\s+$/g, '');
    /* v-evergreen while the AI message is still generating, the message area
       shows a "writing" animation instead of the seeded preset, so she never
       sees a placeholder line get swapped out. When the message lands (or the
       fallback fires) it reveals word by word. pendingReveal is a one-shot. */
    var aiPending = (state.aiStatus === 'loading' && state.cardMsgPreset !== 'custom' && state.cardMsgPreset !== 'ai');
    var msgInner, msgCls, msgEditable = true;
    if (aiPending) {
      msgInner = '<span class="ffg-invite__writing" aria-hidden="true"><span></span><span></span><span></span></span>';
      msgCls = 'ffg-invite__msg ffg-invite__msg--writing';
      msgEditable = false;
    } else if (pendingReveal && msg) {
      msgInner = revealWordsHTML(msg);
      msgCls = 'ffg-invite__msg ffg-invite__msg--reveal';
      pendingReveal = false;
    } else {
      msgInner = msg ? esc(msg).replace(/\n/g, '<br>') : '';
      msgCls = 'ffg-invite__msg' + (msg ? '' : ' ffg-invite__msg--placeholder');
    }
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    /* Art layer. An uploaded scene photo wins. Otherwise the hand-drawn
       SVG scene for this world fills the band, so picking a world
       changes the whole scene, not a color. */
    var artInner = artUrl
      ? '<div class="ffg-invite__photo" style="background-image:url(\'' + esc(artUrl) + '\');"></div>'
      : inviteSceneSVG(themeKey);
    var artCls = 'ffg-invite__art ffg-invite__art--' + esc(themeKey) + (artUrl ? ' ffg-invite__art--photo' : '');
    /* v36.3 no portrait image is drawn on the card anymore. The size only sets
       the code-box line and the variant the buy adds, so the card keeps its
       full scene band and stays a clean, fixed-height keepsake (the morph made
       it too tall and clipped the scene). The portrait lives on the wall, not
       on the card. */
    var cardCls = 'ffg-invite ffg-invite--' + esc(themeKey);
    /* v34.1 the card reads as a keepable object and every line is tappable
       to edit in place. The datestamp stays a fixed occasion label. */
    return '<div class="' + cardCls + '">' +
      '<div class="ffg-invite__frame">' +
        '<p class="ffg-invite__datestamp" id="ffg-invite-stamp" contenteditable="true" role="textbox" spellcheck="false" aria-label="The label at the top, tap to edit" data-ph="A gift for you">' + esc((state.cardStamp && state.cardStamp.trim()) ? state.cardStamp : occasionStamp()) + '</p>' +
        '<div class="' + artCls + '">' + artInner + '</div>' +
        '<div class="ffg-invite__body">' +
          '<p class="ffg-invite__greeting" id="ffg-invite-greeting" contenteditable="true" role="textbox" spellcheck="false" aria-label="The greeting, tap to edit" data-ph="The greeting">' + esc(greeting) + '</p>' +
          '<div class="ffg-summons-row">' +
            '<p class="ffg-invite__summons" id="ffg-invite-summons" contenteditable="true" role="textbox" spellcheck="false" aria-label="A line under their name, tap to edit" data-ph="A line under their name">' + esc(summons) + '</p>' +
            '<button type="button" class="ffg-summons-refresh" id="ffg-summons-refresh" aria-label="Try a different line" title="Try a different line">' + refreshGlyph() + '</button>' +
          '</div>' +
          '<p class="' + msgCls + '" id="ffg-invite-msg" contenteditable="' + (msgEditable ? 'true' : 'false') + '" role="textbox" aria-multiline="true" aria-label="Your message, tap to edit" spellcheck="false" data-ph="Tap to write your own message">' + msgInner + '</p>' +
          '<p class="ffg-invite__signoff" id="ffg-invite-signoff" contenteditable="true" role="textbox" spellcheck="false" aria-label="How you sign it, tap to edit" data-ph="How you sign it">' + esc(signoff) + '</p>' +
          /* v-link the claim steps are removed from the buyer's card face. They belong to
             the recipient, and now live on the recipient card and in the value block below. */
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* v37.8 two-sided flip card. ---------------------------------------------
     The portrait side shows a full-bleed character image for the selected
     size, with the character name in gold near the bottom. The image comes
     from the per-size sample-portrait settings (size1/2/3_image); until Jan
     uploads them, each size falls back to a distinct portfolio placeholder so
     the side is never empty. */
  /* v37.9 the example portrait per size (Jan-supplied art), each with the name of
     the character it shows. An uploaded per-size image in the editor still wins. */
  var SIZE_PORTRAIT = {
    half:  { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Cullen_Dragonborn_v2_HD.webp?v=1780790187', name: 'Drakkar' },
    thigh: { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/AustinKinderEdit6copy.jpg?v=1780778658', name: 'Anduin' },
    full:  { img: 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/FramedFantasy_Hero_Full_Body.webp?v=1780055109', name: 'Ambessa' }
  };
  function sizePortraitUrl(sz) {
    if (sz && sz.image) return sz.image;
    var d = sz && SIZE_PORTRAIT[sz.key];
    if (d) return d.img;
    return GALLERY_DEFAULT.length ? GALLERY_DEFAULT[0] : '';
  }
  /* The name of the character shown in the example art for this size. */
  function sizePortraitName(sz) {
    var d = sz && SIZE_PORTRAIT[sz.key];
    return d ? d.name : '';
  }
  /* The size whose portrait the card shows. The selected size wins; before any
     pick we hold the first size so the image can preload and the face is ready. */
  function currentPortraitSize() {
    return selectedSize() || (SIZES.length ? SIZES[0] : null);
  }
  /* The gold name on the portrait. Her own character name wins (edit, then quiz
     value). With none, it shows the name of the character in the example art for
     the current size (Ember / Lily / Ambessa), so the sample reads as a finished,
     named card. Falls to empty (hidden) only if there is no example name. */
  function portraitDisplayName() {
    var edit = (state.cardCharacter && state.cardCharacter.trim());
    if (edit) return edit;
    var quiz = (state.characterName && state.characterName.trim());
    if (quiz) return quiz;
    return sizePortraitName(currentPortraitSize());
  }
  /* v38.10 the sample note names the size, e.g. "An example of a completed thigh up
     portrait", so it reads as a clear sample of exactly what he gets at that size.
     Tracks the selected size live. */
  function portraitSampleLabel() {
    var sz = currentPortraitSize();
    var nm = (sz && sz.name) ? sz.name.toLowerCase() : '';
    return nm ? 'An example of a completed ' + nm + ' portrait' : 'An example of a completed portrait';
  }
  /* The portrait face content. Image + scrim + a prominent size-aware sample banner
     at the top + the gold name at the bottom. */
  function invitePortraitInner() {
    var url = sizePortraitUrl(currentPortraitSize());
    var name = portraitDisplayName();
    return '<img class="ffg-portrait__img" id="ffg-portrait-img" src="' + esc(url) + '" alt="" decoding="async">' +
      '<div class="ffg-portrait__scrim" aria-hidden="true"></div>' +
      '<p class="ffg-portrait__label" id="ffg-portrait-label">' + esc(portraitSampleLabel()) + '</p>' +
      '<p class="ffg-portrait__name" id="ffg-portrait-name">' + esc(name) + '</p>';
  }
  /* The flip scaffold: message face (in flow, defines height) + portrait face
     (absolute over the same box). updateInvitePreview re-renders only the front
     face, so the flip wrapper and portrait face persist across edits/themes.
     v37.9.2 no flip icon: tapping any non-editable spot on the card flips it. */
  function invitePreviewShell() {
    /* v37.9.3 a tilt wrapper sits between the perspective container and the flip
       element. It carries the live mouse-follow tilt (a small rotateX/rotateY)
       so the card leans toward the cursor, while the inner keeps owning the flip
       (rotateY 180). Separate layers so the two transforms never fight. */
    return '<div class="ffg-flip" id="ffg-flip">' +
      '<div class="ffg-flip__tilt" id="ffg-flip-tilt">' +
        '<div class="ffg-flip__inner" id="ffg-flip-inner">' +
          '<div class="ffg-flip__face ffg-flip__face--message" id="ffg-flip-front" role="button" tabindex="0" aria-label="Tap the card to see the portrait side">' + invitePreviewInner() + '</div>' +
          '<div class="ffg-flip__face ffg-flip__face--portrait" id="ffg-portrait-face" role="button" tabindex="0" aria-label="Tap to flip back to the card">' + invitePortraitInner() + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* v34.1 the redemption explainer, now the body of the how-it-works
     lightbox. It tells her plainly what she just made him and the three
     steps to get it to him, ending at FramedFantasy.com/Gift. The code is
     typed straight onto the card, so there is no input here anymore. */
  function unlockBlockInner() {
    var p = pron();
    var S = p.subj, O = p.obj, isPl = (S === 'they');
    return '<p class="ffg-redeem__head">What you just made</p>' +
      '<p class="ffg-redeem__lead">A hand painted portrait of the character ' + S + ' ' + (isPl ? 'play' : 'plays') + '. Here is how it reaches ' + O + '.</p>' +
      '<ol class="ffg-redeem__steps">' +
        '<li><span class="ffg-redeem__n">1</span><span>Finish the gift to lock in the portrait.</span></li>' +
        '<li><span class="ffg-redeem__n">2</span><span>Type the code you get onto the card, then download it and give it to ' + O + '.</span></li>' +
        '<li><span class="ffg-redeem__n">3</span><span>' + cap(S) + ' ' + (isPl ? 'enter' : 'enters') + ' the code at FramedFantasy.com/Gift and I paint the character by hand.</span></li>' +
      '</ol>';
  }
  /* v34.1 the how-it-works lightbox. It auto-opens the first time she taps
     the code area on the card, and the small help button reopens it. The
     steps live here so the card stays clean and she still learns what the
     XXXX code is for. */
  function stepsLightboxHTML() {
    return '<div class="ffg-lightbox" id="ffg-steps-lightbox" hidden>' +
      '<div class="ffg-lightbox__backdrop" data-ffg-steps-close></div>' +
      '<div class="ffg-lightbox__panel" role="dialog" aria-modal="true" aria-label="How the code works">' +
        '<button type="button" class="ffg-lightbox__close" data-ffg-steps-close aria-label="Close">&times;</button>' +
        unlockBlockInner() +
      '</div>' +
    '</div>';
  }

  function builderHTML() {
    var rc = routeCopy();
    var giftUrl = (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
    /* v36.6 product-page reveal. Desktop reads like a real product page: the
       card is the "product image" on the LEFT (card on top, then the colour
       picker, then the download right under it), and it stays in view (sticky)
       while the buyer scrolls the buy column on the RIGHT. The right column is
       laid out like a product page: star reviews + a short headline above the
       size options, the buy button right under the options, and the longer
       detail (how it works for her + the For him / For you reasons) below it,
       so nothing long blocks the options. Reviews run full width below. On
       mobile it stacks into one intuitive flow. */
    return '<div class="ffg-builder ffg-builder--centered ffg-builder--product ffg-reveal-2p is-phase1">' +
      '<a class="ffg-wordmark ffg-result__wordmark" href="/" aria-label="FramedFantasy home">FRAMEDFANTASY</a>' +
      '<h1 class="ffg-builder__head">' + esc('Customize your ' + (occasionLabel() ? occasionLabel() + ' ' : '') + 'card') + '</h1>' +
      '<p class="ffg-builder__sub">I made it from your answers. Every line is yours to change, so tap any field on the card to make it theirs, or leave it just as it is.</p>' +
      '<div class="ffg-reveal-split">' +
        '<div class="ffg-reveal-split__media">' +
          '<div class="ffg-builder__preview" id="ffg-invite-preview">' + invitePreviewShell() + '</div>' +
          '<p class="ffg-frameline">This is the card they&#39;ll open. Choose a size below and check out, and the portrait is paid in full.</p>' +
          themePickerHTML() +
          /* v38.4 phase 1 confirm. While building, this is the only button under the
             card + colours. Clicking it reveals the rest of the page (phase 2), where
             it is replaced by the Present / Download actions below. */
          '<div class="ffg-confirm" id="ffg-confirm-wrap">' +
            '<button type="button" class="ffg-confirm__btn" id="ffg-confirm-card">' +
              '<span class="ffg-confirm__label">Looks good</span>' +
              '<span class="ffg-confirm__arrow" aria-hidden="true">&rarr;</span>' +
            '</button>' +
          '</div>' +
          '<div class="ffg-builder__dl" id="ffg-builder-dl">' + downloadBlock() + '</div>' +
        '</div>' +
        '<div class="ffg-reveal-split__info">' +
          buyTopHTML() +
          reviewsCarouselHTML() +
          sizesSelectorHTML() +
          '<div class="ffg-builder__finish">' + finishInner(rc, giftUrl) + '</div>' +
          valueBlockHTML() +
          buyDetailHTML() +
        '</div>' +
      '</div>' +
      /* v37.7 the "Good to know" FAQ, full width, its own quiet section directly
         above the reviews. */
      faqHTML() +
      /* The Loox reviews widget, full width below the split. No-ops if the page
         has no Loox section to bring in. */
      '<div id="ffg-loox-mount" class="ffg-loox-mount" aria-label="Customer reviews"></div>' +
      /* v37.5 (Change 5) — sticky scroll nudge.
         Mirrors the .ff-stickybar mechanic from product.d-d-custom-sales:
           - Hidden until the buy area scrolls out of view
           - Slides up from the bottom (mobile) / sits along the bottom (desktop)
           - Click → smooth-scroll back to the SIZE PICKER (not the button),
             so she lands on the choice rather than being dropped at the
             top or having a size auto-selected for her.
           - Dismissible via the × button; sessionStorage flag keeps it
             gone for the rest of this visit (clears on tab close).
           - Mounted as a fixed-position element, kept inside the reveal
             container so it tears down cleanly if the quiz unmounts. */
      '<div class="ffg-stickynudge" id="ffg-stickynudge" aria-hidden="true" role="region" aria-label="Continue to gift">' +
        '<div class="ffg-stickynudge__inner">' +
          '<div class="ffg-stickynudge__text">' +
            '<span class="ffg-stickynudge__title">Their card is ready.</span>' +
            '<span class="ffg-stickynudge__sub">Their portrait is the gift they keep.</span>' +
          '</div>' +
          '<button type="button" class="ffg-stickynudge__cta" id="ffg-stickynudge-cta">Give them their adventure</button>' +
          '<button type="button" class="ffg-stickynudge__dismiss" id="ffg-stickynudge-dismiss" aria-label="Dismiss">&times;</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }
  /* v36.6 the product-page top of the buy column: star reviews, a short
     benefit headline, and one subtitle line. Kept deliberately short so the
     size options sit high, not buried under copy. Route-aware. */
  function buyTopHTML() {
    /* v37.5 (Change 1) — title + subhead rewrite. Per Jan: the previous title
       led with a feature ("painted by hand") and never told her what the
       free card was vs. what the paid gift was. The new title names the
       portrait as the gift and keeps the card as the moment. Universal copy
       across both routes (character / portrait) per the build prompt.
       v37.10 the product title is now the emotional headline "He'll talk
       about this for years", with "years" in the same gold accent (.ffg-em)
       as the hero headline on the main screen. The subhead drops its old
       "for years" so the word is not repeated under the title. */
    var titleHTML = 'The gift they&#39;ll talk about for <span class="ffg-em">years</span>';
    /* v-evergreen3 subhead. Dropped the old "Not a portrait off a shelf" opener
       per Jan: this IS a character portrait, so calling it "not a portrait" read as
       a contradiction. The kept line says the real point on its own. */
    var subhead = 'They open it, and bring their own character to life.';
    return '<div class="ffg-buytop">' +
      '<div class="ffg-stars" role="img" aria-label="Rated 5.0 from over 500 five star reviews">' +
        '<span class="ffg-stars__row" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
        '<span class="ffg-stars__text">500+ five star reviews</span>' +
      '</div>' +
      '<h2 class="ffg-buytop__title">' + titleHTML + '</h2>' +
      '<p class="ffg-buytop__sub">' + subhead + '</p>' +
    '</div>';
  }
  /* v37.5 (Changes 2 + 3 + reorder) — under-button detail rewritten:
       1. The "For him" / "For you" columns are gone. They read like a spec
          sheet inside an emotional moment, and the labels sorted the value
          into buckets that did not need sorting.
       2. Four universal value lines replace them. Each is its own beat,
          short, and route-agnostic. The standalone "Almost everyone I
          paint for…" reassurance paragraph is removed — value-line #4
          already says the equivalent in fewer words, so keeping both was
          redundant.
       3. Order swap per Jan's UX note: reasons before process. The four
          value lines render before the "How it works for you" steps, so the
          buyer reads WHY this is worth her time before she scans her own
          to-do list.
       v37.7 (Change 2): this block is now the WHOLE under-button column, one
       cohesive flush left-aligned section. finishInner() owns only the CTA
       above it; the availability, reassurance, and proof lines lead this
       block, then the value lines, then How it works. */
  /* v-link the "what you're paying for" value block. It carries the buyer-facing
     explanation that used to crowd the card face, and on mobile it sits below the CTA. */
  function valueBlockHTML() {
    /* v-evergreen3 (Jan) the old single dense paragraph is split into a clear lead
       line + one reassurance line. Delivery, the code, the questions, and the
       turnaround all move down into "How it works" so this block stays purely about
       WHAT she is buying. Leads with the payoff for a most-aware buyer. */
    return '<div class="ffg-valueblock">' +
        '<p class="ffg-valueblock__h">What you\'re paying for</p>' +
        '<p class="ffg-valueblock__lead">A portrait of their character, <span class="ffg-gold">painted by hand</span>. The one that has only ever lived in their head, finally real.</p>' +
        '<p class="ffg-valueblock__p">You don\'t need to know a thing about their character. They do, and they\'ll love telling me everything.</p>' +
      '</div>';
  }
  function buyDetailHTML() {
    var buyerSteps = [
      'Make the card yours and check out. Your code lands in your inbox [[within minutes]].',
      'Give it your way. Email the card straight to them, or grab the link and send it yourself.',
      occasionGiveStep()
    ];
    var stepHTML = '';
    for (var s = 0; s < buyerSteps.length; s++) {
      stepHTML += '<li><span class="ffg-buysteps__n">' + (s + 1) + '</span><span>' + presentLinkify(buyerSteps[s], 'ffg-present-link') + '</span></li>';
    }
    /* v-evergreen3 two emotional beats (down from four). Line 1 (they have played
       this for years) moved up into the valueblock lead, and the old line 4 ("He
       just answers...") moved into step 3, where it also fixes the stray "He" that
       broke the they/them voice. These two carry the payoff. */
    var valueLines = [
      'It\'s the rare gift they [[actually use]]. Their avatar online, their token at the table, their phone wallpaper, a framed print on the wall.',
      'They open it, and their character comes to life in front of them. That moment is the gift as much as the painting.'
    ];
    var valueHTML = '';
    for (var v = 0; v < valueLines.length; v++) {
      valueHTML += '<p class="ffg-value-lines__item">' + presentLinkify(valueLines[v]) + '</p>';
    }
    /* v37.7 (Change 2) everything under the buy button is one cohesive,
       flush, left-aligned column with tight even spacing, in this order:
       availability, reassurance, proof, the four value lines, then How it
       works. The availability line is the single honest act-now reason and
       gives the in-stock dots above it a meaning. The reassurance and proof
       lines moved here out of finishInner so nothing reads as a separate
       scrap. No divider, no indent, no loud scarcity styling. */
    /* v37.7 the availability + reassurance lines moved into the FAQ ("Good to
       know") below. The block opens straight on the proof line now. */
    /* v39.1 (Rebuild 1) the code pre frame line, approved by Jan. It sits
       first, directly under the CTA, and sets up what happens after checkout
       so the gift card code never jars her. */
    return '<div class="ffg-buydetail">' +
      /* v-evergreen3 emotional payoff first (the strongest lever for a most-aware
         buyer), then one quiet proof line, then the clean How-it-works path. The
         old standalone code line is gone: the code now lives in step 1 and the
         "paid in full" reassurance closes the steps, so nothing is said twice. */
      '<div class="ffg-value-lines">' + valueHTML + '</div>' +
      '<p class="ffg-reveal__microtrust">Over a thousand portraits, painted by hand since 2022. More than 500 five star reviews, and a <span class="ffg-gold">money back guarantee</span> on every order.</p>' +
      '<div class="ffg-buysteps">' +
        '<p class="ffg-buydetail__label">How it works for you</p>' +
        '<ol class="ffg-buysteps__list">' + stepHTML + '</ol>' +
        '<p class="ffg-buysteps__after">Their portrait is <span class="ffg-gold">paid in full</span>, and about two weeks later it\'s theirs.</p>' +
      '</div>' +
    '</div>';
  }
  /* v37.7 the "Good to know" FAQ. A quiet accordion that sits full width above
     the reviews. Every row is collapsed on load; tapping a question opens its
     answer (smooth grid-rows expand) and tapping again closes it. Rows are
     independent so several can be open. Copy is verbatim (per Jan). */
  /* v38.1 FAQ copy rewrite (verbatim per Jan). New title, then six Q&A. */
  var FAQ_TITLE = 'What you\'re probably wondering';
  /* v38.21 each answer is an array of blocks: a string is a paragraph, an object
     { list: [...] } is a bullet list. The [Present the card](#present-card) marker
     inside any paragraph or bullet renders as an inline link that opens the same
     reveal as the Present the card button (see faqInline + bindFaq). */
  var FAQS = [
    /* v-evergreen FAQ neutralized to they/their and made occasion-agnostic
       (no hardcoded Father's Day). Same voice and structure as Jan's copy. */
    { q: 'What makes this different from a normal gift?', a: [
      'There is a part of them almost no one in their life has really seen. You have.',
      'Most gifts get a thank you and a drawer. This one shows them you saw the thing they love.'
    ] },
    { q: 'Don\'t they already have a picture of their character?', a: [
      'Probably a placeholder. A lot of players keep a rough one, the way a quick sketch stands in for a real photo. You can tell who it is meant to be, but everything that makes them who they are is missing.',
      'This is the real one. I paint their details by hand from their own description until it is unmistakably theirs, and I keep going until they see themselves in it.',
      'Just below, players describe what it is like to finally see their character done right.'
    ] },
    { q: 'Do they have to do anything?', a: [
      'Normally a commission is a lot of back and forth before anything ever gets painted. After four years and more than a thousand of these, I have turned that part into something they will actually look forward to. They play a short quest and describe their character in their own words. Most people get into it without even realizing they are handing me everything I need.',
      { gold: 'You never have to know a thing about their character. That part is completely on them, not you.' },
      'Do not just take my word for it. Read the reviews below, then press [Present the card](#present-card) and run through the experience yourself.'
    ] },
    { q: 'What if they do not love it?', a: [
      'They will, because they are the one shaping it. They describe their own character and see it before anything is final, so it is built around their picture of it, not mine. If anything is off, I keep revising until it is right.',
      'I play these games myself, so getting them right matters to me as much as it does to you. Out of more than a thousand portraits, fewer than five people have ever asked for their money back. Every order still carries that guarantee, so you are protected either way.'
    ] },
    { q: 'Will it be ready in time?', a: [
      'Yes, with room to spare. The card is ready the moment you check out, so you have something real to give on the day no matter what. I am usually booked weeks out, and this gift skips that line.',
      'Here is exactly how it goes.',
      { list: [
        'You check out now and your code lands in your inbox within minutes.',
        'On the day, you present the card and hand over the code.',
        'They play their quest whenever they are ready.',
        'Around two weeks after they play it, their finished portrait is ready.'
      ] }
    ] }
  ];
  /* escape a line, then turn the [Present the card](#present-card) marker into a
     real inline link (bound to openPresent in bindFaq). cls picks the look:
     ffg-faq__present is the underlined FAQ link, ffg-present-link is the subtle
     no-underline variant used inside the buyer steps. */
  function presentLinkify(text, cls) {
    return esc(text)
      .replace(/\[Present the card\]\(#present-card\)/g,
        '<a class="' + (cls || 'ffg-faq__present') + '" href="#present-card" data-ffg-present>Present the card</a>')
      /* v-evergreen3 [[phrase]] renders as a clean gold accent. Fixed-literal copy only. */
      .replace(/\[\[(.+?)\]\]/g, '<span class="ffg-gold">$1</span>');
  }
  function faqInline(text) { return presentLinkify(text, 'ffg-faq__present'); }
  function faqAnswerHTML(blocks) {
    var out = '';
    for (var b = 0; b < blocks.length; b++) {
      var blk = blocks[b];
      if (blk && blk.list) {
        var items = '';
        for (var k = 0; k < blk.list.length; k++) { items += '<li>' + faqInline(blk.list[k]) + '</li>'; }
        out += '<ul class="ffg-faq__bullets">' + items + '</ul>';
      } else if (blk && blk.gold) {
        out += '<p class="ffg-faq__a ffg-faq__a--gold">' + faqInline(blk.gold) + '</p>';
      } else {
        out += '<p class="ffg-faq__a">' + faqInline(blk) + '</p>';
      }
    }
    return out;
  }
  function faqHTML() {
    var rows = '';
    for (var i = 0; i < FAQS.length; i++) {
      var aid = 'ffg-faq-a-' + i, qid = 'ffg-faq-q-' + i;
      rows += '<div class="ffg-faq__item">' +
        '<button type="button" class="ffg-faq__q" id="' + qid + '" aria-expanded="false" aria-controls="' + aid + '">' +
          '<span class="ffg-faq__qtext">' + esc(FAQS[i].q) + '</span>' +
          '<span class="ffg-faq__chev" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' +
          '</span>' +
        '</button>' +
        '<div class="ffg-faq__panel" id="' + aid + '" role="region" aria-labelledby="' + qid + '">' +
          '<div class="ffg-faq__panel-inner">' + faqAnswerHTML(FAQS[i].a) + '</div>' +
        '</div>' +
      '</div>';
    }
    return '<section class="ffg-faq" aria-label="' + esc(FAQ_TITLE) + '">' +
      '<h2 class="ffg-faq__head">' + esc(FAQ_TITLE) + '</h2>' +
      '<div class="ffg-faq__list">' + rows + '</div>' +
    '</section>';
  }
  function bindFaq(root) {
    var qs = (root || document).querySelectorAll('.ffg-faq__q');
    Array.prototype.forEach.call(qs, function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentNode;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    /* v38.21 every inline "Present the card" link (FAQ + the buyer step) opens
       the same reveal as the Present the card button. Guard against double-binding
       since this can be called on the whole screen. */
    var links = (root || document).querySelectorAll('[data-ffg-present]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.__ffgPresentBound) return;
      a.__ffgPresentBound = true;
      a.addEventListener('click', function (e) { e.preventDefault(); openPresent(); });
    });
  }
  /* v34 the color theme picker. Clickable swatches under the card that
     re-skin the whole card live, palette and scene. The active one is the
     world-derived default until she picks another. */
  function themePickerHTML() {
    var cur = state.cardTheme || defaultThemeForHobby();
    var row = '';
    for (var i = 0; i < INVITE_ART_THEMES.length; i++) {
      var t = INVITE_ART_THEMES[i];
      var on = t.key === cur;
      row += '<button type="button" class="ffg-theme' + (on ? ' is-active' : '') + '" data-ffg-theme="' + esc(t.key) + '" aria-pressed="' + (on ? 'true' : 'false') + '" title="' + esc(t.label) + '">' +
        '<span class="ffg-theme__swatch" style="background:' + esc(t.swatch) + '" aria-hidden="true"></span>' +
        '<span class="ffg-theme__name">' + esc(t.label) + '</span>' +
      '</button>';
    }
    return '<div class="ffg-themes" id="ffg-themes" role="group" aria-label="Card theme">' +
      '<p class="ffg-themes__label">Pick their theme</p>' +
      '<div class="ffg-themes__row">' + row + '</div>' +
    '</div>';
  }

  /* v27.1 the download lives directly under the card preview so she sees
     straight away that she can download what she is building. Quiet
     outline secondary while she is still building (the buy is the hero
     below), then the gold primary once she pastes his code and it becomes
     the finished, code-bearing card. The note names plainly what the
     download contains so the free version never reads as the finished
     gift on its own. */
  /* v36.3 a clear download glyph (a tray with a downward arrow) instead of the
     bare arrow, so the action reads at a glance. Inherits the gold via
     currentColor on the glyph span. */
  /* v-evergreen the "try a different question" icon: two arrows chasing in a
     ring. It idles with a slow spin to read as tappable and pops on tap. */
  function refreshGlyph() {
    return '<svg class="ffg-refresh__svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 12a9 9 0 0 1 15.5-6.3L21 8"/>' +
      '<polyline points="21 3 21 8 16 8"/>' +
      '<path d="M21 12a9 9 0 0 1-15.5 6.3L3 16"/>' +
      '<polyline points="3 21 3 16 8 16"/>' +
    '</svg>';
  }
  function dlGlyph() {
    return '<span class="ffg-dl__glyph" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 3v11"/><path d="M7.5 10l4.5 4.5 4.5-4.5"/><path d="M5 20.5h14"/>' +
      '</svg>' +
    '</span>';
  }
  /* v37.10 a play glyph for the "Present the card" button (launches the reveal). */
  function playGlyph() {
    return '<span class="ffg-dl__glyph" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none"><path d="M7 4.5v15l13-7.5z"/></svg>' +
    '</span>';
  }
  function downloadBlock() {
    /* v-link the only action under the card is a preview of the recipient's opening
       experience. The download is removed: the shareable link is the only delivery. */
    return '<div class="ffg-cardactions">' +
        '<button type="button" class="ffg-dl__icon" id="ffg-invite-present" aria-label="Preview their opening experience">' +
          playGlyph() + ' Preview their opening experience' +
        '</button>' +
      '</div>';
  }
  /* v-link bind the preview action. The download button is gone. */
  function bindDownload() {
    var pr = document.getElementById('ffg-invite-present');
    if (pr) pr.addEventListener('click', openPresent);
  }

  /* v39 (Rebuild 4) one light, dismissible prompt that leads her into the
     reveal once, right after she confirms the card and the buy column
     appears. It sits inline under the card actions, never a wall. The ×
     dismisses it, opening the reveal any other way also retires it, and the
     persisted presentPromptSeen flag keeps it to a single appearance. The
     line is the sentence Jan already shipped in the old first FAQ answer,
     reused here so the reveal keeps its strongest invitation. Flagged for
     copy approval. */
  function dismissPresentPrompt() {
    var p = document.getElementById('ffg-present-prompt');
    if (p && p.parentNode) p.parentNode.removeChild(p);
    if (!state.presentPromptSeen) { state.presentPromptSeen = true; save(); }
  }
  function showPresentPrompt() {
    if (state.presentPromptSeen) return;
    if (document.getElementById('ffg-present-prompt')) return;
    var dl = document.getElementById('ffg-builder-dl');
    if (!dl || !dl.parentNode) return;
    var p = document.createElement('div');
    p.className = 'ffg-presentprompt';
    p.id = 'ffg-present-prompt';
    p.setAttribute('role', 'note');
    p.innerHTML =
      '<button type="button" class="ffg-presentprompt__close" id="ffg-present-prompt-close" aria-label="Dismiss">&times;</button>' +
      '<p class="ffg-presentprompt__line">Press Present the card now and you will feel exactly what they will.</p>' +
      '<button type="button" class="ffg-presentprompt__cta" id="ffg-present-prompt-cta">' + playGlyph() + ' Present the card</button>';
    dl.parentNode.insertBefore(p, dl.nextSibling);
    var close = document.getElementById('ffg-present-prompt-close');
    if (close) close.addEventListener('click', dismissPresentPrompt);
    var cta = document.getElementById('ffg-present-prompt-cta');
    if (cta) cta.addEventListener('click', function () { dismissPresentPrompt(); openPresent(); });
  }

  /* ============================================================
     v37.10 PRESENT — the in-page unboxing reveal experience.
     Launchable any time from "Present the card". It dims the page, centres a
     sealed envelope, the buyer taps it three times (a heart floats up each
     tap), it bursts open, the card rises out and writes itself, and the claim
     ends on one tap-through CTA. Re-openable + resettable so they can rehearse
     the reveal for the day. Built on demand, torn down on close. */
  /* v38.26 the three charge-up hint lines under the envelope: resting, after tap 1,
     after tap 2. Father's Day themed instead of the old generic "Keep going". */
  var PRESENT_HINTS = { open: 'Open your gift', tap1: 'Keep going', tap2: 'Almost yours' };
  var presentState = { taps: 0, busy: false, timers: [], scrollY: 0 };
  function presentClearTimers() {
    for (var i = 0; i < presentState.timers.length; i++) { clearTimeout(presentState.timers[i]); }
    presentState.timers = [];
  }
  function presentT(fn, ms) { var id = setTimeout(fn, ms); presentState.timers.push(id); return id; }
  /* v38.18 the portrait (sample) side of the PRESENT card. Same image + size-aware
     sample label + gold name as the live card, but ID-free so it can coexist with
     the builder card behind the overlay (the present card is a static snapshot). */
  function presentPortraitInner() {
    var url = sizePortraitUrl(currentPortraitSize());
    return '<img class="ffg-portrait__img" src="' + esc(url) + '" alt="" decoding="async">' +
      '<div class="ffg-portrait__scrim" aria-hidden="true"></div>' +
      '<p class="ffg-portrait__label">' + esc(portraitSampleLabel()) + '</p>' +
      '<p class="ffg-portrait__name">' + esc(portraitDisplayName()) + '</p>';
  }
  /* The read-only card for the reveal: same look as the live card (theme, art,
     lines) but not editable, and flippable to the portrait sample side just like
     the live card. The claim ends on a single step-one CTA to /gift. */
  function presentCardInner() {
    var character = state.giftRoute !== 'portrait';
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    var artInner = artUrl
      ? '<div class="ffg-invite__photo" style="background-image:url(\'' + esc(artUrl) + '\');"></div>'
      : inviteSceneSVG(themeKey);
    var artCls = 'ffg-invite__art ffg-invite__art--' + esc(themeKey) + (artUrl ? ' ffg-invite__art--photo' : '');
    var greeting = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
    var summons = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : routeCopy().summons;
    var signoff = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
    var msg = (state.cardMessage || '').replace(/^\s+|\s+$/g, '');
    var sz = selectedSize();
    var subject = character ? cardCharacterValue() : 'you as the hero';
    var giftLine = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of ' + subject + '.'
      : 'Your gift is a hand painted portrait of ' + subject + '.';
    /* The claim block differs by mode. Buyer preview keeps the existing one-step
       "Get started" that links to /gift, unchanged. The recipient (paid link) gets
       the real claim panel: a "Claim my portrait" button that reveals the code
       (wired in openPresent -> doRecipientClaim). */
    var claim;
    if (PRESENT_MODE === 'recipient') {
      claim = '<div class="ffg-invite__claim ffg-present__claim ffg-cv-claim" id="ffg-cv-claim">' +
          '<p class="ffg-invite__claim-head">Your gift</p>' +
          '<p class="ffg-invite__claim-gift">A hand painted portrait of your character, already paid for.</p>' +
          '<ol class="ffg-cv-claim__steps">' +
            '<li>Tap below to get your code.</li>' +
            '<li>Answer a few quick questions about your character, or send a photo.</li>' +
            '<li>About two weeks later your finished portrait is ready.</li>' +
          '</ol>' +
          '<button type="button" class="ffg-present__cta ffg-cv-claim__btn" id="ffg-cv-claim-btn">Claim my portrait <span class="ffg-present__cta-arrow" aria-hidden="true">&rarr;</span></button>' +
        '</div>';
    } else {
      /* one tap-through step (per Jan), links to /gift */
      claim = '<div class="ffg-invite__claim ffg-present__claim">' +
          '<p class="ffg-invite__claim-head">Claim your portrait</p>' +
          '<p class="ffg-invite__claim-gift">' + esc(giftLine) + '</p>' +
          '<a class="ffg-present__cta" id="ffg-present-cta" href="/gift" target="_blank" rel="noopener">Get started <span class="ffg-present__cta-arrow" aria-hidden="true">&rarr;</span></a>' +
        '</div>';
    }
    return '<div class="ffg-flip ffg-present__flip" id="ffg-present-flip">' +
      '<div class="ffg-flip__tilt" id="ffg-present-tilt">' +
      '<div class="ffg-flip__inner">' +
        '<div class="ffg-flip__face ffg-flip__face--message">' +
          '<div class="ffg-invite ffg-invite--' + esc(themeKey) + '">' +
            '<div class="ffg-invite__frame">' +
              '<p class="ffg-invite__datestamp">' + esc((state.cardStamp && state.cardStamp.trim()) ? state.cardStamp : occasionStamp()) + '</p>' +
              '<div class="' + artCls + '">' + artInner + '</div>' +
              '<div class="ffg-invite__body">' +
                '<p class="ffg-invite__greeting ffg-present__rise ffg-present__rise--hero">' + esc(greeting) + '</p>' +
                '<p class="ffg-invite__summons ffg-present__rise">' + esc(summons) + '</p>' +
                '<p class="ffg-invite__msg ffg-present__rise">' + esc(msg) + '</p>' +
                '<p class="ffg-invite__signoff ffg-present__rise">' + esc(signoff) + '</p>' +
                '<div class="ffg-present__rise">' + claim + '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="ffg-flip__face ffg-flip__face--portrait">' + presentPortraitInner() + '</div>' +
      '</div>' +
      '</div>' +
    '</div>';
  }
  function presentHTML() {
    return '<div class="ffg-present" id="ffg-present" role="dialog" aria-modal="true" aria-label="Your card reveal">' +
      '<button type="button" class="ffg-present__close" id="ffg-present-close" aria-label="Close the reveal">&times;</button>' +
      '<div class="ffg-present__stage" id="ffg-present-stage">' +
        '<div class="ffg-present__env" id="ffg-present-env" role="button" tabindex="0" aria-label="Tap to open the card">' +
          '<div class="ffg-env__pocket" aria-hidden="true"></div>' +
          '<div class="ffg-env__tri" aria-hidden="true"></div>' +
          '<div class="ffg-env__flap" aria-hidden="true"></div>' +
          '<div class="ffg-env__seal" aria-hidden="true">' + presentSealSVG() + '</div>' +
          '<p class="ffg-present__hint" id="ffg-present-hint">' + esc(PRESENT_HINTS.open) + '</p>' +
        '</div>' +
        '<div class="ffg-present__card" id="ffg-present-card" aria-hidden="true">' + presentCardInner() + '</div>' +
      '</div>' +
      '<button type="button" class="ffg-present__replay" id="ffg-present-replay" hidden>Play again</button>' +
    '</div>';
  }
  function heartSVG() {
    /* v38.11 a clean heart, perfectly symmetric about the centre (x=12): every
       control point on the right mirrors the left, so both lobes match. */
    return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" stroke="none"><path d="M12 20.7 C12 20.7 2.4 13.9 2.4 7.8 C2.4 4.9 4.7 2.9 7.2 2.9 C9.2 2.9 10.9 4.1 12 5.9 C13.1 4.1 14.8 2.9 16.8 2.9 C19.3 2.9 21.6 4.9 21.6 7.8 C21.6 13.9 12 20.7 12 20.7 Z"/></svg>';
  }
  /* v38.28 per-theme reveal FX. Each card theme gets its own envelope seal emblem
     and its own burst particle, in colours pulled from that theme, so the reveal
     feels specific to the world he plays in. Love keeps the brand hearts. Minimal,
     clean shapes (single path, 24x24, currentColor) so they glow like the seal. */
  function flameSVG()       { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 22 C5 18 8 9 12 3 C16 9 19 18 12 22 Z"/></svg>'; }
  function candleFlameSVG() { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 3 C12 3 6 9 6 14 a6 6 0 0 0 12 0 C18 9 12 3 12 3 Z"/></svg>'; }
  function starSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 1 C12.5 8 16 11.5 23 12 C16 12.5 12.5 16 12 23 C11.5 16 8 12.5 1 12 C8 11.5 11.5 8 12 1 Z"/></svg>'; }
  function leafSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 2 C6 8 6 16 12 22 C18 16 18 8 12 2 Z"/></svg>'; }
  function gemSVG()         { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 2 L21 10 L12 22 L3 10 Z"/></svg>'; }
  function sparkSVG()       { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><path d="M12 1 L13.4 12 L12 23 L10.6 12 Z"/></svg>'; }
  function moteSVG()        { return '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor"><circle cx="12" cy="12" r="6"/></svg>'; }
  /* Love still cycles the two FramedFantasy brand tones plus a soft tint of each. */
  var PRESENT_HEART_COLORS = ['#e99df6', '#bbede8', '#f3c2f9', '#d4f4f0', '#e99df6', '#bbede8'];
  /* seal = the emblem on the envelope (kept brand gold, only the shape is themed).
     particle = the shape that bursts/drifts, in the theme's own colours.
     spin = how far each particle tumbles. v38.30 no gravity: every effect radiates
     OUTWARD evenly, as if the card is emitting it, never falling. */
  var PRESENT_THEME_FX = {
    love:   { seal: heartSVG,       particle: heartSVG, colors: PRESENT_HEART_COLORS,                         spin: 55 },
    tavern: { seal: candleFlameSVG, particle: moteSVG,  colors: ['#e8c674', '#c9a84c', '#fff3d6', '#f0d9a0'], spin: 35 },
    arcane: { seal: starSVG,        particle: starSVG,  colors: ['#b9a6f0', '#d4c2ff', '#e8c674', '#9f86e0'], spin: 90 },
    wilds:  { seal: leafSVG,        particle: leafSVG,  colors: ['#7fc99a', '#a8e0bd', '#c9a84c', '#5fae7d'], spin: 150 },
    hall:   { seal: gemSVG,         particle: gemSVG,   colors: ['#8fb0f0', '#c2d4ff', '#e8c674', '#6f93e0'], spin: 60 },
    ember:  { seal: flameSVG,       particle: sparkSVG, colors: ['#f0a25a', '#ff8c42', '#e8c674', '#ff6b35'], spin: 45 }
  };
  function currentPresentTheme() { return state.cardTheme || defaultThemeForHobby(); }
  function presentSealSVG() {
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    return fx.seal();
  }
  function presentRand(min, max) { return min + Math.random() * (max - min); }
  function spawnParticle(layer, cx, cy, dx, dy, scale, rot, dur, color, svg, extraClass) {
    if (!layer) return;
    var h = document.createElement('span');
    h.className = 'ffg-present__heart' + (extraClass ? ' ' + extraClass : '');
    h.style.left = cx + 'px';
    h.style.top = cy + 'px';
    h.style.color = color;
    h.style.setProperty('--ffg-dx', dx + 'px');
    h.style.setProperty('--ffg-dy', dy + 'px');
    h.style.setProperty('--ffg-sc', scale);
    h.style.setProperty('--ffg-rot', rot + 'deg');
    h.style.setProperty('--ffg-dur', dur + 'ms');
    h.innerHTML = svg || heartSVG();
    layer.appendChild(h);
    h.addEventListener('animationend', function () { if (h.parentNode) h.parentNode.removeChild(h); });
    /* safety removal if animationend never fires */
    presentT(function () { if (h.parentNode) h.parentNode.removeChild(h); }, dur + 400);
  }
  /* Fire `count` themed particles radially outward from (cx,cy). power (default 1)
     scales how far they fly, so each tap throws them further than the last. v38.30
     no gravity: a clean even radial burst, the same in every theme. Used by the
     envelope taps and the reveal (which emit from the envelope point). */
  function burstParticles(layer, cx, cy, count, power, themeKey) {
    if (!layer) return;
    count = count || 14;
    power = power || 1;
    var fx = PRESENT_THEME_FX[themeKey] || PRESENT_THEME_FX.love;
    var svg = fx.particle();
    for (var i = 0; i < count; i++) {
      var ang = (Math.PI * 2 * i) / count + presentRand(-0.35, 0.35);
      var dist = presentRand(70, 165) * power;
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist;
      var scale = presentRand(0.55, 1.45);
      var rot = presentRand(-fx.spin, fx.spin);
      var dur = presentRand(820, 1320);
      spawnParticle(layer, cx, cy, dx, dy, scale, rot, dur, fx.colors[i % fx.colors.length], svg);
    }
  }
  /* v-evergreen while an arcane (hat) card's scene is hovered, the card's own
     ambient halo reverses: each particle is born OUTSIDE and flies inward to the
     card, so the glints read as being sucked in. Released on leave, when the halo
     drifts outward again. Read by emitFromCardOnce, so both the builder card and
     the present card behave the same. */
  var cardSuckIn = false;
  /* v38.30 the card-emission effects. Particles are born on the card PERIMETER and
     travel OUTWARD (away from the card centre), so it reads as the card emitting
     them, never as gravity pulling them down. Shared by the present card and the
     builder card so every theme behaves the same clean way. */
  function emitFromCardOnce(layer, lr, r, fx, o) {
    if (!r.width || !r.height) return;
    var ccx = r.left + r.width / 2, ccy = r.top + r.height / 2;
    var side = Math.floor(presentRand(0, 4));
    var px, py;
    if (side === 0) { px = presentRand(r.left, r.right); py = r.top; }
    else if (side === 1) { px = r.right; py = presentRand(r.top, r.bottom); }
    else if (side === 2) { px = presentRand(r.left, r.right); py = r.bottom; }
    else { px = r.left; py = presentRand(r.top, r.bottom); }
    var vx = px - ccx, vy = py - ccy, m = Math.sqrt(vx * vx + vy * vy) || 1;
    vx /= m; vy /= m;
    var dist = presentRand(o.distMin, o.distMax);
    var jx = presentRand(-12, 12), jy = presentRand(-12, 12);
    var scale = presentRand(o.scaleMin, o.scaleMax);
    var rot = presentRand(-fx.spin, fx.spin) * 0.5;
    var dur = presentRand(o.durMin, o.durMax);
    var color = fx.colors[Math.floor(presentRand(0, fx.colors.length))];
    if (cardSuckIn) {
      /* born outside the card, travelling inward to the perimeter (sucked in) */
      spawnParticle(layer, (px + vx * dist) - lr.left, (py + vy * dist) - lr.top, -vx * dist + jx, -vy * dist + jy, scale, rot, dur, color, fx.particle(), o.cls);
    } else {
      spawnParticle(layer, px - lr.left, py - lr.top, vx * dist + jx, vy * dist + jy, scale, rot, dur, color, fx.particle(), o.cls);
    }
  }
  function emitFromCard(layer, cardEl, fx, o, count) {
    if (!layer || !cardEl) return;
    var lr = layer.getBoundingClientRect();
    var r = cardEl.getBoundingClientRect();
    count = count || 1;
    for (var i = 0; i < count; i++) { emitFromCardOnce(layer, lr, r, fx, o); }
  }
  /* the resting halo (now livelier, more present) and the tap spurt (a quick burst) */
  var FX_AMBIENT = { distMin: 30, distMax: 95, scaleMin: 0.6, scaleMax: 1.18, durMin: 2400, durMax: 3500, cls: 'ffg-present__heart--ambient' };
  var FX_SPURT   = { distMin: 72, distMax: 152, scaleMin: 0.55, scaleMax: 1.2, durMin: 700, durMax: 1160, cls: '' };
  function presentAmbientTick() {
    /* v-evergreen reduced motion stops the continuous particle halo. */
    if (reducedMotion()) return;
    var node = document.getElementById('ffg-present');
    var card = document.getElementById('ffg-present-card');
    /* stop quietly once the overlay closes or the card is no longer revealed */
    if (!node || !card || !card.classList.contains('is-revealed')) return;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    emitFromCard(node, card, fx, FX_AMBIENT, 2 + (Math.random() < 0.5 ? 1 : 0));
    presentT(presentAmbientTick, presentRand(280, 520));
  }
  /* v38.33 a tap fires a satisfying spray of the theme's particles OUT of the card
     edges. The card itself does not move, it is just the burst that pulses out. */
  function presentCardSpurt() {
    var node = document.getElementById('ffg-present');
    var card = document.getElementById('ffg-present-card');
    if (!node || !card) return;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    emitFromCard(node, card, fx, FX_SPURT, 16);
  }
  /* v38.30 the builder preview card carries the same ambient halo while she builds.
     The preview re-renders on a theme switch (innerHTML is replaced), so the FX layer
     self-heals: each tick re-creates it if it was wiped. */
  var builderFxRunning = false;
  /* ---------- v-evergreen card refreshable summons + interactive scene ---------- */
  /* A pool of less-generic summons lines, route aware. The refresh icon on the
     card cycles them into state.cardSummons; the canvas export reads the same
     field, so the PNG matches the preview. */
  var SUMMONS_LINES = {
    character: [
      'Time to bring them to life.',
      'Your story starts here.',
      'The table is set for you.',
      'Your character, made real.',
      'A hero pulled from your own world.',
      'This one is yours to play.',
      'Where the story finally takes shape.',
      'Your legend, in your hands.',
      'Step into the world they built.',
      'The one only you could give.'
    ],
    portrait: [
      'About to be made real.',
      'Soon, on your wall.',
      'Your hero, painted by hand.',
      'The portrait only you would think of.',
      'Made real, brushstroke by brushstroke.',
      'Your face, as the hero.',
      'Coming to life in paint.',
      'The one only you could give.'
    ]
  };
  function summonsPool() { return SUMMONS_LINES[state.giftRoute === 'portrait' ? 'portrait' : 'character']; }
  /* v-evergreen swap any refreshable line with a soft fade so the text never
     snaps. Reduced motion gets an instant swap. Used by every refresh icon. */
  function fadeSwapText(el, txt) {
    if (!el) return;
    if (reducedMotion()) { el.textContent = txt; return; }
    el.style.transition = 'opacity .16s ease';
    el.style.opacity = '0';
    setTimeout(function () { el.textContent = txt; el.style.opacity = '1'; }, 165);
  }
  function cycleSummons() {
    var pool = summonsPool();
    state.summonsIdx = ((state.summonsIdx || 0) + 1) % pool.length;
    state.cardSummons = pool[state.summonsIdx];
    save();
    fadeSwapText(document.getElementById('ffg-invite-summons'), state.cardSummons);
  }
  /* v-evergreen the scene reacts to the cursor instead of to clicks. Per theme:
     love hearts ease away from the pointer, tavern + ember flames flare as it
     crosses them, the arcane hat star shifts hue, the wilds mountains drift, and
     the hall pillars lower. Desktop fine-pointer only and off under reduced
     motion. It only ever touches inline CSS transform/filter on live DOM (and
     never the same property the looping keyframes drive on that node), so the
     scene animation and the PNG export are both left exactly as they were. */
  function sceneHoverApply(art, theme, vx, vy) {
    var i, els;
    /* arcane sucks the card's halo inward; every other theme leaves it drifting
       out. Set each frame so switching theme mid-hover can never leave it stuck. */
    cardSuckIn = (theme === 'arcane');
    if (theme === 'love') {
      els = art.querySelectorAll('.ffg-h-heart');
      for (i = 0; i < els.length; i++) {
        var el = els[i];
        var bx = parseFloat(el.getAttribute('data-bx')) || 0;
        var by = parseFloat(el.getAttribute('data-by')) || 0;
        var dx = bx - vx, dy = by - vy;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var push = dist < 76 ? (76 - dist) / 76 : 0;       // 0..1 inside the radius
        var ox = (dist ? dx / dist : 0) * push * 10;        // gentle, subtle drift away from the cursor
        var oy = (dist ? dy / dist : 0) * push * 10;
        el.style.transform = 'translate(' + (bx + ox).toFixed(1) + 'px,' + (by + oy).toFixed(1) + 'px)';
      }
    } else if (theme === 'tavern' || theme === 'ember') {
      /* the flames warp as the cursor passes through them, like a real flame
         disturbed by something moving past. The inner path keeps its flicker; this
         outer group bends (skew) and stretches a touch, pivoting at the base. */
      els = art.querySelectorAll('.ffg-h-flame');
      var ar = art.getBoundingClientRect();
      var sc = Math.max(ar.width / 400, ar.height / 200);   // slice-aware map, matches the cursor
      var aoffX = (ar.width - 400 * sc) / 2;
      var aoffY = (ar.height - 200 * sc) / 2;
      for (i = 0; i < els.length; i++) {
        var fr = els[i].getBoundingClientRect();
        var fx = ((fr.left + fr.width / 2 - ar.left) - aoffX) / sc;
        var fy = ((fr.top + fr.height / 2 - ar.top) - aoffY) / sc;
        var ddx = fx - vx, ddy = fy - vy;
        var fdist = Math.sqrt(ddx * ddx + ddy * ddy);
        var fnear = fdist < 78 ? (78 - fdist) / 78 : 0;
        if (fnear <= 0) { els[i].style.transform = ''; continue; }
        var lean = Math.max(-9, Math.min(9, -ddx * 0.45)) * fnear;   // bends away from the cursor
        els[i].style.transform = 'skewX(' + lean.toFixed(1) + 'deg) scaleY(' + (1 - fnear * 0.18).toFixed(3) + ')';  // ducks lower as it is disturbed
      }
    } else if (theme === 'arcane') {
      /* the card halo is already being sucked in (cardSuckIn above). On top of
         that, the hat's sparkles fade away and the hat itself shifts colour a
         touch. The PNG export is untouched (these are inline styles on live DOM). */
      var star = art.querySelector('.ffg-h-star');
      var sparks = art.querySelector('.ffg-h-sparks');
      if (star) star.classList.add('is-cursed');   // the star pulses dark evil purple; the hat stays gold
      if (sparks) sparks.style.opacity = '0';
    } else if (theme === 'wilds') {
      var f1 = art.querySelector('.ffg-h-mtn--front');
      var f2 = art.querySelector('.ffg-h-mtn--back');
      var off = (vx - 200) / 200;                            // -1 (left) .. 1 (right)
      if (f1) f1.style.transform = 'translateX(' + (off * 9).toFixed(1) + 'px)';
      if (f2) f2.style.transform = 'translateX(' + (off * 4.5).toFixed(1) + 'px)';  // back parallaxes less
    } else if (theme === 'hall') {
      /* the pillar nearest the cursor sinks, and its cap rides down with it
         because they share a group. */
      els = art.querySelectorAll('.ffg-h-pillar');
      for (i = 0; i < els.length; i++) {
        var rc = els[i].querySelector('rect');
        var px = rc ? (parseFloat(rc.getAttribute('x')) || 0) + 8 : 200;
        var dxp = Math.abs(px - vx);
        var nearp = dxp < 70 ? (70 - dxp) / 70 : 0;
        els[i].style.transform = 'translateY(' + (nearp * 14).toFixed(1) + 'px)';
      }
    }
  }
  function sceneHoverReset(art) {
    cardSuckIn = false;   // the arcane halo resumes drifting outward
    if (!art) return;
    var star = art.querySelector('.ffg-h-star'); if (star) star.classList.remove('is-cursed');   // star back to gold
    var spk = art.querySelector('.ffg-h-sparks'); if (spk) spk.style.opacity = '';                // hat sparkles fade back in
    var els = art.querySelectorAll('.ffg-h-heart, .ffg-h-flame, .ffg-h-mtn--front, .ffg-h-mtn--back, .ffg-h-pillar');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], cls = '' + (el.getAttribute('class') || '');
      if (cls.indexOf('ffg-h-heart') > -1) {
        el.style.transform = 'translate(' + (parseFloat(el.getAttribute('data-bx')) || 0) + 'px,' + (parseFloat(el.getAttribute('data-by')) || 0) + 'px)';
      } else {
        el.style.transform = '';
      }
    }
  }
  /* Delegated on the persistent card node so it survives the theme re-renders
     (the art band is rebuilt on every theme switch). One throttled rAF per move. */
  function bindCardHover(rootNode) {
    if (!rootNode || rootNode.__ffgHover || reducedMotion()) return;
    if (!(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;
    rootNode.__ffgHover = true;
    var hoverRaf = null, curArt = null, vx = 0, vy = 0;
    rootNode.addEventListener('mousemove', function (e) {
      var art = e.target && e.target.closest ? e.target.closest('.ffg-invite__art') : null;
      if (!art) { if (curArt) { sceneHoverReset(curArt); curArt = null; } return; }
      curArt = art;
      /* The scene SVG is viewBox 0 0 400 200 with preserveAspectRatio slice, so
         it scales to COVER the short art band and crops (mostly top/bottom).
         Undo that here so the cursor maps to the true viewBox point on screen,
         otherwise the heart repel + pillar drop would be off vertically. */
      var r = art.getBoundingClientRect();
      var scale = Math.max(r.width / 400, r.height / 200);
      var offX = (r.width - 400 * scale) / 2;
      var offY = (r.height - 200 * scale) / 2;
      vx = ((e.clientX - r.left) - offX) / scale;
      vy = ((e.clientY - r.top) - offY) / scale;
      if (hoverRaf) return;
      hoverRaf = requestAnimationFrame(function () {
        hoverRaf = null;
        if (curArt) sceneHoverApply(curArt, currentPresentTheme(), vx, vy);
      });
    });
    rootNode.addEventListener('mouseleave', function () {
      if (curArt) { sceneHoverReset(curArt); curArt = null; }
    });
  }
  function ensureBuilderFxLayer() {
    var pv = document.getElementById('ffg-invite-preview');
    if (!pv) return null;
    if (pv.style.position !== 'relative') pv.style.position = 'relative';
    var layer = pv.querySelector('#ffg-builder-fx');
    if (!layer) {
      layer = document.createElement('div');
      layer.id = 'ffg-builder-fx';
      layer.className = 'ffg-card-fx';
      layer.setAttribute('aria-hidden', 'true');
      pv.insertBefore(layer, pv.firstChild);
    }
    return layer;
  }
  function builderAmbientTick() {
    if (state.view !== 'builder') { builderFxRunning = false; return; }
    /* v-evergreen respect reduced motion: stop spawning ambient particles (saves
       mobile CPU/battery and honors the preference). The card scene still shows. */
    if (reducedMotion()) { builderFxRunning = false; return; }
    var pv = document.getElementById('ffg-invite-preview');
    if (!pv || !document.body.contains(pv)) { builderFxRunning = false; return; }
    var layer = ensureBuilderFxLayer();
    var card = pv.querySelector('.ffg-invite') || pv;
    var fx = PRESENT_THEME_FX[currentPresentTheme()] || PRESENT_THEME_FX.love;
    if (layer && card) emitFromCard(layer, card, fx, FX_AMBIENT, 1 + (Math.random() < 0.6 ? 1 : 0));
    setTimeout(builderAmbientTick, presentRand(420, 760));
  }
  function startBuilderFx() {
    if (builderFxRunning) return;
    builderFxRunning = true;
    setTimeout(builderAmbientTick, 450);
  }
  function presentReveal() {
    var card = document.getElementById('ffg-present-card');
    var env = document.getElementById('ffg-present-env');
    var replay = document.getElementById('ffg-present-replay');
    /* clear the swollen-seal inline transform so the .is-open rule can shrink it
       away as the envelope bursts open */
    var seal = env ? env.querySelector('.ffg-env__seal') : null;
    if (seal) { seal.style.animation = 'none'; seal.style.transform = ''; }
    if (env) env.classList.add('is-open');
    /* a big brand-coloured explosion from the envelope centre */
    var layer = document.getElementById('ffg-present');
    if (layer && env) {
      var r = env.getBoundingClientRect();
      var lr = layer.getBoundingClientRect();
      burstParticles(layer, r.left - lr.left + r.width / 2, r.top - lr.top + r.height / 2, 30, 1, currentPresentTheme());
    }
    /* fade the envelope away, raise the card with a glow flash */
    presentT(function () { if (env) env.classList.add('is-gone'); }, 220);
    presentT(function () {
      if (card) { card.setAttribute('aria-hidden', 'false'); card.classList.add('is-revealed'); }
    }, 380);
    /* once the card is up, cascade the lines in (no typewriter) */
    presentT(function () {
      var lines = card ? card.querySelectorAll('.ffg-present__rise') : [];
      for (var i = 0; i < lines.length; i++) {
        (function (el, d) { presentT(function () { el.classList.add('is-in'); }, d); })(lines[i], i * 170);
      }
      if (replay) { replay.hidden = false; presentT(function () { replay.classList.add('is-in'); }, lines.length * 170 + 220); }
    }, 820);
    /* once the reveal burst has cleared, start the soft ambient field around the card */
    presentT(presentAmbientTick, 1300);
  }
  function presentReset() {
    presentClearTimers();
    presentState.taps = 0;
    presentState.busy = false;
    var env = document.getElementById('ffg-present-env');
    var card = document.getElementById('ffg-present-card');
    var hint = document.getElementById('ffg-present-hint');
    var replay = document.getElementById('ffg-present-replay');
    var stage = document.getElementById('ffg-present-stage');
    if (card) {
      card.classList.remove('is-revealed');
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML = presentCardInner(); /* fresh empty type targets */
      bindPresentTilt(); /* rebind the lean to the freshly built card */
    }
    if (env) {
      env.classList.remove('is-open', 'is-gone');
      var rseal = env.querySelector('.ffg-env__seal');
      if (rseal) { rseal.style.animation = ''; rseal.style.transform = ''; }
    }
    if (hint) hint.textContent = 'Tap to open';
    if (replay) { replay.hidden = true; replay.classList.remove('is-in'); }
    var layer = document.getElementById('ffg-present');
    if (layer) {
      var hs = layer.querySelectorAll('.ffg-present__heart');
      for (var i = 0; i < hs.length; i++) { if (hs[i].parentNode) hs[i].parentNode.removeChild(hs[i]); }
    }
  }
  /* v38.11 three-tap "charge, then burst". Tap 1 throws ~30% of the final burst,
     tap 2 ~50%, and the heart swells a little more each time so it looks about to
     pop. Tap 3 is the full explosion + the card reveal. */
  function presentTap() {
    if (presentState.busy) return;
    presentState.taps++;
    var env = document.getElementById('ffg-present-env');
    var hint = document.getElementById('ffg-present-hint');
    var layer = document.getElementById('ffg-present');
    var seal = env ? env.querySelector('.ffg-env__seal') : null;
    if (env) { env.classList.remove('is-nudge'); void env.offsetWidth; env.classList.add('is-nudge'); }
    if (presentState.taps >= 3) {
      presentState.busy = true;
      if (hint) hint.textContent = '';
      presentReveal();
      return;
    }
    /* escalating burst: tap 1 is small + close (~9 hearts, ~half distance), tap 2 is
       bigger + shoots out further (~15 hearts, ~80% distance). Tap 3 (reveal) is full. */
    if (layer && env) {
      var r = env.getBoundingClientRect();
      var lr = layer.getBoundingClientRect();
      var cx = r.left - lr.left + r.width / 2, cy = r.top - lr.top + r.height * 0.4;
      var tk = currentPresentTheme();
      if (presentState.taps === 1) { burstParticles(layer, cx, cy, 9, 0.5, tk); }
      else { burstParticles(layer, cx, cy, 15, 0.8, tk); }
    }
    /* the heart grows a touch more each tap (overrides the resting wiggle), so it
       reads as charging up to burst */
    if (seal) {
      seal.style.animation = 'none';
      seal.style.transform = 'translate(-50%, -50%) scale(' + (presentState.taps === 1 ? 1.16 : 1.32) + ')';
    }
    if (hint) hint.textContent = presentState.taps === 1 ? PRESENT_HINTS.tap1 : PRESENT_HINTS.tap2;
  }
  function openPresent() {
    if (document.getElementById('ffg-present')) return;
    /* v39 (Rebuild 4) opening the reveal by any path retires the one-time
       prompt so it never asks for something she already did. */
    dismissPresentPrompt();
    /* Append to #ffg-root, NOT the screen: the screen carries an identity
       transform, which would make this position:fixed overlay size to that tall
       element instead of the viewport. #ffg-root has the CSS vars + no transform,
       so the overlay centres on the real viewport. */
    var root = document.getElementById('ffg-root') || screenEl();
    if (!root) return;
    presentClearTimers();
    presentState.taps = 0; presentState.busy = false;
    var wrap = document.createElement('div');
    wrap.innerHTML = presentHTML();
    var node = wrap.firstChild;
    root.appendChild(node);
    /* v38.21 lock background scroll while the experience is open, remembering the
       current scroll position so we can restore it exactly on close. Pinning the
       body with position:fixed holds the page still on mobile (overflow:hidden
       alone does not on iOS). */
    try {
      presentState.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + presentState.scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } catch (e) {}
    /* fade in on the next frame */
    requestAnimationFrame(function () { node.classList.add('is-visible'); });
    var env = document.getElementById('ffg-present-env');
    if (env) {
      env.addEventListener('click', presentTap);
      env.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); presentTap(); } });
    }
    var close = document.getElementById('ffg-present-close');
    if (close) close.addEventListener('click', closePresent);
    var replay = document.getElementById('ffg-present-replay');
    if (replay) replay.addEventListener('click', presentReset);
    /* v38.29 the revealed card no longer flips. Tapping anywhere in the claim box
       (the whole gold "Claim your portrait" panel) opens the gift, the same as the
       Get started link, and stops any media first. Tapping the card anywhere else
       pulses a small spurt of the theme's particles. */
    var pcard = document.getElementById('ffg-present-card');
    if (pcard) {
      pcard.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.ffg-present__claim')) {
          stopAllMedia();
          /* Recipient (paid link): tapping the claim panel reveals the real code. */
          if (PRESENT_MODE === 'recipient') { doRecipientClaim(); return; }
          /* Buyer preview: if they tapped the link itself, let the browser open it;
             otherwise open it for them (the whole box is the target). */
          if (!(t.closest('.ffg-present__cta'))) {
            var cta = document.getElementById('ffg-present-cta');
            if (cta) { try { window.open(cta.href, '_blank', 'noopener'); } catch (err) {} }
          }
          return;
        }
        presentCardSpurt();
      });
    }
    /* v38.31 the present card leans toward the cursor, same subtle tilt as the builder card */
    bindPresentTilt();
    bindCardHover(node);  /* v-evergreen the reveal scene reacts to the cursor too */
    node.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePresent(); });
    /* v38.26 only the X closes the reveal. Tapping anywhere else (including the dim
       backdrop) keeps the experience going. The envelope/card/replay have their own
       handlers; the card handler above owns the claim box + the card spurt. */
    node.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.ffg-present__card, .ffg-present__env, .ffg-present__close, .ffg-present__replay')) return;
      /* backdrop or any other empty area advances the reveal instead of closing it */
      presentTap();
    });
    if (close) close.focus();
    try { fbTrack('present_open', { content_name: 'Gift Quiz Evergreen' }); } catch (e) {}
  }
  function closePresent() {
    presentClearTimers();
    var node = document.getElementById('ffg-present');
    /* v38.21 unlock scroll and restore the exact position we were at on open. */
    try {
      document.documentElement.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      var y = presentState.scrollY || 0;
      window.scrollTo(0, y);
    } catch (e) {}
    if (!node) return;
    node.classList.remove('is-visible');
    setTimeout(function () { if (node.parentNode) node.parentNode.removeChild(node); }, 360);
  }
  /* v38.20 stop every video/audio in this tab. Called when "Get started" opens
     /gift in a new tab, so any media (now or added later) does not keep playing
     here in the background. */
  function stopAllMedia() {
    try {
      var m = document.querySelectorAll('video, audio');
      for (var i = 0; i < m.length; i++) {
        try { m[i].pause(); if (m[i].tagName === 'AUDIO') { m[i].currentTime = 0; } m[i].autoplay = false; m[i].loop = false; } catch (e) {}
      }
    } catch (e) {}
  }

  /* v28 layer-three reveal. The product is held back from the hero and
     the questions so the curiosity gap stays open. Here, after she is
     invested, it is finally stated plainly and in her terms. Route-aware
     because the character path has a quest and the portrait path takes a
     photo. */
  /* v33 the painting framed as the upgrade of the card she just made,
       an experience and a keepsake. The picture line lands the moment. */
  /* v36.1 the value-stack (For him / For you bullets, reservation, picture) was
     replaced by the short buyExplainHTML above the pricing. */
  /* v36.1 the portrait size she picked. Nothing is selected by default, so
     the card stays in its base state until she taps a size, which completes
     it (adds the portrait) and reveals the download. */
  function selectedSize() {
    if (!state.sizeKey) return null;
    for (var i = 0; i < SIZES.length; i++) { if (SIZES[i].key === state.sizeKey) return SIZES[i]; }
    return null;
  }
  /* v36 the product-style size picker on the reveal, just above the button.
     Name + descriptor + price per row, the popular one badged, tap to select.
     Selecting updates the card size line and the variant the buy adds. */
  /* v36.7 scarcity per size, modeled on the d-d-custom-sales pulsing dot. Each
     size reads "In stock" with a small pulsing dot whose colour comes from the
     slots-left number (editor-set per size): green at 21+, amber at 10 to 20,
     red under 10, and a still "Sold out" at 0. */
  function sizeStock(sz) {
    var qty = parseInt(sz && sz.qty, 10);
    if (isNaN(qty)) qty = 22;
    if (qty <= 0) return { cls: 'sold', label: 'Sold out', sold: true };
    if (qty < 10) return { cls: 'out', label: 'In stock', sold: false };
    if (qty < 21) return { cls: 'low', label: 'In stock', sold: false };
    return { cls: 'in', label: 'In stock', sold: false };
  }
  function sizesSelectorHTML() {
    if (!SIZES.length) return '';
    var cur = selectedSize();
    var rows = '';
    for (var i = 0; i < SIZES.length; i++) {
      var sz = SIZES[i];
      var on = cur && sz.key === cur.key;
      var st = sizeStock(sz);
      rows += '<button type="button" class="ffg-size' + (on ? ' is-selected' : '') + (st.sold ? ' ffg-size--sold' : '') + '" data-ffg-size="' + esc(sz.key) + '"' + (st.sold ? ' data-sold="1" aria-disabled="true"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="ffg-size__check" aria-hidden="true"></span>' +
        '<span class="ffg-size__main">' +
          '<span class="ffg-size__name">' + esc(sz.name) + (sz.popular ? '<span class="ffg-size__badge">Most popular</span>' : '') + '</span>' +
          (sz.desc ? '<span class="ffg-size__desc">' + esc(sz.desc) + '</span>' : '') +
        '</span>' +
        '<span class="ffg-size__right">' +
          '<span class="ffg-size__price">' + esc(sz.price) + '</span>' +
          '<span class="ffg-stock ffg-stock--' + st.cls + '"><span class="ffg-stockdot" aria-hidden="true"></span>' + esc(st.label) + '</span>' +
        '</span>' +
      '</button>';
    }
    return '<div class="ffg-sizes" id="ffg-sizes" role="radiogroup" aria-label="Portrait size">' +
      rows +
    '</div>';
  }

  /* v36.8 the review carousel: a left-aligned, auto-scrolling loop of square
     customer review photos between the headline and the size picker. ~5 show at
     a time; the loop holds up to 15. Each photo is a link to its Loox review, so
     tapping it opens Loox's own review lightbox (same as clicking a review in the
     grid). The track is the items tripled, driven by the shared marquee runtime
     (data-ffg-marquee) so mountMarquees animates + makes it draggable. */
  function reviewsCarouselHTML() {
    /* v-evergreen2 the buy-page strip now draws from the SAME image list as the
       intro proof band (GALLERY / CONFIG.galleryUrls), so the two scrolling strips
       always match. Editing the gallery list updates both at once. Each photo still
       links through to the reviews so the tap-to-read affordance stays. */
    if (!GALLERY.length) return '';
    var link = (CONFIG && CONFIG.reviewsLinkFallback) || REVIEW_FALLBACK_LINK;
    var items = '';
    for (var i = 0; i < GALLERY.length; i++) {
      /* Eager (not lazy) so the looping carousel never pops a blank thumb in as
         it scrolls. Only the unique URLs download; the tripled copies are cached. */
      var img = '<img src="' + esc(GALLERY[i]) + '" alt="A FramedFantasy portrait, sent in by a customer" decoding="async" draggable="false">';
      items += link
        ? '<a class="ffg-reviews__item" href="' + esc(link) + '" aria-label="Read our reviews" draggable="false">' + img + '</a>'
        : '<span class="ffg-reviews__item ffg-reviews__item--static">' + img + '</span>';
    }
    /* Tripled for a seamless loop, matching the proof gallery (the marquee
       runtime measures singleSetWidth = scrollWidth / 3). */
    return '<div class="ffg-reviews" id="ffg-reviews">' +
      '<p class="ffg-reviews__label">Loved by hundreds who finally saw their character</p>' +
      '<div class="ffg-reviews__viewport">' +
        '<div class="ffg-reviews__track" data-ffg-marquee>' + items + items + items + '</div>' +
      '</div>' +
    '</div>';
  }

  /* v28 the social proof beat, the trust moment placed right before the
     buy. Belief 3: Jan is a real person who paints each one. The
     scarcity line doubles as the act-now reason. Real faces (the photo
     gallery) sit right under it. v28.2 the heavier Loox review widget
     moves below the buy and the paste step, so it never pushes the
     action down the page. */
  function proofBeatHTML() {
    return '<div class="ffg-proofbeat">' +
        '<p class="ffg-proofbeat__line">I am Jan. My team and I have hand painted over a thousand of these since 2022.</p>' +
        '<p class="ffg-proofbeat__trust">I only take a handful at a time, so each one gets the time it needs.</p>' +
      '</div>' +
      galleryHTML();
  }

  /* v27 the finish block has two states. Before purchase the gold buy
     button is the hero (Part 2). After she pastes his code the buy is
     done, so it retires and the under-card download carries the finished
     card. v28 the trust band moved up into the proof beat, so the close
     is just the gift line, the descent, and the buy. */
  /* v33 the descent and the one forward button, with honest scarcity.
     Once she has pasted a code (post purchase) the buy retires and the
     finished card download under the card is the only action. */
  function finishInner(rc, giftUrl) {
    /* v37.7 (Change 2) finishInner now owns ONLY the CTA. The reassurance and
       proof lines that used to sit here moved down into buyDetailHTML, so
       everything under the button reads as one cohesive, flush, left-aligned
       column (availability, reassurance, proof, value lines, How it works). */
    return '<a class="ffg-cta-primary" id="ffg-invite-buy" href="' + esc(giftUrl) + '" data-ffg-cta="invitation">' +
        '<span class="ffg-cta-primary__shimmer" aria-hidden="true"></span>' +
        '<span class="ffg-cta-primary__label">' + esc(rc.cta) + ' <span class="ffg-cta-primary__arrow" aria-hidden="true">&rarr;</span></span>' +
      '</a>';
  }
  /* v30 the paste-to-unlock block moved up into the card controls (it is a
     card field she fills in), so the close is just the gift line, the
     descent, and the buy. The inner is its own function so the code field
     can refresh it in place as she types, without a full repaint. */
  function finishHTML(rc, giftUrl) {
    return '<div class="ffg-builder__finish">' + finishInner(rc, giftUrl) + '</div>';
  }

  /* v37.8 re-render only the MESSAGE face so the flip wrapper + portrait face
     persist (the flip state survives theme/size refreshes, and the delegated
     input listener on #ffg-invite-preview keeps covering the editable fields). */
  function updateInvitePreview() {
    var front = document.getElementById('ffg-flip-front');
    if (front) { front.innerHTML = invitePreviewInner(); return; }
    var node = document.getElementById('ffg-invite-preview');
    if (node) node.innerHTML = invitePreviewShell();
  }
  /* v39.1 a size change only affects the claim gift line on the card front,
     so rebuild just that line in place with a soft fade. The old full repaint
     (updateInvitePreview) restarted the scene animation and made the size
     switch feel abrupt. Falls back to the full repaint if the line is not in
     the DOM (it is hidden during phase 1, which keeps the node, so the
     selector still finds it). */
  function updateClaimGiftLine() {
    var p = document.querySelector('#ffg-invite-preview .ffg-invite__claim-gift');
    if (!p) { updateInvitePreview(); return; }
    p.classList.remove('ffg-invite__claim-gift--swap');
    void p.offsetWidth; /* restart the fade if she clicks sizes quickly */
    p.innerHTML = claimGiftHTML();
    p.classList.add('ffg-invite__claim-gift--swap');
  }
  /* v37.8 swap the portrait face's image to the current size, optionally with a
     crossfade (used when the size changes while already on the portrait side),
     and keep the gold name in sync. */
  function updatePortraitFace(crossfade) {
    var nameEl = document.getElementById('ffg-portrait-name');
    if (nameEl) nameEl.textContent = portraitDisplayName();
    var lblEl = document.getElementById('ffg-portrait-label');
    if (lblEl) lblEl.textContent = portraitSampleLabel();
    var img = document.getElementById('ffg-portrait-img');
    if (!img) return;
    var url = sizePortraitUrl(currentPortraitSize());
    if (!url || img.getAttribute('src') === url) return;
    if (!crossfade || ffgReducedMotion()) { img.src = url; return; }
    /* v-evergreen2 a true crossfade between sizes. The old version toggled
       opacity 0 then 1 on a single, already-preloaded image in one tick, so the
       browser never painted the faded state and the swap looked instant. Instead
       the new image fades in on an overlay stacked above the current one, then
       becomes the base and the overlay is removed. An image stays visible the
       whole time, so there is no blank flash. Falls back to an instant swap under
       reduced motion (handled above). */
    var pre = new Image();
    pre.onload = pre.onerror = function () {
      /* drop any overlay still mid-fade from a quick previous click */
      if (img.parentNode) {
        var stale = img.parentNode.querySelectorAll('.ffg-portrait__img--xfade');
        for (var s = 0; s < stale.length; s++) { if (stale[s].parentNode) stale[s].parentNode.removeChild(stale[s]); }
      }
      var overlay = img.cloneNode(false);
      overlay.removeAttribute('id');
      overlay.classList.add('ffg-portrait__img--xfade');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.src = url;
      overlay.style.opacity = '0';
      /* sits right above the base image but below the scrim, name, and label,
         which follow it in the DOM, so the gold name never flickers. */
      img.insertAdjacentElement('afterend', overlay);
      var done = false;
      var finish = function () {
        if (done) return; done = true;
        if (!overlay.parentNode) return; /* superseded by a newer click */
        img.src = url;
        img.style.opacity = '1';
        overlay.parentNode.removeChild(overlay);
      };
      overlay.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 520); /* fallback if transitionend never fires */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { overlay.style.opacity = '1'; });
      });
    };
    pre.src = url;
  }
  function ffgReducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { return false; }
  }
  /* v37.8 module-scoped flip state so size/theme re-renders never lose which
     side is showing. */
  var flipShowingPortrait = false;
  function flipCard(toPortrait) {
    var flip = document.getElementById('ffg-flip');
    var inner = document.getElementById('ffg-flip-inner');
    if (!flip || !inner) return;
    flipShowingPortrait = !!toPortrait;
    /* v-evergreen2 drop the mouse-follow lean the instant we show the portrait, so
       the image side sits flat and stable (the lean is the editable side's cue). */
    if (toPortrait) { var tl = document.getElementById('ffg-flip-tilt'); if (tl) tl.style.transform = ''; }
    /* Blur any focused editable so a size-triggered flip feels intentional and
       nothing typed is lost (edge case / Part 3.5). */
    try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) {}
    if (ffgReducedMotion()) {
      /* No spin. Soft opacity crossfade: fade out, swap sides, fade back in. */
      flip.classList.add('ffg-flip--fading');
      setTimeout(function () {
        inner.classList.toggle('is-flipped', !!toPortrait);
        flip.classList.remove('ffg-flip--fading');
      }, 250);
    } else {
      inner.classList.toggle('is-flipped', !!toPortrait);
    }
  }
  /* Preload all three size portraits so the first flip is instant, no flash. */
  function preloadPortraits() {
    for (var i = 0; i < SIZES.length; i++) {
      var u = sizePortraitUrl(SIZES[i]);
      if (u) { var im = new Image(); im.src = u; }
    }
  }
  /* v37.9.3 the card leans toward the cursor. As the mouse moves over it, the
     tilt layer takes a small rotateX/rotateY based on where the cursor is, so the
     card subtly tilts in 3D (and settles back when the mouse leaves). This is the
     ambient hint that the card is a real, flippable object, replacing the old
     one-time load tease. Mouse only (no touch), skipped under reduced motion. */
  var TILT_MAX = 4; /* degrees — subtle lean */
  /* v37.9.3 / v38.31 the subtle mouse-follow lean. Shared by the builder card and
     the present (reveal) card so both lean toward the cursor the same gentle way. */
  function bindTilt(flip, tilt) {
    if (!flip || !tilt || ffgReducedMotion()) return;
    if (flip.__ffgTiltBound) return;
    flip.__ffgTiltBound = true;
    var raf = null, lastX = 0, lastY = 0;
    function apply() {
      raf = null;
      /* v-evergreen2 no mouse-follow lean while the portrait (image) side is up.
         The lean re-rotates the flipped card on every mousemove, which made the
         image shimmer/glitch under the cursor. The editable side keeps the lean. */
      if (flip.id === 'ffg-flip' && flipShowingPortrait) { tilt.style.transform = ''; return; }
      var r = flip.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (lastX - r.left) / r.width;   /* 0..1 across */
      var py = (lastY - r.top) / r.height;   /* 0..1 down */
      var ry = (px - 0.5) * 2 * TILT_MAX;    /* left/right -> rotateY */
      var rx = -(py - 0.5) * 2 * TILT_MAX;   /* up/down -> rotateX */
      tilt.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
    }
    flip.addEventListener('mousemove', function (e) {
      lastX = e.clientX; lastY = e.clientY;
      if (raf == null) raf = requestAnimationFrame(apply);
    });
    flip.addEventListener('mouseleave', function () {
      if (raf != null) { cancelAnimationFrame(raf); raf = null; }
      tilt.style.transform = '';
    });
  }
  function bindCardTilt() { bindTilt(document.getElementById('ffg-flip'), document.getElementById('ffg-flip-tilt')); }
  function bindPresentTilt() { bindTilt(document.getElementById('ffg-present-flip'), document.getElementById('ffg-present-tilt')); }
  /* v34 drop the caret at the end of a contenteditable node, used after the
     message soft-cap trims overflow so her cursor does not jump to the top. */
  function placeCaretEnd(el) {
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      r.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    } catch (e) {}
  }
  /* v34.1 read a contenteditable's text with line breaks preserved and any
     non-breaking spaces normalized. innerText keeps newlines in browsers;
     textContent is the jsdom fallback. */
  function editableText(el) {
    var t = (el.innerText != null ? el.innerText : (el.textContent || ''));
    return t.split(String.fromCharCode(160)).join(' ');
  }
  /* v34.1 the how-it-works lightbox. */
  function openSteps() {
    var lb = document.getElementById('ffg-steps-lightbox');
    if (!lb) return;
    lb.hidden = false;
    if (!state.stepsSeen) { state.stepsSeen = true; save(); }
  }
  function closeSteps() {
    var lb = document.getElementById('ffg-steps-lightbox');
    if (lb) lb.hidden = true;
  }
  /* v34.1 she types the real code straight into the box on the card. Update
     the box state, the note, the download, and the buy in place, never
     re-rendering the preview (that would steal the caret she is typing in). */
  function handleCodeInput(el) {
    state.unlockCode = sanitizeCode(editableText(el));
    var box = el.closest ? el.closest('.ffg-invite__claim') : el.parentNode;
    if (box && box.classList) {
      var real = !!state.unlockCode;
      box.classList.toggle('ffg-invite__claim--real', real);
      var note = box.querySelector('.ffg-invite__claim-note');
      if (note) {
        var pp = pron();
        note.textContent = real
          ? 'The code is on the card. Give it to ' + pp.obj + ' and ' + pp.subj + ' ' + (pp.subj === 'they' ? 'follow' : 'follows') + ' these steps.'
          : 'A sample. The real code appears here once you finish the gift, and these steps go live.';
      }
    }
    refreshAfterCode();
    save();
  }

  function bindBuilder() {
    var screen = screenEl();
    /* v38.30 the builder preview card carries the same ambient themed halo */
    startBuilderFx();
    /* v38.4 two-phase reveal. The page lands in phase 1 (just the card, the colour
       picker, and the "It looks good" confirm). Confirming reveals the rest of the
       page (the buy column, FAQ, reviews, the claim block on the card, and the
       Present / Download actions) and eases the card from centre to the left. */
    var confirmBtn = screen.querySelector('#ffg-confirm-card');
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      var b = screen.querySelector('.ffg-reveal-2p');
      if (!b || b.classList.contains('is-phase2')) return;
      b.classList.remove('is-phase1');
      b.classList.add('is-phase2');
      /* is-revealing drives the one-time entrance cascade. It is removed after the
         cascade so a later re-render (theme/size change re-renders the card front)
         does NOT replay the claim-block pop-in. */
      b.classList.add('is-revealing');
      setTimeout(function () { if (b) b.classList.remove('is-revealing'); }, 1800);
      try { fbTrack('CardConfirmed', { content_name: 'Gift Quiz Evergreen' }); gaTrack('card_confirmed', {}); } catch (e) {}
      /* Gift link: create the Supabase row now so the preview link exists and checkout
         is fast. Best effort here; directCheckout re-ensures and hard-blocks if it fails. */
      try { ensureCardSaved().catch(function () {}); } catch (e) {}
      /* v-evergreen3 the one-time "Present the card" prompt box is removed per Jan.
         After the mobile reorder it had no flex order (defaulted to order:0) and
         jumped above the headline, and it duplicated the "Preview their opening
         experience" button that already sits under the card. showPresentPrompt is
         left defined but no longer triggered. */
      /* setTimeout(showPresentPrompt, 1500); */
    });
    /* v34 the color theme picker. Clicking a swatch re-skins the card live,
       palette and scene, and marks itself active. */
    var themeBtns = screen.querySelectorAll('[data-ffg-theme]');
    Array.prototype.forEach.call(themeBtns, function (btn) {
      btn.addEventListener('click', function () {
        state.cardTheme = btn.getAttribute('data-ffg-theme');
        Array.prototype.forEach.call(themeBtns, function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        updateInvitePreview();
        save();
      });
    });
    /* v36 the portrait size picker. Picking a size marks it selected, updates
       the size line on the card, and sets the variant the buy will add. */
    var sizeBtns = screen.querySelectorAll('[data-ffg-size]');
    Array.prototype.forEach.call(sizeBtns, function (btn) {
      btn.addEventListener('click', function () {
        /* v36.7 a sold-out size cannot be picked. */
        if (btn.getAttribute('data-sold') === '1') return;
        state.sizeKey = btn.getAttribute('data-ffg-size');
        Array.prototype.forEach.call(sizeBtns, function (b) {
          var on = b.getAttribute('data-ffg-size') === state.sizeKey;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        /* The gift line on the card updates live, in place, so the rest of
           the card (scene animation included) never jumps. */
        updateClaimGiftLine();
        /* v37.8 the size drives the portrait side too. Point the portrait at the
           new size's art; if already on the portrait side, crossfade in place;
           otherwise flip to it. */
        var alreadyPortrait = flipShowingPortrait;
        updatePortraitFace(alreadyPortrait);
        if (!alreadyPortrait) flipCard(true);
        save();
      });
    });
    /* v34.1 every card line is edited in place. The preview node persists
       across re-renders (only its innerHTML changes on a theme switch), so
       one delegated input listener covers all the editable fields. I read
       the text (newlines preserved) into the matching state override, never
       repaint the preview while she types (that would steal the caret), and
       clear the node when empty so the CSS placeholder shows again. The code
       value is handled separately so it can drive the download and the buy. */
    var FIELD_MAP = {
      'ffg-invite-stamp': 'cardStamp',
      'ffg-invite-greeting': 'cardGreeting',
      'ffg-invite-summons': 'cardSummons',
      'ffg-invite-msg': 'cardMessage',
      'ffg-invite-signoff': 'cardSignoff',
      /* v37.6 (Change 4) the "your character" words in the claim gift line. */
      'ffg-invite-character': 'cardCharacter'
    };
    var previewNode = screen.querySelector('#ffg-invite-preview');
    if (previewNode) {
      bindCardHover(previewNode);  /* v-evergreen scene reacts to the cursor (desktop fine-pointer, survives theme re-renders) */
      /* v36.7 the card has no code field anymore, so this just keeps the
         editable greeting/summons/message/sign-off in sync with state. */
      previewNode.addEventListener('input', function (e) {
        var m = e.target;
        if (!m || !m.id) return;
        var field = FIELD_MAP[m.id];
        if (!field) return;
        var max = (m.id === 'ffg-invite-msg') ? 220 : 60;
        var txt = editableText(m);
        if (txt.length > max) { txt = txt.slice(0, max); m.textContent = txt; placeCaretEnd(m); }
        var trimmed = txt.replace(/^\s+|\s+$/g, '');
        if (!trimmed && m.innerHTML) m.innerHTML = '';
        state[field] = trimmed;
        if (field === 'cardMessage') { state.cardMsgPreset = 'custom'; }
        /* v37.8 the character name drives the gold name on the portrait side too;
           update it live as she types (edge: empty hides cleanly via :empty CSS). */
        if (m.id === 'ffg-invite-character') {
          var pn = document.getElementById('ffg-portrait-name');
          if (pn) pn.textContent = portraitDisplayName();
        }
        save();
      });
      /* v37.9.2 flip interactions, delegated on the persistent preview container.
         No flip icon: tapping ANY non-editable spot on the message side flips to
         the portrait; tapping the portrait flips back to edit. Editable fields,
         links, and active text selections are left alone so editing still works. */
      previewNode.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        /* v-evergreen handled before the flip: the summons refresh cycles the
           line. Everything else on the message side still flips. The scene now
           reacts to hover (not taps), so there is no click hotspot to intercept. */
        if (t.closest('#ffg-summons-refresh')) { cycleSummons(); return; }
        if (t.closest('#ffg-portrait-face')) { flipCard(false); return; }
        if (t.closest('#ffg-flip-front')) {
          if (t.closest('[contenteditable="true"]')) return;   // let her edit a line
          if (t.closest('a, button')) return;                  // let interactive bits work
          var sel = window.getSelection && window.getSelection();
          if (sel && !sel.isCollapsed) return;                 // she is selecting text, not tapping
          flipCard(true);
        }
      });
      previewNode.addEventListener('keydown', function (e) {
        var t = e.target;
        if (!t) return;
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        if (t.id === 'ffg-portrait-face') { e.preventDefault(); flipCard(false); return; }
        if (t.id === 'ffg-flip-front') { e.preventDefault(); flipCard(true); }
      });
      preloadPortraits();
      bindCardTilt();
    }
    /* Download the card (immediate). */
    bindDownload();
    /* v37.7 the "Good to know" FAQ accordion. */
    bindFaq(screen);
    /* v36.8 the review carousel auto-scrolls via the shared marquee runtime
       (mountMarquees, called after paint). The photos are plain links to Loox
       reviews, so no extra binding is needed here. */
    /* v-evergreen the builder is the locked, final screen. There is no back into
       the quiz from here, so a re-answer can never fire another AI generation. */
    /* The gap-close CTA. Fires analytics, then the browser follows the
       href to the gift product page. */
    bindBuyClick(screen.querySelector('#ffg-invite-buy'));
    /* v37.5 (Change 5) — sticky scroll nudge wire-up.
       Mirrors product.d-d-custom-sales' ff-stickybar pattern: passive
       scroll listener + rAF tick + getBoundingClientRect().bottom < 0
       on the buy-area anchor (the .ffg-builder__finish wrapper that
       holds the CTA + the two trust lines). Dismissal lives in
       sessionStorage so it persists across the visit but does not
       leak into future sessions on the same device. */
    bindStickyNudge(screen);
  }

  /* v37.5 (Change 5) — sticky scroll nudge controller.
     Behaviour summary:
       - HIDDEN by default.
       - Shows once the .ffg-builder__finish (button + trust lines) has
         scrolled fully above the top of the viewport. That keeps the
         nudge out of the way while there is nothing yet to nudge her
         toward.
       - Hides again if she scrolls back up and the button re-enters view.
       - Tap on the CTA → smooth-scroll the SIZE PICKER to the center of
         the viewport. Per Jan: "she lands on the choice rather than being
         dropped at the top or having a size chosen for her."
       - Dismiss × → permanent-for-this-visit hide via sessionStorage.
       - Mobile: bottom-anchored full-width bar above the safe area inset.
       - Desktop: bottom-anchored centered card with extra padding.
     CSS lives in fathers-day-quiz.css. */
  var STICKY_DISMISS_KEY = 'ffg-stickynudge-dismissed';
  function bindStickyNudge(screen) {
    var bar = screen.querySelector('#ffg-stickynudge');
    if (!bar) return;
    var cta = bar.querySelector('#ffg-stickynudge-cta');
    var dismiss = bar.querySelector('#ffg-stickynudge-dismiss');
    var anchor = screen.querySelector('.ffg-builder__finish');
    if (!anchor) return;
    /* sessionStorage may be unavailable in private modes; guard everything. */
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(STICKY_DISMISS_KEY) === '1'; } catch (e) {}
    if (dismissed) {
      bar.style.display = 'none';
      return;
    }
    var ticking = false;
    function showBar() {
      if (bar.classList.contains('is-visible')) return;
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
    function hideBar() {
      if (!bar.classList.contains('is-visible')) return;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
    function checkPosition() {
      ticking = false;
      /* If the anchor was removed from the DOM (rare, only on a full
         re-render of the screen), tear down quietly. */
      if (!document.body.contains(anchor)) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      var rect = anchor.getBoundingClientRect();
      /* Trigger only after the buy area has fully scrolled past the top
         of the viewport. Identical heuristic to ff-stickybar in
         product.d-d-custom-sales. */
      if (rect.bottom < 0) showBar();
      else hideBar();
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(checkPosition);
        ticking = true;
      }
    }
    function scrollToSizes() {
      var picker = document.getElementById('ffg-sizes');
      if (picker && picker.scrollIntoView) {
        try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      }
    }
    if (cta) cta.addEventListener('click', scrollToSizes);
    if (dismiss) dismiss.addEventListener('click', function () {
      hideBar();
      try { sessionStorage.setItem(STICKY_DISMISS_KEY, '1'); } catch (e) {}
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* Initial check (the buy area may already be out of view if she
       navigated here via in-page anchor / back-forward cache). */
    checkPosition();
  }

  /* v35 the reveal IS the close now. The button no longer hops to the gift
     product page. It adds the gift product to the cart and goes straight to
     checkout, the highest-intent moment in the funnel. The gift page stays
     live for non-quiz traffic; we only stop routing the quiz through it. */
  function bindBuyClick(buy) {
    if (!buy) return;
    buy.addEventListener('click', function (e) {
      if (e && e.preventDefault) e.preventDefault();
      var sz = selectedSize();
      /* v36 she has to pick a size first. If she has not, send her up to the
         picker and pulse it rather than checking out an unchosen gift. */
      if (!sz) {
        var picker = document.getElementById('ffg-sizes');
        if (picker) {
          if (picker.scrollIntoView) { try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {} }
          picker.classList.remove('ffg-sizes--nudge');
          void picker.offsetWidth;
          picker.classList.add('ffg-sizes--nudge');
        }
        return;
      }
      var giftUrl = buy.getAttribute('href') || (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
      directCheckout(buy, giftUrl, sz);
    });
  }
  /* v37.9 direct checkout with the chosen size, mapped to the GIFT CARD product.
     The quiz offers three sizes (99 / 139 / 199), which match three of the gift
     card's four denominations. We resolve the gift card product's variants from
     its JSON and add the one whose price matches the chosen size, then go to
     checkout, so the order is for the gift card (not the portrait product). The
     per-size variant id settings are no longer used here, so a stale id can no
     longer send the wrong product to the cart. The gift card product URL comes
     from the section's "Gift card product URL" setting (CONFIG.giftCardUrl); set
     it to the gift card product or the buy falls back to that URL. Clear the cart
     first so she never checks out with a stale item. On any failure, navigate to
     the gift URL so the funnel never dead-ends. */
  var checkoutBusy = false;
  function priceToCents(p) {
    var n = parseFloat(String(p == null ? '' : p).replace(/[^0-9.]/g, ''));
    return isFinite(n) ? Math.round(n * 100) : 0;
  }
  /* ---------- Gift link: save the card, then carry it through checkout ----------
     The card is moved to a Supabase row (the source of truth) so the link can render
     it on any device. ensureCardSaved creates the row once and remembers the ids, with
     a retry. directCheckout hard-blocks if it ultimately fails, so a buyer can never pay
     with no card behind the order. The id and tier ride the order as a line item property
     AND a cart attribute, so a theme or app that strips one does not orphan the order. */
  function cardPriceNumber() {
    var sz = selectedSize();
    if (!sz || !sz.price) return null;
    var c = priceToCents(sz.price);
    return c ? c / 100 : null;
  }
  function cardProps() {
    return { _card_id: state.publicId || '', _card_tier: state.sizeKey || '' };
  }
  function showCheckoutError(msg) {
    try {
      var box = document.getElementById('ffg-checkout-error');
      if (!box) {
        var host = document.querySelector('.ffg-builder__finish') || screenEl() || document.body;
        box = document.createElement('p');
        box.id = 'ffg-checkout-error';
        box.className = 'ffg-checkout-error';
        box.setAttribute('role', 'alert');
        host.appendChild(box);
      }
      box.textContent = msg;
    } catch (e) {}
  }
  function ensureCardSaved() {
    if (state.publicId) return Promise.resolve();
    var body = JSON.stringify({ card_json: state, size_tier: state.sizeKey || null, price: cardPriceNumber() });
    var attempt = function (n) {
      return fetch(GIFT_WORKER + '/cards', { method: 'POST', headers: { 'content-type': 'application/json' }, body: body })
        .then(function (r) { if (!r.ok) throw new Error('save ' + r.status); return r.json(); })
        .then(function (d) {
          if (!d || !d.publicId) throw new Error('save no id');
          state.publicId = d.publicId; state.previewKey = d.previewKey;
          try { save(); } catch (e) {}
        })
        .catch(function (e) {
          if (n >= 2) throw e;
          return new Promise(function (res) { setTimeout(res, 400 * (n + 1)); }).then(function () { return attempt(n + 1); });
        });
    };
    return attempt(0);
  }
  function syncCardEdit() {
    if (!state.publicId) return Promise.resolve();
    return fetch(GIFT_WORKER + '/cards/' + encodeURIComponent(state.publicId), {
      method: 'PATCH', headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ card_json: state, previewKey: state.previewKey })
    }).catch(function () {}); /* best effort, never blocks checkout */
  }
  function directCheckout(buy, giftUrl, sz) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    var sizeKey = (sz && sz.key) || '';
    var label = buy && buy.querySelector ? buy.querySelector('.ffg-cta-primary__label') : null;
    var prev = label ? label.innerHTML : '';
    if (label) label.textContent = 'Preparing your card…';
    var fallback = function () { window.location.href = giftUrl; };
    var fail = function () { if (label) label.innerHTML = prev; checkoutBusy = false; fallback(); };
    var addAndGo = function (id) {
      var props = cardProps();
      return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .catch(function () {})
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
          });
        })
        .then(function (r) {
          if (!r || !r.ok) return Promise.reject();
          /* backstop: store the id + tier as a cart attribute too, in case line item
             properties get stripped, so the webhook can still find the card. */
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: props })
          }).catch(function () {});
        })
        .then(function () { window.location.href = '/checkout'; });
    };
    var proceed = function () {
      try {
        var ev = { content_name: 'Gift Quiz Evergreen', route: state.giftRoute || '', theme: state.cardTheme || '', size: sizeKey };
        fbTrack('AddToCart', ev); gaTrack('add_to_cart', { route: state.giftRoute || '', size: sizeKey });
        fbTrack('InitiateCheckout', ev); gaTrack('begin_checkout', { route: state.giftRoute || '', size: sizeKey });
      } catch (e) {}
      if (label) label.textContent = 'Taking you to checkout…';
      /* prefer the per-size variant id from settings; else resolve by price. A cart
         failure navigates to the gift product page so the funnel never dead-ends. */
      var variantId = sz && sz.variantId ? String(sz.variantId).replace(/[^0-9]/g, '') : '';
      if (variantId) { addAndGo(variantId).catch(fail); return; }
      try {
        var targetCents = priceToCents(sz && sz.price);
        var handle = String(giftUrl).split('?')[0].replace(/\/$/, '');
        fetch(handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function (p) {
            var vs = (p && p.variants) || [];
            var match = null, firstAvail = null, i, v;
            for (i = 0; i < vs.length; i++) {
              v = vs[i]; if (!v) continue;
              if (firstAvail === null && v.available !== false) firstAvail = v;
              if (targetCents && Number(v.price) === targetCents) { match = v; break; }
            }
            var chosen = match || firstAvail || vs[0];
            if (!chosen) return Promise.reject();
            return addAndGo(chosen.id);
          })
          .catch(fail);
      } catch (e) { fail(); }
    };
    /* HARD BLOCK: never let a buyer pay with no card saved. */
    ensureCardSaved()
      .then(function () { return syncCardEdit(); })
      .then(proceed)
      .catch(function () {
        if (label) label.innerHTML = prev;
        checkoutBusy = false;
        showCheckoutError('We could not prepare your card. Please try again.');
      });
  }

  /* v34.1 the code is typed straight onto the card (#ffg-invite-code-value),
     handled by handleCodeInput in the delegated preview listener. This
     refreshes only what the code drives, the download and the buy, without
     repainting the preview, so the caret stays in the code box she is typing
     in. The code box class and note are updated in place by handleCodeInput. */
  function refreshAfterCode() {
    var dlWrap = document.getElementById('ffg-builder-dl');
    if (dlWrap) {
      dlWrap.innerHTML = downloadBlock();
      bindDownload();
    }
    var fin = document.querySelector('.ffg-builder__finish');
    if (fin) {
      var rc = routeCopy();
      var giftUrl = (CONFIG && CONFIG.giftCardUrl) || '/products/framedfantasy-gift-card';
      fin.innerHTML = finishInner(rc, giftUrl);
      bindBuyClick(fin.querySelector('#ffg-invite-buy'));
    }
  }

  /* ---------- Phone ---------- */
  function formatPhone(raw) {
    var d = digits(raw);
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length <= 3) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function phoneE164() {
    var d = digits(state.phone || (document.getElementById('ffg-phone') || {}).value);
    if (d.length > 10 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return null;
    return '+1' + d;
  }
  function showFieldError(id, msg) {
    var input = document.getElementById(id);
    var err = document.getElementById(id + '-err');
    if (input) input.classList.add('is-error');
    if (err) { err.textContent = msg; err.hidden = false; }
  }
  function clearFieldError(id) {
    var input = document.getElementById(id);
    var err = document.getElementById(id + '-err');
    if (input) input.classList.remove('is-error');
    if (err) err.hidden = true;
  }
  function removeFormError() {
    var e = document.getElementById('ffg-formerror');
    if (e && e.parentNode) e.parentNode.removeChild(e);
  }

  /* ============================================================
     OPT IN  ->  KLAVIYO
     ============================================================ */
  function submitOptIn() {
    var fnameEl = document.getElementById('ffg-fname');
    var phoneEl = document.getElementById('ffg-phone');
    var submit = document.getElementById('ffg-submit');
    var first = (fnameEl ? fnameEl.value : '').trim();
    state.firstName = first;
    state.phone = phoneEl ? phoneEl.value : '';

    var ok = true;
    clearFieldError('ffg-fname');
    clearFieldError('ffg-phone');
    clearFieldError('ffg-timing');
    removeFormError();
    /* v17: timing required. Block submit if she hasn't picked one. */
    if (!state.timing) { showFieldError('ffg-timing', 'Please pick when you\'re thinking.'); ok = false; }
    if (first.length < 2) { showFieldError('ffg-fname', 'Please add your first name.'); ok = false; }
    var e164 = phoneE164();
    if (!e164) { showFieldError('ffg-phone', 'Please enter a 10 digit mobile number.'); ok = false; }
    if (!ok) return;

    submit.disabled = true;
    submit.classList.add('is-busy');
    submit.textContent = 'Sending';

    var props = buildProperties();

    if (first.toLowerCase() === TEST_NAME) {
      setTimeout(function () { onOptInSuccess(true); }, 500);
      return;
    }

    klaviyoSubscribe(e164, first)
      .then(function (r) { return r.ok ? r : klaviyoSubscribe(e164, first); })
      .then(function (r) {
        if (!r.ok) throw new Error('subscribe failed');
        return klaviyoProfile(e164, first, props);
      })
      .then(function () {
        // Real submit only (test names return early before this chain).
        // Fire Meta CompleteRegistration via browser pixel + Conversions API.
        capiCompleteRegistration(e164, first);
        onOptInSuccess(false);
      })
      .catch(function () { onOptInError(); });
  }

  function klaviyoPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KL_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return { ok: res.status >= 200 && res.status < 300, status: res.status };
    }).catch(function () { return { ok: false, status: 0 }; });
  }
  function klaviyoSubscribe(e164, first) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Gift Quiz Evergreen',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                phone_number: e164,
                first_name: first,
                subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function klaviyoProfile(e164, first, props) {
    var payload = {
      data: {
        type: 'profile',
        attributes: { phone_number: e164, first_name: first, properties: props }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  /* v33 the Q7 capture. Email is the channel, phone optional. Subscribes
     her to list W8Unvq and writes the six quiz answers plus the route
     onto her profile so the follow up can name his actual character.
     Non-blocking, with one retry, so the reveal never waits on it. */
  function quizProps() {
    computeRoute();
    return {
      FathersDayQuiz_HisName: state.hisName || '',
      FathersDayQuiz_Stance: state.stance || '',
      FathersDayQuiz_Recipient: state.recipient || '',
      FathersDayQuiz_World: answerByKey('his_world') || '',
      FathersDayQuiz_Character: answerByKey('his_character') || '',
      FathersDayQuiz_Character_Name: state.characterName || '',
      FathersDayQuiz_Notice: answerByKey('the_notice') || (state.notesText || ''),
      FathersDayQuiz_Route: state.giftRoute || ''
    };
  }
  function klaviyoSubscribeEmail(email, phoneE) {
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: email };
    if (phoneE) { attrs.phone_number = phoneE; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    attrs.subscriptions = subs;
    var payload = {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'Gift Quiz Evergreen', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      }
    };
    return klaviyoPost('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function klaviyoProfileEmail(email, phoneE, props) {
    var attrs = { email: email, properties: props };
    if (phoneE) attrs.phone_number = phoneE;
    var payload = { data: { type: 'profile', attributes: attrs } };
    return klaviyoPost('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(KL_COMPANY), payload);
  }
  function submitQuizCapture() {
    var email = (state.email || '').trim();
    if (!email) return;
    var phoneE = phoneE164();
    var props = quizProps();
    try {
      fbTrack('Lead', { content_name: 'Gift Quiz Evergreen', route: state.giftRoute || '' });
      gaTrack('quiz_lead', { route: state.giftRoute || '' });
    } catch (e) {}
    try {
      klaviyoSubscribeEmail(email, phoneE)
        .then(function (r) { return (r && r.ok) ? r : klaviyoSubscribeEmail(email, phoneE); })
        .then(function () { return klaviyoProfileEmail(email, phoneE, props); })
        .catch(function () {});
    } catch (e) {}
  }
  function buildProperties() {
    var now = new Date().toISOString();
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    var props = {
      FathersDayQuiz_Recipient: recipientObj().map,
      FathersDayQuiz_Headline_Variant: state.headlineVariant,
      FathersDayQuiz_Branch: state.branch,
      FathersDayQuiz_Hobby: answerByKey('hobby'),
      /* v17: timing moved off the quiz body and onto the SMS opt-in
         form as inline form data. Read from state.timing instead of
         the answers[] index. */
      FathersDayQuiz_Timing: state.timing || '',
      FathersDayQuiz_Hobby_Vibe: answerByKey('hobby_vibe'),
      /* v16: FathersDayQuiz_Personality removed. The personality
         question was cut entirely so the Klaviyo property is gone
         too — Klaviyo will not error on missing properties, but
         downstream flows that branched on Personality need updating
         on the Klaviyo side. */
      FathersDayQuiz_Moral_Signature: answerByKey('moral_signature'),
      /* v5 engagement-layer properties. Trait curation is now a
         single-select (was multi in v5.1), so it saves as a single
         string: the picked option's store value. Renamed to
         _Most_Him_Trait to reflect the new mechanic. Signature
         behavior and inside detail unchanged. */
      FathersDayQuiz_Most_Him_Trait: answerByKey('trait_curation'),
      FathersDayQuiz_Signature_Behavior: answerByKey('signature_behavior'),
      FathersDayQuiz_Inside_Detail: answerByKey('inside_detail'),
      FathersDayQuiz_Result_Archetype: a.name,
      FathersDayQuiz_Archetype_Scores: JSON.stringify(state.scores),
      FathersDayQuiz_First_Text_Template: firstTextTemplate(),
      FathersDayQuiz_Completed_At: now,
      FathersDayQuiz_Source: 'Gift Quiz Evergreen',
      FathersDayQuiz_SMS_Consent_Text: TCPA_TEXT,
      FathersDayQuiz_SMS_Consent_At: now
    };
    if (state.hisName) props.FathersDayQuiz_Recipient_First_Name = state.hisName;
    return props;
  }

  function onOptInSuccess(isTest) {
    clearSaved();
    if (!isTest) {
      trackOnce('lead', function () {
        fbTrack('Lead', { value: 150, currency: 'USD', content_name: 'PfP Waitlist SMS', content_category: 'Gift Quiz Evergreen' });
        gaTrack('generate_lead', { currency: 'USD', value: 150 });
      });
      /* v18 fallback_submit. Fires on a real successful Klaviyo
         submission only. Test names return earlier in submitOptIn so
         this branch only runs for live opt ins. */
      trackOnce('fallback_submit', function () {
        fbTrack('fallback_submit', {
          content_name: 'Gift Quiz Evergreen',
          archetype: (ARCH[state.archetype] || {}).name || '',
          timing: state.timing || ''
        });
        gaTrack('fallback_submit', {
          archetype: state.archetype,
          timing: state.timing || ''
        });
      });
    }
    /* Marker class kept so CSS hooks that watched for the post submit
       state still apply. In v18 nothing is hidden on the page that
       this class needs to reveal, but downstream styles may key off
       it for muted post submit states. */
    var resultWrap = document.querySelector('.ffg-result');
    if (resultWrap) resultWrap.classList.add('ffg-result--saved');
    var optin = document.getElementById('ffg-optin');
    if (!optin) return;
    optin.innerHTML = confirmationHTML(isTest);
    bindConfirmation();
    try { optin.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }
  function onOptInError() {
    var submit = document.getElementById('ffg-submit');
    if (submit) {
      submit.disabled = false;
      submit.classList.remove('is-busy');
      submit.textContent = 'Have Jan text me';
    }
    removeFormError();
    var optin = document.getElementById('ffg-optin');
    if (!optin) return;
    var err = h('<div class="ffg-formerror" id="ffg-formerror">That did not go through. Tap here to try again.</div>');
    err.addEventListener('click', function () { removeFormError(); submitOptIn(); });
    optin.appendChild(err);
  }

  /* ============================================================
     CONFIRMATION  +  SHAREABLE CARD  (inline, same screen)
     ============================================================ */
  function confirmationHTML(isTest) {
    /* v14: cardModuleHTML() ("Want his name on the card?" + card
       preview + Save/Share buttons) removed from the post-submit
       confirmation. The buyer can already download the card via the
       "SAVE YOUR HUSBAND'S ARCHETYPE CARD" link further up the result
       page, so the second card here was redundant friction. The
       confirmation is now just the gold checkmark + reassurance copy. */
    /* v17 confirmation. Closes the SOKA frame ("you already know what
       to give him") and Jan signs off in first person to land the
       trust handoff the whole flow has been building toward. */
    var msg = 'You already know what to give him. I\'ll text in a day or two and we\'ll talk through the photo and his character. Keep an eye on your phone.';
    var signoff = 'Jan';
    if (isTest) msg += ' (Test mode, nothing was sent to Klaviyo.)';
    return '<div class="ffg-confirm">' +
      '<div class="ffg-confirm__mark"><svg viewBox="0 0 24 24" fill="none">' +
        '<path d="M5 13l4 4L19 6" stroke="#e8c674" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
      '<p class="ffg-confirm__head">Your spot is saved.</p>' +
      '<p class="ffg-confirm__text">' + esc(msg) + '</p>' +
      '<p class="ffg-confirm__signoff">' + esc(signoff) + '</p>' +
      '</div>';
  }
  function cardModuleHTML() {
    return '<div class="ffg-cardwrap">' +
      '<p class="ffg-cardwrap__head">A keepsake to share while you wait.</p>' +
      '<div class="ffg-cardname">' +
        '<label class="ffg-label" for="ffg-hisname">Want his name on the card?</label>' +
        '<input class="ffg-input" id="ffg-hisname" type="text" maxlength="20" autocomplete="off" placeholder="His first name (optional)">' +
      '</div>' +
      '<div class="ffg-cardpreview"><img id="ffg-card-img" alt="Your shareable result card"></div>' +
      '<div class="ffg-card-actions">' +
        '<button type="button" class="ffg-continue" id="ffg-card-save">Save image</button>' +
        '<button type="button" class="ffg-cardshare" id="ffg-card-share">Share</button>' +
      '</div>' +
    '</div>';
  }
  function bindConfirmation() {
    var screen = screenEl();
    var nameInput = screen.querySelector('#ffg-hisname');
    if (state.hisName && nameInput) nameInput.value = state.hisName;
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        state.hisName = nameInput.value.trim();
        updateCardPreview();
      });
    }
    /* The card is 4:5 only now (no aspect toggle), so cardAspect stays
       at its default and the renderer uses the post dimensions. */
    var saveBtn = screen.querySelector('#ffg-card-save');
    var shareBtn = screen.querySelector('#ffg-card-share');
    if (saveBtn) saveBtn.addEventListener('click', saveCard);
    if (shareBtn) shareBtn.addEventListener('click', shareCard);
    withFonts(updateCardPreview);
  }

  /* ---------- Card rendering ---------- */
  function withFonts(cb) {
    if (document.fonts && document.fonts.load) {
      var jobs = [
        document.fonts.load('900 80px Cinzel'),
        document.fonts.load('700 30px Cinzel'),
        document.fonts.load('600 26px Cinzel'),
        document.fonts.load('italic 500 52px "Cormorant Garamond"'),
        document.fonts.load('italic 500 40px "Cormorant Garamond"')
      ];
      Promise.all(jobs).then(cb, cb);
    } else { cb(); }
  }
  function wrapLines(ctx, text, maxWidth) {
    var words = String(text).split(' '), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = words[i];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    return lines;
  }
  function drawSpaced(ctx, text, cx, y, spacing) {
    text = String(text);
    var total = 0, i, w;
    for (i = 0; i < text.length; i++) {
      total += ctx.measureText(text.charAt(i)).width;
      if (i < text.length - 1) total += spacing;
    }
    var x = cx - total / 2;
    ctx.textAlign = 'left';
    for (i = 0; i < text.length; i++) {
      ctx.fillText(text.charAt(i), x, y);
      w = ctx.measureText(text.charAt(i)).width;
      x += w + spacing;
    }
    ctx.textAlign = 'center';
  }
  /* v9 card restyle. Portrait 1080x1350 (Instagram 4:5 post format).
     Now MATCHES the landing carousel card design from the homepage,
     plus includes the painted character image at the top.

     Layout (top to bottom):
       wordmark   FRAMEDFANTASY small cream caps
       painting   archetype painting, 670 tall, gold border
       eyebrow    HE IS THE small gold caps
       name       archetype name, large gold serif, auto-shrink to 2 lines
       tagline    italic cream Cormorant
       ornament   small gold diamond mark
       pull       italic gold-pale pull quote in curly quotes
       footer     TAKE THE QUIZ TO FIND HIS + URL

     Image loading is async, so renderCardCanvas takes a callback that
     receives the finished canvas. If the image fails to load (CORS,
     network, blank slot), the card renders without it and still
     calls back cleanly. */
  function renderCardCanvas(callback) {
    var d = revealData();
    var W = 1080;
    var H = 1350;
    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');

    /* Layout constants. Painted-image zone is fixed; the text block
       beneath flows from a single y cursor so font-size changes don't
       cause overlap. */
    var PAINTING = { x: 205, y: 145, w: 670, h: 670, radius: 14 };

    drawCardBackground(ctx, W, H);
    drawCardWordmark(ctx, W);

    var imgUrl = (IMG[state.archetype] && IMG[state.archetype].full) || '';
    function drawTextLayer() {
      drawCardTextBlock(ctx, d, W, H, PAINTING);
      callback(canvas);
    }
    if (imgUrl) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        drawCardPainting(ctx, img, PAINTING);
        drawTextLayer();
      };
      img.onerror = function () {
        /* Graceful fallback: dark placeholder so the layout still
           reads as a card, not an empty hole. */
        drawCardPaintingPlaceholder(ctx, PAINTING);
        drawTextLayer();
      };
      img.src = imgUrl;
    } else {
      drawCardPaintingPlaceholder(ctx, PAINTING);
      drawTextLayer();
    }
  }
  function drawCardBackground(ctx, W, H) {
    /* v34 the card body tint follows the chosen theme so the exported PNG
       matches the recolored on-screen card. These values mirror the
       per-theme --ffg-card-body values in the CSS. */
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var bg = {
      tavern: '#15100a', arcane: '#100b20', wilds: '#0a140e',
      hall: '#0a1020', ember: '#160a0c', love: '#160a18'
    }[themeKey] || '#0c1428';
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);
    /* Subtle gold inner frame, 1px. */
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.25)';
    ctx.lineWidth = 1;
    ctx.strokeRect(36, 36, W - 72, H - 72);
  }
  function drawCardWordmark(ctx, W) {
    ctx.textAlign = 'center';
    ctx.fillStyle = '#efe6d2';
    ctx.font = '600 22px Cinzel, Georgia, serif';
    drawSpaced(ctx, 'FRAMEDFANTASY', W / 2, 95, 8);
  }
  function roundRectPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y,     x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x,     y + h, r);
    ctx.arcTo(x,     y + h, x,     y,     r);
    ctx.arcTo(x,     y,     x + w, y,     r);
    ctx.closePath();
  }
  function drawCardPainting(ctx, img, P) {
    /* Cover-fit the image into the painting box (crop to fill), with
       rounded corners and a subtle gold border. */
    ctx.save();
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.clip();
    /* Cover-fit math. */
    var iw = img.width || img.naturalWidth || 1;
    var ih = img.height || img.naturalHeight || 1;
    var scale = Math.max(P.w / iw, P.h / ih);
    var dw = iw * scale;
    var dh = ih * scale;
    var dx = P.x + (P.w - dw) / 2;
    var dy = P.y + (P.h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
    ctx.restore();
    /* Border on top of the clipped image. */
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.55)';
    ctx.lineWidth = 1.5;
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.stroke();
  }
  function drawCardPaintingPlaceholder(ctx, P) {
    /* Dark plate with a faint "PORTRAIT" caption so the layout never
       looks broken on a missing image. */
    ctx.save();
    roundRectPath(ctx, P.x, P.y, P.w, P.h, P.radius);
    ctx.fillStyle = '#14202f';
    ctx.fill();
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.4)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.fillStyle = 'rgba(201, 168, 76, 0.45)';
    ctx.font = '600 22px Cinzel, Georgia, serif';
    ctx.textAlign = 'center';
    drawSpaced(ctx, 'PORTRAIT', P.x + P.w / 2, P.y + P.h / 2 + 8, 6);
    ctx.restore();
  }
  function drawCardTextBlock(ctx, d, W, H, P) {
    var cx = W / 2;
    /* v15 spacing pass. The previous values opened a big air pocket
       between the "HE IS THE" eyebrow and the giant archetype name
       (label→name was 58) and another between the name and the
       tagline (50). With a 1-line tagline + 1-line quote the bottom
       half of the card felt cramped against the pinned footer while
       the top felt loose. Tightening label→name and name→tagline
       lifts the whole text block up and lets the ornament + quote
       breathe naturally above the footer. */
    /* v15.1 micro-tighten: lift the "HE IS THE" + giant-name pair
       closer to the painting (PAINT_TO_LABEL 48→36, LABEL_TO_NAME
       30→24), and add real breathing room between the headline and
       the tagline (NAME_TO_TAGLINE 38→58) so the italic line reads
       as its own beat instead of crowding the giant name. */
    var GAP_PAINT_TO_LABEL = 36;
    var GAP_LABEL_TO_NAME = 24;
    var GAP_NAME_TO_TAGLINE = 58;
    var GAP_TAGLINE_TO_ORNAMENT = 48;
    var GAP_ORNAMENT_TO_QUOTE = 58;
    var TAGLINE_LINE_H = 34;
    var QUOTE_LINE_H = 34;
    /* Footer is pinned near the canvas bottom (inside the 36px frame
       inset) so it never floats off-card no matter what font sizes
       above it computed to. */
    var FOOTER_HEADING_Y = H - 100;
    var FOOTER_URL_Y = H - 65;

    var y = P.y + P.h + GAP_PAINT_TO_LABEL;

    ctx.textAlign = 'center';

    /* Eyebrow: HE IS THE */
    ctx.fillStyle = '#c9a84c';
    ctx.font = '700 22px Cinzel, Georgia, serif';
    drawSpaced(ctx, d.cardLabel, cx, y, 5);

    /* Archetype name — large gold serif, auto-shrink to fit two lines. */
    var nameSize = 78;
    ctx.font = '900 ' + nameSize + 'px Cinzel, Georgia, serif';
    var nameLines = wrapLines(ctx, d.cardName, W - 240);
    while (nameLines.length > 2 && nameSize > 50) {
      nameSize -= 4;
      ctx.font = '900 ' + nameSize + 'px Cinzel, Georgia, serif';
      nameLines = wrapLines(ctx, d.cardName, W - 240);
    }
    ctx.fillStyle = '#f4d68a';
    var nameLineH = nameSize + 6;
    /* Move to the first name baseline: label baseline + gap + ascent
       of the giant name. */
    y += GAP_LABEL_TO_NAME + nameSize;
    for (var n = 0; n < nameLines.length; n++) {
      ctx.fillText(nameLines[n], cx, y);
      if (n < nameLines.length - 1) y += nameLineH;
    }

    /* Tagline — italic cream, just under the name. */
    y += GAP_NAME_TO_TAGLINE;
    ctx.fillStyle = '#efe6d2';
    ctx.font = 'italic 500 28px "Cormorant Garamond", Georgia, serif';
    var taglineText = d.cardTagline.replace(/\.\s*$/, '');
    var taglineLines = wrapLines(ctx, taglineText, W - 220);
    for (var tl = 0; tl < taglineLines.length; tl++) {
      ctx.fillText(taglineLines[tl], cx, y);
      if (tl < taglineLines.length - 1) y += TAGLINE_LINE_H;
    }

    /* Ornament between tagline and pull quote. */
    y += GAP_TAGLINE_TO_ORNAMENT;
    drawOrnament(ctx, cx, y);
    y += GAP_ORNAMENT_TO_QUOTE;

    /* Pull quote — italic gold-pale, wrapped in curly quotes.
       Fixed offset below the ornament (no longer dynamically centered
       against the footer): with the v15 upper-spacing tighten, the
       quote now sits naturally above the pinned footer with room to
       breathe, and a fixed offset keeps it visually anchored to the
       ornament instead of floating in the middle of the empty space. */
    ctx.fillStyle = '#e8c674';
    ctx.font = 'italic 500 26px "Cormorant Garamond", Georgia, serif';
    var quoteText = '“' + d.pull.replace(/^[“”"']+|[“”"']+$/g, '') + '”';
    var quoteLines = wrapLines(ctx, quoteText, W - 240);
    for (var q = 0; q < quoteLines.length; q++) {
      ctx.fillText(quoteLines[q], cx, y);
      if (q < quoteLines.length - 1) y += QUOTE_LINE_H;
    }

    /* Footer is always pinned to the same canvas-relative position.
       Pull-quote variable length doesn't move it. Worst-case (4-line
       quote) leaves about 16px between the last quote line and the
       footer — tight but still visually separated. */
    ctx.fillStyle = '#efe6d2';
    ctx.font = '600 17px Cinzel, Georgia, serif';
    drawSpaced(ctx, 'TAKE THE QUIZ TO FIND HIS', cx, FOOTER_HEADING_Y, 4);
    ctx.fillStyle = '#aa9f86';
    ctx.font = '400 15px "SF Mono", "Roboto Mono", Consolas, monospace';
    ctx.fillText('framedfantasy.com/fathersday', cx, FOOTER_URL_Y);
  }
  /* Small 4-point gold ornament. Heraldic, fantasy-rune feel without
     turning the card into a D&D logo. Two perpendicular slim diamonds
     plus a center dot. */
  function drawOrnament(ctx, cx, cy) {
    ctx.save();
    ctx.fillStyle = '#c9a84c';
    ctx.strokeStyle = 'rgba(201, 168, 76, 0.6)';
    ctx.lineWidth = 1;
    var r = 9;
    var rl = 14; /* longer arm */
    /* Vertical diamond */
    ctx.beginPath();
    ctx.moveTo(cx, cy - rl);
    ctx.lineTo(cx + r * 0.55, cy);
    ctx.lineTo(cx, cy + rl);
    ctx.lineTo(cx - r * 0.55, cy);
    ctx.closePath();
    ctx.fill();
    /* Horizontal thin line */
    ctx.beginPath();
    ctx.moveTo(cx - 38, cy);
    ctx.lineTo(cx - 18, cy);
    ctx.moveTo(cx + 18, cy);
    ctx.lineTo(cx + 38, cy);
    ctx.stroke();
    /* Center dot */
    ctx.beginPath();
    ctx.arc(cx, cy, 2.2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
  function updateCardPreview() {
    var img = document.getElementById('ffg-card-img');
    if (!img) return;
    try {
      renderCardCanvas(function (canvas) {
        try { img.src = canvas.toDataURL('image/png'); } catch (e) {}
      });
    } catch (e) {}
  }
  function cardFilename() {
    var a = ARCH[state.archetype] || ARCH.noble_knight;
    return 'framedfantasy-' + a.name.toLowerCase().replace(/[^a-z]+/g, '-') + '-' + state.cardAspect + '.png';
  }
  function _downloadCardBlob(blob) {
    if (!blob) return;
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = cardFilename();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }
  /* v25 invitation PNG. Draws the invitation she designed to a
     1080x1350 canvas for download. The free version always shows the
     locked panel and no code, so the downloaded artifact reads as an
     invitation missing his part, not a finished gift. An uploaded
     scene photo is used for the art band when present (Jan's art is
     the final look), otherwise a themed gradient. The code-bearing
     finished version is rendered after purchase in the paste-to-unlock
     step (next slice). Async because the photo loads cross-origin. */
  function renderInvitationCanvas(callback) {
    var W = 1080, cx = W / 2;
    var themeKey = state.cardTheme || defaultThemeForHobby();
    var artUrl = inviteArtUrl(themeKey);
    var sz = selectedSize();
    /* v37.8 the portrait side's image for the download (selected size, or the
       first size as the default shown before any pick). */
    var portraitUrl = sizePortraitUrl(currentPortraitSize());
    var character = state.giftRoute !== 'portrait';
    var themeGrad = {
      tavern: ['#4a3415', '#160d05'], arcane: ['#2c1f52', '#0a0714'],
      wilds: ['#16331f', '#060f09'], hall: ['#1c2c5a', '#070b18'],
      ember: ['#4a1a20', '#140507'], love: ['#3a1f44', '#140a18']
    }[themeKey] || ['#20264d', '#080a18'];
    var ABH = 372;
    var AB = { x: 80, y: 140, w: W - 160, h: ABH, r: 16 };

    /* v36.7 the claim block content, matching the on-screen card: a gift line,
       an eyebrow, and three steps. No code or disclaimer (the code is delivered
       to her separately). */
    /* v37.6 (Change 4) mirror the editable character value from the live card
       so the downloaded PNG carries his character's name when she set one. */
    var subject = character ? cardCharacterValue() : 'you as the hero';
    var giftLine = sz
      ? 'Your gift is a hand painted ' + sz.name + ' portrait of ' + subject + '.'
      : 'Your gift is a hand painted portrait of ' + subject + '.';
    /* v37.4 Jan: "Here is how to bring it to life." on its own line. */
    var bringLine = 'Here is how to bring it to life.';
    var claimSteps = [
      'Go to FramedFantasy.com/Gift.',
      (character ? 'Take the character quest and download your blueprint.' : 'Send your best photo so I have your likeness.'),
      'Check out with your code. I reach out, and about two weeks later you review your finished portrait.'
    ];

    /* Draw (or, when draw=false, only measure) the claim block content inside a
       box at [boxX, topY, boxW]. Returns the box height. Fonts are set in both
       modes so wrapLines wraps identically. */
    function renderClaim(ctx, boxX, boxW, topY, draw) {
      var pad = 30, innerW = boxW - 80, y = topY + pad;
      ctx.textAlign = 'center';
      /* v36.9 gold eyebrow on top, then the white subtext, then the steps. */
      if (draw) ctx.fillStyle = '#c9a84c';
      ctx.font = '700 21px Cinzel, Georgia, serif';
      if (draw) drawSpaced(ctx, 'HOW TO CLAIM YOUR PORTRAIT', cx, y, 5);
      y += 34;
      if (draw) ctx.fillStyle = '#efe6d2';
      ctx.font = 'italic 500 29px "Cormorant Garamond", Georgia, serif';
      var giftLines = wrapLines(ctx, giftLine, innerW);
      for (var gi = 0; gi < giftLines.length; gi++) { if (draw) ctx.fillText(giftLines[gi], cx, y); y += 37; }
      var bringLines = wrapLines(ctx, bringLine, innerW);
      for (var bi = 0; bi < bringLines.length; bi++) { if (draw) ctx.fillText(bringLines[bi], cx, y); y += 37; }
      y += 10;
      ctx.textAlign = 'left';
      var stepX = boxX + 46, textX = stepX + 40;
      for (var s = 0; s < claimSteps.length; s++) {
        ctx.font = '400 25px "Cormorant Garamond", Georgia, serif';
        var lines = wrapLines(ctx, claimSteps[s], boxW - (textX - boxX) - 30);
        if (draw) {
          var ccx = stepX, ccy = y - 9;
          ctx.beginPath(); ctx.arc(ccx, ccy, 15, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(201,168,76,0.6)'; ctx.lineWidth = 1.4; ctx.stroke();
          ctx.fillStyle = '#c9a84c'; ctx.font = '600 19px Cinzel, Georgia, serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(String(s + 1), ccx, ccy + 1);
          ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'left';
          ctx.fillStyle = '#cdbfa3'; ctx.font = '400 25px "Cormorant Garamond", Georgia, serif';
        }
        for (var j = 0; j < lines.length; j++) { if (draw) ctx.fillText(lines[j], textX, y); y += 32; }
        y += 11;
      }
      y += 2;
      return (y - topY); /* box bottom sits ~pad below the last step */
    }

    /* Draw (or measure) the whole flowing card below the band. Returns final y. */
    function layoutText(ctx, draw) {
      if (draw) {
        ctx.textAlign = 'center';
        ctx.fillStyle = '#c2b79f'; ctx.font = '600 26px Cinzel, Georgia, serif';
        drawSpaced(ctx, (((state.cardStamp && state.cardStamp.trim()) ? state.cardStamp : occasionStamp()) || '').toUpperCase(), cx, 88, 6);
        ctx.strokeStyle = 'rgba(201,168,76,0.18)'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(150, 120); ctx.lineTo(W - 150, 120); ctx.stroke();
      }
      ctx.textAlign = 'center';
      var y = AB.y + AB.h + 86;
      ctx.font = '900 52px Cinzel, Georgia, serif';
      if (draw) ctx.fillStyle = '#f4d68a';
      var greetVal = (state.cardGreeting && state.cardGreeting.trim()) ? state.cardGreeting : inviteGreeting();
      var greetLines = wrapLines(ctx, greetVal, W - 160);
      for (var g = 0; g < greetLines.length; g++) { if (draw) ctx.fillText(greetLines[g], cx, y); y += 60; }
      y += 8;
      ctx.font = 'italic 500 36px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#efe6d2';
      var summonsVal = (state.cardSummons && state.cardSummons.trim()) ? state.cardSummons : routeCopy().summons;
      var summonsLines = wrapLines(ctx, summonsVal, W - 200);
      for (var sg = 0; sg < summonsLines.length; sg++) { if (draw) ctx.fillText(summonsLines[sg], cx, y); y += 42; }
      y += 22;
      if (draw) { ctx.strokeStyle = 'rgba(201,168,76,0.22)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(170, y); ctx.lineTo(W - 170, y); ctx.stroke(); }
      y += 54;
      ctx.font = 'italic 500 38px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#efe6d2';
      var msgParas = (state.cardMessage || '').trim().split('\n');
      var msgLines = [];
      for (var mp = 0; mp < msgParas.length; mp++) {
        var seg = msgParas[mp].replace(/^\s+|\s+$/g, '');
        if (!seg) { msgLines.push(''); continue; }
        msgLines = msgLines.concat(wrapLines(ctx, seg, W - 230));
      }
      for (var i = 0; i < msgLines.length; i++) { if (draw) ctx.fillText(msgLines[i], cx, y); y += 48; }
      y += 8;
      if (draw) { ctx.strokeStyle = 'rgba(201,168,76,0.22)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(170, y); ctx.lineTo(W - 170, y); ctx.stroke(); }
      y += 56;
      ctx.font = 'italic 600 32px "Cormorant Garamond", Georgia, serif';
      if (draw) ctx.fillStyle = '#c2b79f';
      var signoffVal = (state.cardSignoff && state.cardSignoff.trim()) ? state.cardSignoff : inviteSignoff();
      if (draw) ctx.fillText(signoffVal, cx, y);
      y += 44 + 28;
      var boxX = 120, boxW = W - 240;
      var boxH = renderClaim(ctx, boxX, boxW, y, false);
      if (draw) {
        ctx.save();
        ctx.fillStyle = 'rgba(201,168,76,0.05)';
        roundRectPath(ctx, boxX, y, boxW, boxH, 16); ctx.fill();
        ctx.strokeStyle = 'rgba(201,168,76,0.45)'; ctx.lineWidth = 1.5;
        roundRectPath(ctx, boxX, y, boxW, boxH, 16); ctx.stroke();
        ctx.restore();
        renderClaim(ctx, boxX, boxW, y, true);
      }
      y += boxH;
      return y;
    }

    /* Draw the art band (clip + theme gradient + photo/scene fill + frame), no
       text. Shared by the single- and double-sided paths. */
    function drawBandInner(ctx, img, isPhoto) {
      ctx.save();
      roundRectPath(ctx, AB.x, AB.y, AB.w, AB.h, AB.r); ctx.clip();
      var grd = ctx.createLinearGradient(AB.x, AB.y, AB.x, AB.y + AB.h);
      grd.addColorStop(0, themeGrad[0]); grd.addColorStop(1, themeGrad[1]);
      ctx.fillStyle = grd; ctx.fillRect(AB.x, AB.y, AB.w, AB.h);
      if (img && isPhoto) {
        var s = Math.max(AB.w / img.width, AB.h / img.height);
        var dw = img.width * s, dh = img.height * s;
        ctx.drawImage(img, AB.x + (AB.w - dw) / 2, AB.y + (AB.h - dh) / 2, dw, dh);
      } else if (img) {
        ctx.drawImage(img, AB.x, AB.y, AB.w, AB.h);
      }
      ctx.restore();
      ctx.strokeStyle = 'rgba(201,168,76,0.5)'; ctx.lineWidth = 1.5;
      roundRectPath(ctx, AB.x, AB.y, AB.w, AB.h, AB.r); ctx.stroke();
    }
    /* Draw the whole message card (background + band + flowing text) at vertical
       offset offY, loading the art (or scene fallback) first, then call done. */
    function drawMessageCard(ctx, H, offY, done) {
      ctx.save(); ctx.translate(0, offY);
      drawCardBackground(ctx, W, H);
      function finish(artImg, isPhoto) {
        drawBandInner(ctx, artImg, isPhoto);
        layoutText(ctx, true);
        ctx.restore();
        done();
      }
      function scene() {
        var sv = new Image();
        sv.onload = function () { finish(sv, false); };
        sv.onerror = function () { finish(null, false); };
        sv.src = inviteSceneDataUrl(themeKey);
      }
      if (artUrl) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { finish(im, true); };
        im.onerror = scene;
        im.src = artUrl;
      } else { scene(); }
    }
    /* Portrait side: full-bleed cover image (top anchor so the face stays in),
       bottom scrim, the sample label (kept in the download per decision 3), and
       the gold name near the bottom. No flip icon or tap hint (those are DOM
       affordances, never drawn here). */
    function drawPortraitRegion(ctx, img, x, y, w, h) {
      ctx.save();
      roundRectPath(ctx, x, y, w, h, 16); ctx.clip();
      ctx.fillStyle = '#0a0a12'; ctx.fillRect(x, y, w, h);
      if (img) {
        var s = Math.max(w / img.width, h / img.height);
        var dw = img.width * s, dh = img.height * s;
        ctx.drawImage(img, x + (w - dw) / 2, y, dw, dh); /* top-center anchor */
      }
      var sg = ctx.createLinearGradient(x, y + h, x, y + h * 0.54);
      sg.addColorStop(0, 'rgba(8,8,14,0.92)'); sg.addColorStop(1, 'rgba(8,8,14,0)');
      ctx.fillStyle = sg; ctx.fillRect(x, y + h * 0.54, w, h * 0.46);
      ctx.restore();
      ctx.strokeStyle = 'rgba(201,168,76,0.5)'; ctx.lineWidth = 1.5;
      roundRectPath(ctx, x, y, w, h, 16); ctx.stroke();
      ctx.textAlign = 'center';
      ctx.fillStyle = 'rgba(239,230,210,0.75)';
      ctx.font = 'italic 400 22px "Cormorant Garamond", Georgia, serif';
      ctx.fillText('example art, painted from your own description', x + w / 2, y + 40);
      var name = portraitDisplayName();
      if (name) {
        ctx.fillStyle = '#f4d68a';
        ctx.font = '700 56px Cinzel, Georgia, serif';
        ctx.fillText(name, x + w / 2, y + h - h * 0.09);
      }
    }
    function build() {
      var canvas = document.createElement('canvas');
      canvas.width = W; canvas.height = 10;
      var mctx = canvas.getContext('2d');
      if (!mctx) { callback(null); return; }
      var finalY = layoutText(mctx, false);
      var H = Math.ceil(finalY + 56);
      /* Message-only fallback (existing behavior) if the portrait can't load. */
      function buildSingle() {
        canvas.height = H;
        var ctx = canvas.getContext('2d');
        drawMessageCard(ctx, H, 0, function () { callback(canvas); });
      }
      /* Two sides stacked: portrait on top, message below, each at card height. */
      function buildDouble(pimg) {
        canvas.height = H + H;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#08080e'; ctx.fillRect(0, 0, W, canvas.height);
        drawPortraitRegion(ctx, pimg, 0, 0, W, H);
        drawMessageCard(ctx, H, H, function () { callback(canvas); });
      }
      /* v38.5 the download is the CARD only (the message side). Per Jan, the
         portrait/example-art side is no longer stacked into the PNG. buildDouble
         is kept for reference but no longer called. */
      buildSingle();
    }
    build();
  }
  function inviteFilename() {
    var nm = (state.hisName || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return 'framedfantasy-card' + (nm ? '-' + nm : '') + '.png';
  }
  function downloadInvitation() {
    try {
      fbTrack('invitation_download', { content_name: 'Gift Quiz Evergreen' });
      gaTrack('invitation_download', {});
    } catch (e) {}
    try {
      withFonts(function () {
        renderInvitationCanvas(function (canvas) {
          if (!canvas) return;
          try {
            canvas.toBlob(function (blob) {
              if (!blob) return;
              var url = URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url; a.download = inviteFilename();
              document.body.appendChild(a); a.click(); document.body.removeChild(a);
              setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
            }, 'image/png');
          } catch (e) {}
        });
      });
    } catch (e) {}
  }
  function saveCard() {
    /* Reverted to single-page render (the two-page version with
       answers + commission CTA was rolled back per Jan's request).
       Both saveCard and shareCard now use the same 1080×1350 canvas. */
    try {
      renderCardCanvas(function (canvas) {
        try {
          canvas.toBlob(function (blob) { _downloadCardBlob(blob); }, 'image/png');
          fireCardEvent('save');
        } catch (e) {}
      });
    } catch (e) {}
  }
  function shareCard() {
    try {
      renderCardCanvas(function (canvas) {
        try {
          canvas.toBlob(function (blob) {
            if (!blob) { saveCard(); return; }
            var file = new File([blob], cardFilename(), { type: 'image/png' });
            if (navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
              navigator.share({ files: [file], title: 'My FramedFantasy result' }).catch(function () {});
            } else {
              _downloadCardBlob(blob);
            }
          }, 'image/png');
          fireCardEvent('share');
        } catch (e) {}
      });
    } catch (e) {}
  }
  function fireCardEvent(kind) {
    /* Keep the legacy ShareableCardDownload event name for continuity
       with the prior pixel rules, and fire the v18 card_download
       event alongside it. */
    fbTrack('ShareableCardDownload', {
      content_name: 'Gift Quiz Evergreen',
      archetype: (ARCH[state.archetype] || {}).name || '',
      format: state.cardAspect,
      method: kind
    });
    gaTrack('shareable_card_download', { format: state.cardAspect, method: kind });
    fbTrack('card_download', {
      content_name: 'Gift Quiz Evergreen',
      archetype: (ARCH[state.archetype] || {}).name || '',
      method: kind
    });
    gaTrack('card_download', {
      archetype: state.archetype,
      method: kind
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function pickHeadline() {
    /* A/B retired. Always serve variant A. The function and the
       state.headlineVariant field are kept so analytics still tag the
       headline name in case the test is ever revived. */
    return 'A';
  }
  /* Clear saved progress and send her back to the intro, a fresh run. */
  function resetQuiz() {
    clearSaved();
    clearBreathTimer();
    tracked = {};
    preloaded = false;
    qImgPreloaded = false;
    state.step = 0;
    state.recipient = '';
    state.stance = '';
    state.email = '';
    state.branch = 'Standard';
    state.answers = [null, null, null, null, null, null];
    state.archetype = '';
    state.scores = {};
    state.firstName = '';
    state.phone = '';
    state.country = 'US';
    state.hisName = '';
    state.fromName = '';
    /* Gift link: a new card must create its own row, never attach to the previous one. */
    state.publicId = null;
    state.previewKey = null;
    state.cardAspect = '4x5';
    state.cardMessage = '';
    state.cardGreeting = '';
    state.cardSummons = '';
    state.cardSignoff = '';
    state.characterName = '';
    state.cardCharacter = '';
    state.stepsSeen = false;
    state.presentPromptSeen = false;
    state.sizeKey = '';
    state.cardMsgPreset = '';
    state.cardTheme = '';
    state.giftRoute = '';
    state.unlockCode = '';
    state.notesText = "";
    state.headlineVariant = pickHeadline();
    state.breathShown = { hinge: false };
    state.timing = '';
    goToIntro(false);
  }
  function start() {
    buildShell();
    goToIntro(true);
  }
  function resume(saved) {
    state.recipient = saved.recipient || '';
    state.recipientText = saved.recipientText || '';
    state.cardBuilt = !!saved.cardBuilt;
    state.gateAck = !!saved.gateAck;
    state.occasion = saved.occasion || '';
    state.occasionDetail = saved.occasionDetail || '';
    state.occasionText = saved.occasionText || '';
    state.theDetail = saved.theDetail || '';
    state.detailIdx = saved.detailIdx || 0;
    state.detailAngle = saved.detailAngle || '';
    state.aiMessage = saved.aiMessage || '';
    state.stance = saved.stance || '';
    state.email = saved.email || '';
    state.phone = saved.phone || '';
    state.branch = saved.branch || 'Standard';
    state.timing = saved.timing || '';
    /* v23 builder fields restored so a refresh inside the builder keeps
       her name, message, and theme picks. */
    state.hisName = saved.hisName || '';
    state.fromName = saved.fromName || '';
    state.cardMessage = saved.cardMessage || '';
    state.cardGreeting = saved.cardGreeting || '';
    state.cardStamp = saved.cardStamp || '';
    state.cardSummons = saved.cardSummons || '';
    state.summonsIdx = saved.summonsIdx || 0;
    state.cardSignoff = saved.cardSignoff || '';
    state.characterName = saved.characterName || '';
    state.cardCharacter = saved.cardCharacter || '';
    state.stepsSeen = !!saved.stepsSeen;
    state.presentPromptSeen = !!saved.presentPromptSeen;
    state.sizeKey = saved.sizeKey || '';
    state.cardMsgPreset = saved.cardMsgPreset || '';
    state.cardTheme = saved.cardTheme || '';
    state.unlockCode = saved.unlockCode || '';
    state.notesText = saved.notesText || "";
    state.answers = (saved.answers && saved.answers.length === QUESTIONS.length) ? saved.answers : new Array(QUESTIONS.length);
    buildShell();
    if (saved.view === 'quiz' && !state.cardBuilt) {
      state.view = 'quiz';
      state.step = Math.min(saved.step || 0, QUESTIONS.length - 1);
      preloadQuestionImages();
      paintQuestion(true);
      return;
    }
    /* v24: once the four questions are done, the only end screen is the
       builder. Resume there whether she refreshed on it or had finished
       the quiz. Route and card seed are recomputed from her saved
       answers. */
    if (answersComplete()) {
      state.giftRoute = saved.giftRoute || '';
      computeRoute();
      seedCardFromAnswers();
      renderBuilder();
      return;
    }
    goToIntro(true);
  }
  /* ============================================================
     GIFT LINK CARD VIEW
     Renders a SAVED card on the gift-card page from the gift-cards Worker.
     No quiz runs here. It reuses the existing shell (paint), the card
     renderer, and the reveal (openPresent), so the visuals and the unboxing
     are identical to the builder. Only runs when IS_CARD_VIEW is true, so the
     buyer flow above is never affected.
     ============================================================ */
  function cvParam(name) {
    try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; }
  }
  function cvBase() { return (CARD_BASE || '').replace(/\/+$/, ''); }
  function cvShell() {
    /* a stripped shell: just the stage + screen so paint() works. No quiz topbar. */
    root.innerHTML = '<div class="ffg-app ffg-app--card"><div class="ffg-stage"><div class="ffg-screen" id="ffg-screen"></div></div></div>';
  }
  function cvMessage(title, body) {
    paint('<div class="ffg-cv-msg">' +
        '<p class="ffg-cv-msg__title">' + esc(title) + '</p>' +
        (body ? '<p class="ffg-cv-msg__body">' + esc(body) + '</p>' : '') +
      '</div>', true);
  }
  function mapStateFromCard(card) {
    if (!card || typeof card !== 'object') return;
    for (var k in card) {
      if (Object.prototype.hasOwnProperty.call(card, k)) state[k] = card[k];
    }
  }
  function bootCardView() {
    cvShell();
    var publicId = cvParam('c');
    var key = cvParam('k');
    state.publicId = publicId || null;
    state.previewKey = key || null;
    if (!publicId || !cvBase()) {
      cvMessage('We could not load this card.', 'Please refresh, or contact Jan at Jan@framedfantasy.com.');
      return;
    }
    cvMessage('Opening your card', '');
    var url = cvBase() + '/cards/' + encodeURIComponent(publicId) +
      '?' + (key ? 'k=' + encodeURIComponent(key) + '&' : '') +
      'ua=' + encodeURIComponent(navigator.userAgent || '');
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : { status: 'error' }; })
      .then(function (data) { cvRender(data || { status: 'error' }); })
      .catch(function () { cvRender({ status: 'error' }); });
  }
  function cvRender(data) {
    var status = data && data.status;
    if (status === 'preview') { mapStateFromCard(data.card); cvRenderPreview(); }
    else if (status === 'paid' || status === 'redeemed') {
      mapStateFromCard(data.card);
      /* The buyer reaches their own paid card with the preview key in the URL, so show
         the success and send screen. The recipient's emailed link has no key, so show
         the unboxing. The key is the buyer's private preview key, never shared. */
      if (cvParam('k')) cvRenderSuccess(); else cvRenderRecipient();
    }
    else if (status === 'processing' || status === 'locked') {
      cvMessage('This gift is not ready yet.', 'Give it a moment, then refresh.');
    } else if (status === 'void' || status === 'expired') {
      cvMessage('This gift link is no longer active.', 'Contact Jan at Jan@framedfantasy.com.');
    } else {
      cvMessage('We could not load this card.', 'Please refresh, or contact Jan at Jan@framedfantasy.com.');
    }
  }
  function cvOpenBind() {
    var b = document.getElementById('ffg-cv-open');
    if (b) b.addEventListener('click', function () { openPresent(); });
  }
  function cvRenderPreview() {
    PRESENT_MODE = 'preview'; /* buyer previewing their own card, links to /gift, unchanged */
    paint('<div class="ffg-cv ffg-cv--preview">' +
        '<div class="ffg-cv__banner">Private preview. Only you can see this. Check out, and your card goes live to send.</div>' +
        '<div class="ffg-cv__sealed">' +
          '<p class="ffg-cv__title">This is the card they\'ll open.</p>' +
          '<button type="button" class="ffg-cv__tap" id="ffg-cv-open">Preview their opening experience</button>' +
        '</div>' +
      '</div>', true, cvOpenBind);
  }
  function cvRenderRecipient() {
    PRESENT_MODE = 'recipient'; /* paid link, the claim panel reveals the real code */
    paint('<div class="ffg-cv ffg-cv--gift">' +
        '<div class="ffg-cv__sealed">' +
          '<p class="ffg-cv__title">Someone made you something.</p>' +
          '<button type="button" class="ffg-cv__tap" id="ffg-cv-open">Tap to open</button>' +
        '</div>' +
      '</div>', true, cvOpenBind);
  }
  var cvClaiming = false;
  function doRecipientClaim() {
    if (cvClaiming || !state.publicId || !cvBase()) return;
    var panel = document.getElementById('ffg-cv-claim');
    var btn = document.getElementById('ffg-cv-claim-btn');
    cvClaiming = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Getting your code...'; }
    fetch(cvBase() + '/cards/' + encodeURIComponent(state.publicId) + '/reveal', {
      method: 'POST', headers: { 'content-type': 'application/json' }, body: '{}'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        cvClaiming = false;
        if (!d || !d.code) { cvClaimError(btn); return; }
        if (panel) {
          panel.innerHTML =
            '<p class="ffg-invite__claim-head">Your code is</p>' +
            '<p class="ffg-cv-code">' + esc(d.code) + '</p>' +
            '<a class="ffg-present__cta ffg-cv-claim__btn" href="' + esc(d.redeemUrl || '/pages/dnd-character-quest') + '">Start my quest <span class="ffg-present__cta-arrow" aria-hidden="true">&rarr;</span></a>' +
            '<p class="ffg-cv-code__note">Your portrait is already paid for. The code is applied for you.</p>';
        }
      })
      .catch(function () { cvClaiming = false; cvClaimError(btn); });
  }
  function cvClaimError(btn) {
    if (btn) { btn.disabled = false; btn.textContent = 'Tap again to get your code'; }
  }

  /* ---------- the buyer success and send screen (paid card opened with the key) ---------- */
  function cvLiveLink() {
    return location.origin + CARD_PAGE_PATH + '?c=' + encodeURIComponent(state.publicId || cvParam('c') || '');
  }
  function cvRenderSuccess() {
    var link = cvLiveLink();
    paint('<div class="ffg-cv ffg-cv--success">' +
        '<p class="ffg-cv__title">Your gift is ready. How do you want to send it?</p>' +
        '<div class="ffg-cv-send">' +
          '<div class="ffg-cv-send__opt">' +
            '<h3 class="ffg-cv-send__h">Email it to them</h3>' +
            '<input type="text" id="ffg-cv-rname" class="ffg-cv-input" placeholder="Their first name" autocomplete="off">' +
            '<input type="email" id="ffg-cv-remail" class="ffg-cv-input" placeholder="Their email" autocomplete="off">' +
            '<input type="date" id="ffg-cv-rdate" class="ffg-cv-input" aria-label="Send date, optional">' +
            '<button type="button" class="ffg-cv__tap" id="ffg-cv-send-btn">Email it to them</button>' +
            '<p class="ffg-cv-send__confirm" id="ffg-cv-send-confirm" hidden></p>' +
          '</div>' +
          '<div class="ffg-cv-send__opt">' +
            '<h3 class="ffg-cv-send__h">Send it yourself</h3>' +
            '<input type="text" id="ffg-cv-link" class="ffg-cv-input" readonly value="' + esc(link) + '">' +
            '<div class="ffg-cv-share">' +
              '<button type="button" class="ffg-cv-share__btn" id="ffg-cv-copy">Copy link</button>' +
              '<a class="ffg-cv-share__btn" id="ffg-cv-sms" href="sms:?&body=' + encodeURIComponent('A gift for you. ' + link) + '">Text it</a>' +
              '<a class="ffg-cv-share__btn" id="ffg-cv-mail" href="mailto:?subject=' + encodeURIComponent('A gift for you') + '&body=' + encodeURIComponent('Open your card here: ' + link) + '">Email it</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<p class="ffg-cv-send__note">We also emailed this link to you, so it is safe if you close this page.</p>' +
        '<div class="ffg-cv-next">' +
          '<p class="ffg-cv-next__h">What happens next for them</p>' +
          '<ol class="ffg-cv-claim__steps">' +
            '<li>They open the link and see their card.</li>' +
            '<li>They answer a few quick questions about their character.</li>' +
            '<li>About two weeks later their hand painted portrait is ready.</li>' +
          '</ol>' +
        '</div>' +
      '</div>', true, cvBindSuccess);
  }
  function cvBindSuccess() {
    var copy = document.getElementById('ffg-cv-copy');
    if (copy) copy.addEventListener('click', function () {
      var inp = document.getElementById('ffg-cv-link');
      var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy link'; }, 1800); };
      try { navigator.clipboard.writeText(inp.value).then(done, function () { try { inp.select(); document.execCommand('copy'); done(); } catch (e) {} }); }
      catch (e) { try { inp.select(); document.execCommand('copy'); done(); } catch (e2) {} }
    });
    var send = document.getElementById('ffg-cv-send-btn');
    if (send) send.addEventListener('click', cvDeliver);
  }
  var cvSending = false;
  function cvDeliver() {
    if (cvSending) return;
    var nameEl = document.getElementById('ffg-cv-rname');
    var emailEl = document.getElementById('ffg-cv-remail');
    var dateEl = document.getElementById('ffg-cv-rdate');
    var confirmEl = document.getElementById('ffg-cv-send-confirm');
    var btn = document.getElementById('ffg-cv-send-btn');
    var name = (nameEl && nameEl.value) || '';
    var email = (emailEl && emailEl.value) || '';
    var dateStr = (dateEl && dateEl.value) || '';
    function showMsg(t) { if (confirmEl) { confirmEl.hidden = false; confirmEl.textContent = t; } }
    if (!/.+@.+\..+/.test(email)) { showMsg('Please enter a valid email.'); return; }
    var publicId = state.publicId || cvParam('c');
    if (!publicId || !cvBase()) return;
    cvSending = true; if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
    var payload = { recipient_email: email, recipient_name: name };
    if (dateStr) {
      var d = new Date(dateStr + 'T09:00');
      if (!isNaN(d.getTime()) && d > new Date()) {
        payload.scheduled_send_at = d.toISOString();
        try { payload.send_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) {}
      }
    }
    fetch(cvBase() + '/cards/' + encodeURIComponent(publicId) + '/deliver', {
      method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(payload)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        cvSending = false; if (btn) { btn.disabled = false; btn.textContent = 'Email it to them'; }
        if (!res || res.ok === false) { showMsg('We could not send it. Copy the link and send it yourself.'); return; }
        showMsg(payload.scheduled_send_at ? ('We will send it on ' + dateStr + '.') : 'We will send it now.');
      })
      .catch(function () {
        cvSending = false; if (btn) { btn.disabled = false; btn.textContent = 'Email it to them'; }
        showMsg('We could not send it. Copy the link and send it yourself.');
      });
  }

  function init() {
    var saved = loadSaved();
    state.headlineVariant = (saved && saved.headlineVariant) || pickHeadline();
    if (saved && (saved.recipient || (saved.answers && saved.answers.some && saved.answers.some(function (x) { return x != null; })))) {
      resume(saved);
      return;
    }
    start();
  }

  /* ---------- Shopify theme editor support ----------
     The editor does not reload the page when a merchant changes a
     section setting. It re renders the section markup in place and
     does not re run this file. So re read the fresh config block and
     rebuild the quiz on every section reload, that way the editor
     preview always matches the image and text settings just saved. */
  function readConfigFromDom() {
    try {
      var el = document.getElementById('ffg-config');
      if (!el) return;
      CONFIG = JSON.parse(el.textContent);
      CONFIG_OK = true;
    } catch (e) { CONFIG_OK = false; return; }
    IMG = CONFIG.images || {};
    Q_IMAGES = CONFIG.questionImages || {};
    GALLERY = computeGallery();
    TRUST = CONFIG.trust || {};
    INTRO_PROOF = CONFIG.introProof || 'I am Jan. My team and I have painted over 1,000 of these by hand since 2022. More than 500 five star reviews.';
    FD_CUTOFF = CONFIG.fathersDayCutoff || '2026-06-07';
    KL = CONFIG.klaviyo || {};
    KL_COMPANY = KL.companyId || 'UeMxA4';
    KL_LIST = KL.listId || 'W8Unvq';
    KL_REVISION = KL.revision || '2025-10-15';
    PRODUCT_URL = CONFIG.productUrl || '/products/fathers-day-portrait-from-photo';
    BREATH = mergeBreathConfig(CONFIG.breath);
    EYEBROW_LABEL = CONFIG.eyebrowLabel || 'FATHER\'S DAY 2026';
  }
  function rebootForEditor() {
    var fresh = document.getElementById('ffg-root');
    if (!fresh) return;
    root = fresh;
    if (fresh.getAttribute('data-card-view') !== null) {
      CARD_BASE = fresh.getAttribute('data-card-base') || CARD_BASE;
      bootCardView();
      return;
    }
    readConfigFromDom();
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e && e.target;
    if (t && (t.id === 'ffg-root' || (t.querySelector && t.querySelector('#ffg-root')))) {
      rebootForEditor();
    }
  });

  function bootApp() {
    if (IS_CARD_VIEW) { bootCardView(); return; }
    init();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootApp);
  } else {
    bootApp();
  }
})();
